import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AcmePlayerData: { input: any; output: any; }
  Decimal: { input: any; output: any; }
  ISO8601Date: { input: any; output: any; }
  ISO8601DateTime: { input: any; output: any; }
  PlayerData: { input: any; output: any; }
  SubscriptionMetadata: { input: any; output: any; }
  URL: { input: any; output: any; }
};

export type AcmeLanguage = {
  __typename?: 'AcmeLanguage';
  /** The name of the language as written and reffered to by its community. */
  endonym?: Maybe<Scalars['String']['output']>;
  /** The name of the language as written in English. */
  englishName?: Maybe<Scalars['String']['output']>;
  /** A string identifying the language assigned by the Internet Assigned Numbers Authority. */
  ianaSubtag?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** A short code used to identify the language by TED. */
  internalLanguageCode?: Maybe<Scalars['String']['output']>;
  /** A boolean indicating whether the language is written right to left. */
  isRtl?: Maybe<Scalars['Boolean']['output']>;
  /** A two letter lowercase abbreviation assigned by ISO. */
  iso6391?: Maybe<Scalars['String']['output']>;
  /** A three letter lowercase abbreviation assigned by ISO. */
  iso6393?: Maybe<Scalars['String']['output']>;
  rtl: Scalars['Boolean']['output'];
  /** Number of subtitle collections using this language */
  subtitleCollectionCount: Scalars['Int']['output'];
};

/** The connection type for AcmeLanguage. */
export type AcmeLanguageConnection = {
  __typename?: 'AcmeLanguageConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AcmeLanguageEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<AcmeLanguage>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type AcmeLanguageEdge = {
  __typename?: 'AcmeLanguageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<AcmeLanguage>;
};

export type AcmeSpeaker = {
  __typename?: 'AcmeSpeaker';
  /** A short bit of plaintext, telling who said "what others say" */
  cite?: Maybe<Scalars['String']['output']>;
  /** A short (max 500) plain-text description of the speaker. About half are blank. */
  description?: Maybe<Scalars['String']['output']>;
  /** Speaker's first name. By convention this will be blank for single-name speakers like 'Bono' */
  firstname?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the speaker is currently live to the world. */
  isLive?: Maybe<Scalars['Boolean']['output']>;
  /** Speaker's last name. If the speaker has only one name (like 'Bono') that name will be in this field. */
  lastname?: Maybe<Scalars['String']['output']>;
  /** Short text for the anchor tag */
  linkName1?: Maybe<Scalars['String']['output']>;
  /** Short text for the anchor tag */
  linkName2?: Maybe<Scalars['String']['output']>;
  /** Usually a FQDN, but some lack a protocol. Often blank. */
  linkUrl1?: Maybe<Scalars['String']['output']>;
  /** Same as link_url_1, but more often blank. Some mailto: links! Usually a twitter URL. */
  linkUrl2?: Maybe<Scalars['String']['output']>;
  /** A speaker's middlename, though it's almost always just an initial. Usually blank. */
  middlename?: Maybe<Scalars['String']['output']>;
  /** Link to a photo of the speaker via TED's CDN. */
  photoUrl?: Maybe<Scalars['String']['output']>;
  /** A short human-readable identifier for this speaker. Suitable for building URLs. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The title the speaker holds, often indiciating their affiliation. */
  title?: Maybe<Scalars['String']['output']>;
  /** A short blurb with perspective on the speaker. */
  whatOthersSay?: Maybe<Scalars['String']['output']>;
  /** Usually a short bit of HTML (a few <em> tags) but some are over 2,000 characters. May be blank in some cases. */
  whoTheyAre?: Maybe<Scalars['String']['output']>;
  /** A pile of HTML. Longest is ~5,000 characters. Usually blank. */
  whyListen?: Maybe<Scalars['String']['output']>;
};

/** The connection type for AcmeSpeaker. */
export type AcmeSpeakerConnection = {
  __typename?: 'AcmeSpeakerConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AcmeSpeakerEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<AcmeSpeaker>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type AcmeSpeakerEdge = {
  __typename?: 'AcmeSpeakerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<AcmeSpeaker>;
};

export type Activity = {
  __typename?: 'Activity';
  id: Scalars['ID']['output'];
  itemId?: Maybe<Scalars['Int']['output']>;
  itemType?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  subjectId?: Maybe<Scalars['Int']['output']>;
  subjectType?: Maybe<Scalars['String']['output']>;
  targetId?: Maybe<Scalars['Int']['output']>;
  targetType?: Maybe<Scalars['String']['output']>;
  uri?: Maybe<Scalars['String']['output']>;
};

/** The connection type for Activity. */
export type ActivityConnection = {
  __typename?: 'ActivityConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ActivityEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Activity>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ActivityEdge = {
  __typename?: 'ActivityEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Activity>;
};

/** Autogenerated return type of AddPaymentMethod */
export type AddPaymentMethodPayload = {
  __typename?: 'AddPaymentMethodPayload';
  status: Scalars['String']['output'];
};

/** Autogenerated return type of AddWatchedTalk */
export type AddWatchedTalkPayload = {
  __typename?: 'AddWatchedTalkPayload';
  success: Scalars['Boolean']['output'];
};

export type AspectRatio = {
  __typename?: 'AspectRatio';
  id?: Maybe<Scalars['ID']['output']>;
  /** width:length or a plain language title for the aspect ratio */
  name?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of CancelMembershipEventRegistration. */
export type CancelMembershipEventRegistrationPayload = {
  __typename?: 'CancelMembershipEventRegistrationPayload';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  membershipEvent?: Maybe<MembershipEvent>;
};

/** Autogenerated return type of CancelStripeSupporterSubscription */
export type CancelStripeSupporterSubscriptionPayload = {
  __typename?: 'CancelStripeSupporterSubscriptionPayload';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type Card = {
  __typename?: 'Card';
  brand: Scalars['String']['output'];
  expMonth: Scalars['String']['output'];
  expYear: Scalars['String']['output'];
  last4: Scalars['String']['output'];
};

/** A list of talkstar channels */
export enum ChannelOptions {
  /** All talkstar talks */
  All = 'ALL',
  /** Talkstar talks published to the homepage */
  Featured = 'FEATURED'
}

/** Autogenerated return type of CreateOpenwebUserSession */
export type CreateOpenwebUserSessionPayload = {
  __typename?: 'CreateOpenwebUserSessionPayload';
  codeB?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of CreatePaymentIntentClientSecret */
export type CreatePaymentIntentClientSecretPayload = {
  __typename?: 'CreatePaymentIntentClientSecretPayload';
  clientSecret: Scalars['String']['output'];
  paymentMethodId: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

/** Autogenerated return type of CreateStripeSupporterSubscription */
export type CreateStripeSupporterSubscriptionPayload = {
  __typename?: 'CreateStripeSupporterSubscriptionPayload';
  redemptionToken?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Cue = {
  __typename?: 'Cue';
  endTime: Scalars['Int']['output'];
  startTime: Scalars['Int']['output'];
  text: Scalars['String']['output'];
  time: Scalars['Int']['output'];
};

/** A list of playlist curator types */
export enum CuratorOptions {
  /** Curated by a User */
  Community = 'COMMUNITY',
  /** Curated by TED */
  Editorial = 'EDITORIAL',
  /** Curated by a guest/celebrity */
  Guest = 'GUEST'
}

export type CustomContentDetails = {
  __typename?: 'CustomContentDetails';
  /** When we fake the partner in as a speaker, this is their avatar. */
  partnerAvatarUrl?: Maybe<Scalars['URL']['output']>;
  /** When we fake the partner in as a speaker, this is their 'bio.' */
  partnerDescription?: Maybe<Scalars['String']['output']>;
  /** When we fake the partner in as a speaker, this is their 'name.' */
  partnerName?: Maybe<Scalars['String']['output']>;
};

/** Some extra schmutz that needs to go on the page in some cases. */
export type EventBadge = {
  __typename?: 'EventBadge';
  /** Why a URL, and not an Image? Because don't worry about the sizes, just put it on the page. */
  imageUrl: Scalars['URL']['output'];
  /**
   * If this is present, the image (see imageUrl) should be a hyperlink to this
   * URL. (...Why didn't we make this a URL field?) We're not sold on this name, btw.
   */
  website?: Maybe<Scalars['String']['output']>;
};

/** Statuses a TalkExtra can have */
export enum ExtraStatus {
  /** it's approved */
  Approved = 'APPROVED',
  /** it's a draft */
  Draft = 'DRAFT',
  /** it's expired */
  Expired = 'EXPIRED',
  ReadyForCopyEdit = 'READY_FOR_COPY_EDIT'
}

export type Favorite = {
  __typename?: 'Favorite';
  /** Primitive relational data for objects that have been favorited by a user */
  favoriteable?: Maybe<Favoriteable>;
  /** GraphQL entities that the user has favorited */
  favoriteableEntity?: Maybe<FavoriteableEntity>;
  id: Scalars['ID']['output'];
};

/** The connection type for Favorite. */
export type FavoriteConnection = {
  __typename?: 'FavoriteConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<FavoriteEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Favorite>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type FavoriteEdge = {
  __typename?: 'FavoriteEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Favorite>;
};

export type FavoriteInput = {
  id: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};

export type Favoriteable = {
  __typename?: 'Favoriteable';
  id: Scalars['ID']['output'];
  type: Scalars['String']['output'];
};

/** Objects which may be favorited by a user */
export type FavoriteableEntity = IdentityTalkType | Playlist | TalkTakeaway | User;

export type FavoriteableFilter = {
  id: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};

export type FavoritesFilter = {
  favoriteables?: InputMaybe<Array<FavoriteableFilter>>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type Follow = {
  __typename?: 'Follow';
  id: Scalars['ID']['output'];
  subject?: Maybe<FollowSubject>;
};

/** The connection type for Follow. */
export type FollowConnection = {
  __typename?: 'FollowConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<FollowEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Follow>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type FollowEdge = {
  __typename?: 'FollowEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Follow>;
};

export type FollowSubject = {
  __typename?: 'FollowSubject';
  id: Scalars['ID']['output'];
  type: Scalars['String']['output'];
};

export type FollowSubjectInput = {
  id: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};

export type FollowsFilter = {
  subjects?: InputMaybe<Array<SubjectFilter>>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** A Footnote (citation, correction) from TalkExtras */
export type Footnote = {
  __typename?: 'Footnote';
  /** Probably only on citations, not corrections */
  annotation?: Maybe<Scalars['String']['output']>;
  author?: Maybe<Scalars['String']['output']>;
  /** article, book, note, or video; probably only on citations, not corrections */
  category?: Maybe<Scalars['String']['output']>;
  /** Some date-ish text. Eg: "July 2006", but also eg: "2003", or a URL, or "TK". Don't parse it. Just display it. */
  date?: Maybe<Scalars['String']['output']>;
  isPdf?: Maybe<Scalars['Boolean']['output']>;
  linkUrl?: Maybe<Scalars['URL']['output']>;
  published: Scalars['Boolean']['output'];
  /** The source for the footnote (citation): a journal, report, etc */
  source?: Maybe<Scalars['String']['output']>;
  status: ExtraStatus;
  text?: Maybe<Scalars['String']['output']>;
  /** The minutes:seconds into the video for this footnote. Eg: 01:23 */
  timecode?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export enum GeneratedAvatar {
  Raster = 'RASTER',
  Svg = 'SVG'
}

export type GiftMembership = {
  __typename?: 'GiftMembership';
  createdAt: Scalars['ISO8601DateTime']['output'];
  durationMonths?: Maybe<Scalars['Int']['output']>;
  expiresAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  redeemedAt: Scalars['ISO8601DateTime']['output'];
};

export type IdentityLanguage = {
  __typename?: 'IdentityLanguage';
  code: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type IdentityTalkType = {
  __typename?: 'IdentityTalkType';
  altheadline: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  language: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  talkType: Scalars['String']['output'];
};

export type Industry = {
  __typename?: 'Industry';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** A LearnModule from talk extras. Aka a Learn *more* module, or 'More Resources.' */
export type LearnModule = {
  __typename?: 'LearnModule';
  author?: Maybe<Scalars['String']['output']>;
  blurb?: Maybe<Scalars['String']['output']>;
  eyebrow?: Maybe<Scalars['String']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['URL']['output']>;
  linkUrl?: Maybe<Scalars['URL']['output']>;
  published: Scalars['Boolean']['output'];
  publisher?: Maybe<Scalars['String']['output']>;
  status: ExtraStatus;
  type: LearnModuleTypes;
  /** Not a URL: some text, suitable for a link's text. */
  visibleUrl?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['String']['output']>;
};

/** Types a LearnModule can have */
export enum LearnModuleTypes {
  /** an old partnership */
  BbcRadio4 = 'BBC_RADIO4',
  Book = 'BOOK',
  CompanionFilm = 'COMPANION_FILM',
  /** an external website. http? https? who knows? */
  ExternalWebsite = 'EXTERNAL_WEBSITE',
  FromTheBlog = 'FROM_THE_BLOG',
  ImageGallery = 'IMAGE_GALLERY',
  /** what's happened since then? */
  SinceTheTalk = 'SINCE_THE_TALK'
}

/** Types of things that can be liked (stored in Identity) */
export enum LikableItemType {
  Playlist = 'PLAYLIST',
  Video = 'VIDEO'
}

/** Autogenerated return type of LikeItem */
export type LikeItemPayload = {
  __typename?: 'LikeItemPayload';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  item?: Maybe<LikedItem>;
};

/** An item (a video or playlist) a user has liked. */
export type LikedItem = {
  __typename?: 'LikedItem';
  id: Scalars['ID']['output'];
  itemId: Scalars['ID']['output'];
  itemType: LikableItemType;
};

export type MembershipEvent = {
  __typename?: 'MembershipEvent';
  /** UTC beginning time of the membership event */
  beginAt: Scalars['ISO8601DateTime']['output'];
  /** UTC ending time of the membership event */
  endAt: Scalars['ISO8601DateTime']['output'];
  /** ID of the membership event */
  id: Scalars['ID']['output'];
  /** User registered for the membership event? */
  isRegistered: Scalars['Boolean']['output'];
  /** Membership candidate type sold out? */
  isSoldOut: Scalars['Boolean']['output'];
  /** Sessions of the membership event */
  membershipEventSessions: Array<MembershipEventSession>;
  /** IANA timezone name of the membership event */
  timezoneName: Scalars['String']['output'];
  /** Title of the membership event */
  title: Scalars['String']['output'];
};

export type MembershipEventSession = {
  __typename?: 'MembershipEventSession';
  /** UTC beginning time of the membership event session */
  beginAt: Scalars['ISO8601DateTime']['output'];
  /** Description of the membership event session */
  description: Scalars['String']['output'];
  /** UTC ending time of the membership event session  */
  endAt: Scalars['ISO8601DateTime']['output'];
  /** ID of the membership event */
  eventId: Scalars['ID']['output'];
  /** ID of the membership event session */
  id: Scalars['ID']['output'];
  /** Speakers of the membership event session */
  membershipEventSpeakers: Array<MembershipEventSpeaker>;
  /** Session format name, sometimes thought of as membership event type */
  sessionFormatName: Scalars['String']['output'];
  /** Label of URL to join the membership event session */
  sessionSignupLabel: Scalars['String']['output'];
  /** URL to join the membership event session */
  sessionSignupUrl: Scalars['String']['output'];
  /** Title of the membership event session */
  title: Scalars['String']['output'];
};

export type MembershipEventSpeaker = {
  __typename?: 'MembershipEventSpeaker';
  /** Photo URL of the membership event speaker */
  avatar?: Maybe<Scalars['String']['output']>;
  /** Short description of the membership event speaker, aka nugget */
  description: Scalars['String']['output'];
  /** First name of the membership event speaker */
  firstName: Scalars['String']['output'];
  /** ID of the membership event speaker */
  id: Scalars['ID']['output'];
  /** Last name of the membership event speaker */
  lastName: Scalars['String']['output'];
  /** First name of the membership event speaker */
  middleName: Scalars['String']['output'];
  /** Slug of the membership event speaker */
  slug: Scalars['String']['output'];
  /** Type of this speaker talk, either "Main Speaker" or "Interviewer" */
  speakerTalkTypeName: Scalars['String']['output'];
  /** What other people say about the membership event speaker */
  whatOthersSay?: Maybe<Scalars['String']['output']>;
  /** Longer description of the membership event speaker */
  whoTheyAre?: Maybe<Scalars['String']['output']>;
  /** Why people should listen to the membership event speaker */
  whyListen?: Maybe<Scalars['String']['output']>;
};

export type MembershipSubscription = {
  __typename?: 'MembershipSubscription';
  createdAt: Scalars['ISO8601DateTime']['output'];
  expiresAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  isCancelled: Scalars['Boolean']['output'];
  paymentPlatformId: Scalars['ID']['output'];
  skuId?: Maybe<Scalars['ID']['output']>;
  stripePrice?: Maybe<Scalars['String']['output']>;
  transactionId: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addPaymentMethod?: Maybe<AddPaymentMethodPayload>;
  addWatchedTalk?: Maybe<AddWatchedTalkPayload>;
  /** Cancel an attendee's registration to a membership event */
  cancelMembershipEventRegistration?: Maybe<CancelMembershipEventRegistrationPayload>;
  cancelStripeSupporterSubscription?: Maybe<CancelStripeSupporterSubscriptionPayload>;
  createOpenwebUserSession?: Maybe<CreateOpenwebUserSessionPayload>;
  createPaymentIntentClientSecret?: Maybe<CreatePaymentIntentClientSecretPayload>;
  createStripeSupporterSubscription?: Maybe<CreateStripeSupporterSubscriptionPayload>;
  id?: Maybe<Scalars['Int']['output']>;
  likeItem?: Maybe<LikeItemPayload>;
  purchaseGiftMembership?: Maybe<PurchaseGiftMembershipPayload>;
  redeemGiftMembership?: Maybe<RedeemGiftMembershipPayload>;
  redeemStripeSubscriptionToken?: Maybe<RedeemStripeSubscriptionTokenPayload>;
  /** Create an attendee's registration to a membership event */
  registerMembershipEvent?: Maybe<RegisterMembershipEventPayload>;
  removePaymentMethod?: Maybe<RemovePaymentMethodPayload>;
  removeYourListItem?: Maybe<RemoveYourListItemPayload>;
  renewExpiredStripeSubscriptionToken?: Maybe<RenewExpiredStripeSubscriptionTokenPayload>;
  saveVideoToYourList?: Maybe<SaveVideoToYourListPayload>;
  toggleFavorite?: Maybe<ToggleFavoriteMutationPayload>;
  toggleFollow?: Maybe<ToggleFollowMutationPayload>;
  toggleSavedPlaylist?: Maybe<ToggleSavedPlaylistMutationPayload>;
  unlikeItem?: Maybe<UnlikeItemPayload>;
  updateDefaultPaymentMethod?: Maybe<UpdateDefaultPaymentMethodPayload>;
  updatePreferredLanguage?: Maybe<UpdatePreferredLanguagePayload>;
  updateSailthruVarsMutation?: Maybe<UpdateSailthruVarsMutationPayload>;
  updateUserMutation?: Maybe<UpdateUserMutationPayload>;
};


export type MutationAddPaymentMethodArgs = {
  makeDefault?: InputMaybe<Scalars['Boolean']['input']>;
  paymentMethodId: Scalars['String']['input'];
};


export type MutationAddWatchedTalkArgs = {
  talkInput: WatchedTalkInput;
};


export type MutationCancelMembershipEventRegistrationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCancelStripeSupporterSubscriptionArgs = {
  additionalComments?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  paymentAmount: Scalars['String']['input'];
  paymentInterval: Scalars['String']['input'];
  reason: Scalars['String']['input'];
  subscriptionId: Scalars['ID']['input'];
};


export type MutationCreateOpenwebUserSessionArgs = {
  codeA: Scalars['String']['input'];
};


export type MutationCreatePaymentIntentClientSecretArgs = {
  priceAmountUsdCents: Scalars['Int']['input'];
};


export type MutationCreateStripeSupporterSubscriptionArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId?: InputMaybe<Scalars['ID']['input']>;
  priceAmountUsdCents: Scalars['Int']['input'];
  recaptchaToken: Scalars['String']['input'];
  sku: Scalars['ID']['input'];
  subscriptionMetadata?: InputMaybe<Scalars['SubscriptionMetadata']['input']>;
};


export type MutationLikeItemArgs = {
  id: Scalars['ID']['input'];
  itemType: LikableItemType;
};


export type MutationPurchaseGiftMembershipArgs = {
  cardTokenId: Scalars['ID']['input'];
  dateToSend: Scalars['ISO8601DateTime']['input'];
  giftMembershipMetadata?: InputMaybe<Scalars['SubscriptionMetadata']['input']>;
  personalMessage?: InputMaybe<Scalars['String']['input']>;
  recaptchaToken: Scalars['String']['input'];
  recipientEmail: Scalars['String']['input'];
  recipientFirstName: Scalars['String']['input'];
  recipientLastName: Scalars['String']['input'];
  senderEmail: Scalars['String']['input'];
  senderFirstName: Scalars['String']['input'];
  senderLastName: Scalars['String']['input'];
};


export type MutationRedeemGiftMembershipArgs = {
  token: Scalars['String']['input'];
};


export type MutationRedeemStripeSubscriptionTokenArgs = {
  token: Scalars['String']['input'];
};


export type MutationRegisterMembershipEventArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemovePaymentMethodArgs = {
  paymentMethodId: Scalars['String']['input'];
};


export type MutationRemoveYourListItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRenewExpiredStripeSubscriptionTokenArgs = {
  token: Scalars['String']['input'];
};


export type MutationSaveVideoToYourListArgs = {
  id: Scalars['ID']['input'];
  secondsPlayed: Scalars['Int']['input'];
};


export type MutationToggleFavoriteArgs = {
  favoriteable: FavoriteInput;
  shouldFavorite?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationToggleFollowArgs = {
  shouldFollow?: InputMaybe<Scalars['Boolean']['input']>;
  subject: FollowSubjectInput;
};


export type MutationToggleSavedPlaylistArgs = {
  playlistId: Scalars['ID']['input'];
  shouldSaveForLater?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUnlikeItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUpdateDefaultPaymentMethodArgs = {
  paymentMethodId: Scalars['String']['input'];
};


export type MutationUpdatePreferredLanguageArgs = {
  languageId: Scalars['Int']['input'];
};


export type MutationUpdateSailthruVarsMutationArgs = {
  email: Scalars['String']['input'];
  varsData: Array<SailthruVarsInput>;
};


export type MutationUpdateUserMutationArgs = {
  bornOn?: InputMaybe<Scalars['String']['input']>;
  industryId?: InputMaybe<Scalars['Int']['input']>;
};

export type NativeDownloads = {
  __typename?: 'NativeDownloads';
  /** A hi-res download */
  high?: Maybe<Scalars['URL']['output']>;
  /** A low-res download */
  low?: Maybe<Scalars['URL']['output']>;
  /** A medium-res download */
  medium?: Maybe<Scalars['URL']['output']>;
};

/** Results order sorting options */
export enum OrderOptions {
  /** Sort results in ascending order */
  Asc = 'ASC',
  /** Sort results in descending order */
  Desc = 'DESC'
}

/** Results sort order, when not provided, order defaults to `playlist#updated_at` */
export type OrderingOptions = {
  /** Order by `display_order` */
  displayOrder?: InputMaybe<OrderOptions>;
  /** Order by featured slot, meant to be used with the `in_featured_slot` filter. */
  featuredSlot?: InputMaybe<OrderOptions>;
  /** Order by `updated_at` */
  updatedAt?: InputMaybe<OrderOptions>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type Pancake = {
  __typename?: 'Pancake';
  id: Scalars['ID']['output'];
  lastPublishedVersion?: Maybe<Scalars['String']['output']>;
  playlists: PlaylistConnection;
};


export type PancakePlaylistsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for Pancake. */
export type PancakeConnection = {
  __typename?: 'PancakeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PancakeEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Pancake>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PancakeEdge = {
  __typename?: 'PancakeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Pancake>;
};

export type Paragraph = {
  __typename?: 'Paragraph';
  cues: Array<Cue>;
};

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  card?: Maybe<Card>;
  id: Scalars['String']['output'];
};

export type PhotoSize = {
  __typename?: 'PhotoSize';
  /** Width / height. */
  aspectRatio?: Maybe<AspectRatio>;
  /** Either a short string of the ratio, or a descriptive name for it like Facebook. */
  aspectRatioName?: Maybe<Scalars['String']['output']>;
  /** The height of the photo in pixels. */
  height?: Maybe<Scalars['Int']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  /** The width of the photo in pixels. */
  width?: Maybe<Scalars['Int']['output']>;
};

export type Platform = {
  __typename?: 'Platform';
  id: Scalars['ID']['output'];
  pancakes?: Maybe<PancakeConnection>;
  ribbons?: Maybe<RibbonConnection>;
  spotlightUnits?: Maybe<SpotlightUnitConnection>;
};


export type PlatformPancakesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type PlatformRibbonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type PlatformSpotlightUnitsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type Playlist = {
  __typename?: 'Playlist';
  /** Who put this playlist together? It's usually 'TED.' */
  author: Scalars['String']['output'];
  /** Plain-text, not HTML. */
  description?: Maybe<Scalars['String']['output']>;
  /** A unix timestamp integer. Nicely sortable. */
  displayOrder: Scalars['Int']['output'];
  /** Duration of the whole playlist, in seconds. */
  duration: Scalars['Int']['output'];
  /** Playlists with this value should appear on the homepage, sorted by this. */
  featuredSlotNumber?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  /** A playlist can have >1 photoset in talkstar. This is its primary one. Pick your aspect ratio. */
  primaryImageSet: Array<PhotoSize>;
  /** Whether the talk has been published to the world yet. */
  published: Scalars['Boolean']['output'];
  publishedAt: Scalars['ISO8601DateTime']['output'];
  /** A label to use for the playlist season in the front-end. For example "2019". */
  seasonLabel?: Maybe<Scalars['String']['output']>;
  /** If this playlist is part of a season, this tells you which season it is. */
  seasonNumber?: Maybe<Scalars['String']['output']>;
  /** The series that this playlist belongs to */
  series?: Maybe<Series>;
  slug: Scalars['String']['output'];
  /** Use this description when sharing the playlist to social media. */
  socialDescription?: Maybe<Scalars['String']['output']>;
  /** Use this title when sharing the playlist to social media. */
  socialTitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  videos: VideoConnection;
};


export type PlaylistVideosArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for Playlist. */
export type PlaylistConnection = {
  __typename?: 'PlaylistConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PlaylistEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Playlist>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PlaylistEdge = {
  __typename?: 'PlaylistEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Playlist>;
};

export type PlaylistItem = {
  __typename?: 'PlaylistItem';
  id: Scalars['ID']['output'];
  itemId: Scalars['Int']['output'];
  itemType: Scalars['String']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  playlistId?: Maybe<Scalars['Int']['output']>;
  secondsPlayed?: Maybe<Scalars['Int']['output']>;
  watched?: Maybe<Scalars['Boolean']['output']>;
};

/** The connection type for PlaylistItem. */
export type PlaylistItemConnection = {
  __typename?: 'PlaylistItemConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PlaylistItemEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PlaylistItem>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PlaylistItemEdge = {
  __typename?: 'PlaylistItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PlaylistItem>;
};

export type PreferredUserLanguage = {
  __typename?: 'PreferredUserLanguage';
  code: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated return type of PurchaseGiftMembership */
export type PurchaseGiftMembershipPayload = {
  __typename?: 'PurchaseGiftMembershipPayload';
  giftMembershipToken?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type Query = {
  __typename?: 'Query';
  acmeLanguages?: Maybe<AcmeLanguageConnection>;
  acmeSpeaker?: Maybe<AcmeSpeaker>;
  acmeSpeakers?: Maybe<AcmeSpeakerConnection>;
  doYouLikeItem?: Maybe<LikedItem>;
  /** Returns all languages */
  identityLanguages: Array<IdentityLanguage>;
  /** A simple query that relies on nothing. Suitable for specs and health-checks. */
  identityPing: Scalars['String']['output'];
  /** Returns all industries */
  industries: Array<Industry>;
  /** membership events */
  membershipEvents?: Maybe<Array<MembershipEvent>>;
  ping: Scalars['String']['output'];
  platform?: Maybe<Platform>;
  playlist?: Maybe<Playlist>;
  playlists?: Maybe<PlaylistConnection>;
  /** A simple query that relies on nothing. Suitable for specs and health-checks. */
  roadrunnerPing: Scalars['String']['output'];
  series?: Maybe<Series>;
  speaker?: Maybe<Speaker>;
  topic?: Maybe<Topic>;
  topicList?: Maybe<TopicListItemConnection>;
  translation?: Maybe<Translation>;
  video?: Maybe<Video>;
  videos?: Maybe<VideoConnection>;
  /** Find a user */
  viewer?: Maybe<User>;
  yourListItem?: Maybe<YourListItem>;
};


export type QueryAcmeLanguagesArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAcmeSpeakerArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAcmeSpeakersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDoYouLikeItemArgs = {
  itemId: Scalars['ID']['input'];
  itemType: LikableItemType;
};


export type QueryMembershipEventsArgs = {
  public?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPlatformArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPlaylistArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPlaylistsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  curator?: InputMaybe<CuratorOptions>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  inFeaturedSlot?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderingOptions>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  topics?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QuerySeriesArgs = {
  slug: Scalars['String']['input'];
};


export type QuerySpeakerArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTopicArgs = {
  slug: Scalars['String']['input'];
};


export type QueryTopicListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTranslationArgs = {
  language: Scalars['String']['input'];
  videoId: Scalars['ID']['input'];
};


export type QueryVideoArgs = {
  channelId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryVideosArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<ChannelOptions>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Array<Scalars['Int']['input']>>;
  isPublished?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  language?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Array<Scalars['String']['input']>>;
  symfonyMediaSlug?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryYourListItemArgs = {
  itemId: Scalars['ID']['input'];
  itemType: YourListItemType;
};

/** What kind of recommendation item is it? */
export enum RecItemLabel {
  Explore = 'EXPLORE',
  Listen = 'LISTEN',
  ReadArticle = 'READ_ARTICLE',
  ReadBook = 'READ_BOOK',
  Watch = 'WATCH'
}

/** A 'recommendation' */
export type Recommendation = {
  __typename?: 'Recommendation';
  blurb: Scalars['String']['output'];
  recLists: Array<RecommendationList>;
};

/** A recommendation item */
export type RecommendationItem = {
  __typename?: 'RecommendationItem';
  blurb: Scalars['String']['output'];
  eyebrow?: Maybe<Scalars['String']['output']>;
  headline: Scalars['String']['output'];
  isPdf: Scalars['Boolean']['output'];
  label: RecItemLabel;
  linkUrl: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
};

/** A recommendation list...a list of recommendation items */
export type RecommendationList = {
  __typename?: 'RecommendationList';
  description: Scalars['String']['output'];
  recItems: Array<RecommendationItem>;
  title: Scalars['String']['output'];
};

/** Autogenerated return type of RedeemGiftMembership */
export type RedeemGiftMembershipPayload = {
  __typename?: 'RedeemGiftMembershipPayload';
  status: Scalars['String']['output'];
};

/** Autogenerated return type of RedeemStripeSubscriptionToken */
export type RedeemStripeSubscriptionTokenPayload = {
  __typename?: 'RedeemStripeSubscriptionTokenPayload';
  status: RedeemSubscriptionTokenStatus;
};

/** Types of things that can be happen when you redeem a SubscriptionToken */
export enum RedeemSubscriptionTokenStatus {
  /** All clear: the token was just successfully redeemed. */
  Success = 'SUCCESS',
  /** This token was already redeemed */
  TokenAlreadyRedeemed = 'TOKEN_ALREADY_REDEEMED',
  /** This token has expired; try renewing it. */
  TokenExpired = 'TOKEN_EXPIRED'
}

/** Autogenerated return type of RegisterMembershipEvent. */
export type RegisterMembershipEventPayload = {
  __typename?: 'RegisterMembershipEventPayload';
  membershipEvent?: Maybe<MembershipEvent>;
};

/** Autogenerated return type of RemovePaymentMethod */
export type RemovePaymentMethodPayload = {
  __typename?: 'RemovePaymentMethodPayload';
  status: Scalars['String']['output'];
};

/** Autogenerated return type of RemoveYourListItem */
export type RemoveYourListItemPayload = {
  __typename?: 'RemoveYourListItemPayload';
  errors: Array<Scalars['String']['output']>;
  item?: Maybe<YourListItem>;
};

/** Autogenerated return type of RenewExpiredStripeSubscriptionToken */
export type RenewExpiredStripeSubscriptionTokenPayload = {
  __typename?: 'RenewExpiredStripeSubscriptionTokenPayload';
  status: RenewExpiredSubscriptionTokenStatus;
};

/** Types of things that can be happen when you renew an expired SubscriptionToken */
export enum RenewExpiredSubscriptionTokenStatus {
  /** All clear: the token was successfully renewed */
  Success = 'SUCCESS',
  /** This token was already redeemed */
  TokenAlreadyRedeemed = 'TOKEN_ALREADY_REDEEMED',
  /** This token hasn't expired yet */
  TokenNotExpired = 'TOKEN_NOT_EXPIRED'
}

export type Ribbon = {
  __typename?: 'Ribbon';
  id: Scalars['ID']['output'];
  lastPublishedVersion?: Maybe<Scalars['String']['output']>;
  live?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  slots?: Maybe<SlotConnection>;
  sponsorLogo?: Maybe<Scalars['String']['output']>;
  sponsorName?: Maybe<Scalars['String']['output']>;
  sponsored?: Maybe<Scalars['Boolean']['output']>;
};


export type RibbonSlotsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for Ribbon. */
export type RibbonConnection = {
  __typename?: 'RibbonConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<RibbonEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Ribbon>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type RibbonEdge = {
  __typename?: 'RibbonEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Ribbon>;
};

/** Variables for a Sailthru user, only those with values will be returned by ST. */
export type SailthruUserVars = {
  __typename?: 'SailthruUserVars';
  confirmOptinRequired?: Maybe<Scalars['String']['output']>;
  countdownNewsletterFrequency?: Maybe<Scalars['String']['output']>;
  countdownNewsletterOptinDate?: Maybe<Scalars['String']['output']>;
  countdownNewsletterSource?: Maybe<Scalars['String']['output']>;
  countdownNewsletterSubscriber?: Maybe<Scalars['String']['output']>;
  numberOfNewslettersSubscribed?: Maybe<Scalars['String']['output']>;
  supertopicArtAndDesign?: Maybe<Scalars['String']['output']>;
  supertopicBusiness?: Maybe<Scalars['String']['output']>;
  supertopicClimateChange?: Maybe<Scalars['String']['output']>;
  supertopicEducation?: Maybe<Scalars['String']['output']>;
  supertopicHealth?: Maybe<Scalars['String']['output']>;
  supertopicMusicAndPerformance?: Maybe<Scalars['String']['output']>;
  supertopicNature?: Maybe<Scalars['String']['output']>;
  supertopicPersonalGrowth?: Maybe<Scalars['String']['output']>;
  supertopicPsychology?: Maybe<Scalars['String']['output']>;
  supertopicScience?: Maybe<Scalars['String']['output']>;
  supertopicSocietyAndCulture?: Maybe<Scalars['String']['output']>;
  supertopicSurpriseMe?: Maybe<Scalars['String']['output']>;
  supertopicTechnology?: Maybe<Scalars['String']['output']>;
  tedEdDailyNewsletterFrequency?: Maybe<Scalars['String']['output']>;
  tedEdDailyNewsletterOptinDate?: Maybe<Scalars['String']['output']>;
  tedEdDailyNewsletterSource?: Maybe<Scalars['String']['output']>;
  tedEdDailyNewsletterSubscriber?: Maybe<Scalars['String']['output']>;
  tedEdWeeklyNewsletterFrequency?: Maybe<Scalars['String']['output']>;
  tedEdWeeklyNewsletterOptinDate?: Maybe<Scalars['String']['output']>;
  tedEdWeeklyNewsletterSource?: Maybe<Scalars['String']['output']>;
  tedEdWeeklyNewsletterSubscriber?: Maybe<Scalars['String']['output']>;
  tedEnEspanolNewsletterFrequency?: Maybe<Scalars['String']['output']>;
  tedEnEspanolNewsletterSubscriber?: Maybe<Scalars['String']['output']>;
  tedMembershipNewsletterFrequency?: Maybe<Scalars['String']['output']>;
  tedMembershipNewsletterSubscriber?: Maybe<Scalars['String']['output']>;
  tedRecommendsNewsletterFrequency?: Maybe<Scalars['String']['output']>;
  tedRecommendsNewsletterOptinDate?: Maybe<Scalars['String']['output']>;
  tedRecommendsNewsletterSource?: Maybe<Scalars['String']['output']>;
  tedRecommendsNewsletterSubscriber?: Maybe<Scalars['String']['output']>;
  tedTalksDailyNewsletterFrequency?: Maybe<Scalars['String']['output']>;
  tedTalksDailyNewsletterOptinDate?: Maybe<Scalars['String']['output']>;
  tedTalksDailyNewsletterSource?: Maybe<Scalars['String']['output']>;
  tedTalksDailyNewsletterSubscriber?: Maybe<Scalars['String']['output']>;
  tedTalksTechNewsletterFrequency?: Maybe<Scalars['String']['output']>;
  tedTalksTechNewsletterOptinDate?: Maybe<Scalars['String']['output']>;
  tedTalksTechNewsletterSource?: Maybe<Scalars['String']['output']>;
  tedTalksTechNewsletterSubscriber?: Maybe<Scalars['String']['output']>;
  tedUpdatesConferences?: Maybe<Scalars['String']['output']>;
  tedUpdatesConferencesOptinDate?: Maybe<Scalars['String']['output']>;
  tedUpdatesConferencesSource?: Maybe<Scalars['String']['output']>;
  tedUpdatesImpact?: Maybe<Scalars['String']['output']>;
  tedUpdatesImpactOptinDate?: Maybe<Scalars['String']['output']>;
  tedUpdatesImpactSource?: Maybe<Scalars['String']['output']>;
  tedUpdatesOnlineEvents?: Maybe<Scalars['String']['output']>;
  tedUpdatesOnlineEventsOptinDate?: Maybe<Scalars['String']['output']>;
  tedUpdatesOnlineEventsSource?: Maybe<Scalars['String']['output']>;
  tedUpdatesOptinDate?: Maybe<Scalars['String']['output']>;
  tedUpdatesSource?: Maybe<Scalars['String']['output']>;
  tedUpdatesSubscriber?: Maybe<Scalars['String']['output']>;
  tedUpdatesSupport?: Maybe<Scalars['String']['output']>;
  tedUpdatesSupportOptinDate?: Maybe<Scalars['String']['output']>;
  tedUpdatesSupportSource?: Maybe<Scalars['String']['output']>;
  tedWeekInIdeasNewsletterFrequency?: Maybe<Scalars['String']['output']>;
  tedWeekInIdeasNewsletterSubscriber?: Maybe<Scalars['String']['output']>;
};

/** Returns a Sailthru API user vars payload. */
export type SailthruVars = {
  __typename?: 'SailthruVars';
  vars?: Maybe<SailthruUserVars>;
};

export type SailthruVarsInput = {
  /** Whether the variable is true or false. */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Cadence of the subscription frequency for newsletter. Ei: Biweekly, monthly etc. */
  frequency?: InputMaybe<Scalars['String']['input']>;
  /** Name of the Sailthru var. */
  name: Scalars['String']['input'];
  /** Date when the optin ocurred Ei: "2024-10-03" etc. */
  optinDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Where the optin originates from. Ei: interests-page etc. */
  source?: InputMaybe<Scalars['String']['input']>;
  /** Whether the user is subscribed if this is a newsletter. */
  subscribed?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of SaveVideoToYourList */
export type SaveVideoToYourListPayload = {
  __typename?: 'SaveVideoToYourListPayload';
  errors: Array<Scalars['String']['output']>;
  item?: Maybe<YourListItem>;
};

export type Series = {
  __typename?: 'Series';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  playlists?: Maybe<PlaylistConnection>;
  publishedPlaylistCount: Scalars['Int']['output'];
  slug: Scalars['String']['output'];
};


export type SeriesPlaylistsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type Slot = {
  __typename?: 'Slot';
  duration?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  remote?: Maybe<Scalars['Boolean']['output']>;
  sponsored?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  video?: Maybe<Video>;
};


export type SlotVideoArgs = {
  channelId?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
};

/** The connection type for Slot. */
export type SlotConnection = {
  __typename?: 'SlotConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SlotEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Slot>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SlotEdge = {
  __typename?: 'SlotEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Slot>;
};

export type Speaker = {
  __typename?: 'Speaker';
  avatar: Scalars['URL']['output'];
  /**
   * Another short bit of HTML. ~500 characters, often blank. If queried through a
   * non-curator-approved TEDx talk, it'll be null.
   */
  description: Scalars['String']['output'];
  /** Part of their name. But think about using Video.presenterDisplayName first. */
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Part of their name. But think about using Video.presenterDisplayName first. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Part of their name. But think about using Video.presenterDisplayName first. */
  middleName?: Maybe<Scalars['String']['output']>;
  /** An unpublished speaker should not link to their speaker page...it'll 404. */
  published: Scalars['Boolean']['output'];
  slug: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  users: Array<User>;
  /** Usually under 1,000 characters, sometimes contains HTML. */
  whatOthersSay: Scalars['String']['output'];
  /** A usually short field with a bit of HTML. If queried through a non-curator-approved TEDx talk, it'll be null. */
  whoTheyAre: Scalars['String']['output'];
  /** Up to 5,000 characters of HTML. */
  whyListen: Scalars['String']['output'];
};

export type SpotlightUnit = {
  __typename?: 'SpotlightUnit';
  content?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  published?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** The connection type for SpotlightUnit. */
export type SpotlightUnitConnection = {
  __typename?: 'SpotlightUnitConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SpotlightUnitEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<SpotlightUnit>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SpotlightUnitEdge = {
  __typename?: 'SpotlightUnitEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<SpotlightUnit>;
};

export type SubjectFilter = {
  id: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};

export type SubtitledDownload = {
  __typename?: 'SubtitledDownload';
  /** A hi-res download */
  high?: Maybe<Scalars['URL']['output']>;
  /** The code of the language the subtitles are in */
  internalLanguageCode: Scalars['String']['output'];
  /** The name of the language the subtitles are in */
  languageName: Scalars['String']['output'];
  /** A low-res download */
  low?: Maybe<Scalars['URL']['output']>;
};

/** A take-action module from talkstar */
export type TakeActionModule = {
  __typename?: 'TakeActionModule';
  blurb?: Maybe<Scalars['String']['output']>;
  endAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  eyebrow?: Maybe<Scalars['String']['output']>;
  linkUrl?: Maybe<Scalars['URL']['output']>;
  published: Scalars['Boolean']['output'];
  startAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  status: ExtraStatus;
  verb: Scalars['String']['output'];
  visibleUrl?: Maybe<Scalars['String']['output']>;
};

/** data from Talk Extras, with just-enough modelling */
export type TalkExtras = {
  __typename?: 'TalkExtras';
  footnotes: Array<Footnote>;
  learnModules: Array<LearnModule>;
  recommendations: Array<Recommendation>;
  takeAction: Array<TakeActionModule>;
};

export type TalkTakeaway = {
  __typename?: 'TalkTakeaway';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  offsetSeconds: Scalars['Int']['output'];
  talkstarTalkId: Scalars['Int']['output'];
  text: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  videos: VideoConnection;
};


export type TalkTakeawayVideosArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channelId?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for TalkTakeaway. */
export type TalkTakeawayConnection = {
  __typename?: 'TalkTakeawayConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<TalkTakeawayEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<TalkTakeaway>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TalkTakeawayEdge = {
  __typename?: 'TalkTakeawayEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<TalkTakeaway>;
};

/** Autogenerated return type of ToggleFavoriteMutation */
export type ToggleFavoriteMutationPayload = {
  __typename?: 'ToggleFavoriteMutationPayload';
  updatedFavorites?: Maybe<Array<Favorite>>;
  viewer?: Maybe<User>;
};

/** Autogenerated return type of ToggleFollowMutation */
export type ToggleFollowMutationPayload = {
  __typename?: 'ToggleFollowMutationPayload';
  updatedFollows?: Maybe<Array<Follow>>;
  viewer?: Maybe<User>;
};

/** Autogenerated return type of ToggleSavedPlaylistMutation */
export type ToggleSavedPlaylistMutationPayload = {
  __typename?: 'ToggleSavedPlaylistMutationPayload';
  updatedPlaylists?: Maybe<Array<Playlist>>;
  viewer?: Maybe<User>;
};

export type Topic = {
  __typename?: 'Topic';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  playlists?: Maybe<PlaylistConnection>;
  /** A short human-readable identifier for this Topic. Suitable for building URLs. */
  slug?: Maybe<Scalars['String']['output']>;
  videos?: Maybe<VideoConnection>;
};


export type TopicPlaylistsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderingOptions>;
};


export type TopicVideosArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for Topic. */
export type TopicConnection = {
  __typename?: 'TopicConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<TopicEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Topic>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TopicEdge = {
  __typename?: 'TopicEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Topic>;
};

export type TopicListItem = {
  __typename?: 'TopicListItem';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** A short human-readable identifier for this TopicListItem. Suitable for building URLs. */
  slug?: Maybe<Scalars['String']['output']>;
};

/** The connection type for TopicListItem. */
export type TopicListItemConnection = {
  __typename?: 'TopicListItemConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<TopicListItemEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<TopicListItem>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TopicListItemEdge = {
  __typename?: 'TopicListItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<TopicListItem>;
};

export type Translation = {
  __typename?: 'Translation';
  id: Scalars['ID']['output'];
  language?: Maybe<AcmeLanguage>;
  paragraphs: Array<Paragraph>;
  reviewer?: Maybe<User>;
  translator?: Maybe<User>;
};

export type TypeOfVideo = {
  __typename?: 'TypeOfVideo';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** Autogenerated return type of UnlikeItem */
export type UnlikeItemPayload = {
  __typename?: 'UnlikeItemPayload';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  item?: Maybe<LikedItem>;
};

/** Autogenerated return type of UpdateDefaultPaymentMethod */
export type UpdateDefaultPaymentMethodPayload = {
  __typename?: 'UpdateDefaultPaymentMethodPayload';
  status: Scalars['String']['output'];
};

/** Autogenerated return type of UpdatePreferredLanguage */
export type UpdatePreferredLanguagePayload = {
  __typename?: 'UpdatePreferredLanguagePayload';
  viewer: User;
};

/** Autogenerated return type of UpdateSailthruVarsMutation */
export type UpdateSailthruVarsMutationPayload = {
  __typename?: 'UpdateSailthruVarsMutationPayload';
  success: Scalars['Boolean']['output'];
};

/** Autogenerated return type of UpdateUserMutation */
export type UpdateUserMutationPayload = {
  __typename?: 'UpdateUserMutationPayload';
  viewer: User;
};

export type User = {
  __typename?: 'User';
  /** What a user has done on TED.com. */
  activities?: Maybe<ActivityConnection>;
  avatar: UserAvatar;
  bornOn?: Maybe<Scalars['ISO8601Date']['output']>;
  byline?: Maybe<Scalars['String']['output']>;
  defaultPaymentMethod?: Maybe<PaymentMethod>;
  favorites?: Maybe<FavoriteConnection>;
  follows?: Maybe<FollowConnection>;
  /** @deprecated Moving responsibility to identity */
  fullName?: Maybe<Scalars['String']['output']>;
  /** active gift membership if the user has one */
  giftMembership?: Maybe<GiftMembership>;
  /** Do not send alerts, notifications, emails, etc to this user if false */
  hasMemberNotificationsEnabled: Scalars['Boolean']['output'];
  hasMembersMightyNetworkAccess: Scalars['Boolean']['output'];
  /** The TED user id, specifically the remote id within Identity */
  id: Scalars['ID']['output'];
  /** The object representation of the Industry the user belongs to, name an all. */
  industry?: Maybe<Industry>;
  /** The id of the industry the user belongs to. */
  industryId?: Maybe<Scalars['String']['output']>;
  /** True if the users current membership was gifted */
  isGiftedMember: Scalars['Boolean']['output'];
  /** True if a user is an active TED Member. */
  isMember: Scalars['Boolean']['output'];
  /** True if a user is a paying supporter */
  isSupporter: Scalars['Boolean']['output'];
  /** membership subscription if user is a paying supporter */
  membershipSubscription?: Maybe<MembershipSubscription>;
  name: UserName;
  paymentMethods?: Maybe<Array<PaymentMethod>>;
  preferredLanguage?: Maybe<PreferredUserLanguage>;
  primaryEmailAddress?: Maybe<Scalars['String']['output']>;
  profilePath?: Maybe<Scalars['URL']['output']>;
  /** @deprecated Use profilePath instead */
  profileUrl: Scalars['String']['output'];
  sailthruVars?: Maybe<SailthruVars>;
  savedPlaylists?: Maybe<Array<Playlist>>;
  savedTalks?: Maybe<PlaylistItemConnection>;
  /** @deprecated Use profilePath instead */
  uri?: Maybe<Scalars['URL']['output']>;
  watchedTalks?: Maybe<Array<WatchedTalk>>;
  watchedVideos?: Maybe<VideoConnection>;
};


export type UserActivitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type UserFavoritesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FavoritesFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type UserFollowsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FollowsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type UserSavedPlaylistsArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type UserSavedTalksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type UserWatchedVideosArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  watchedAfter?: InputMaybe<Scalars['ISO8601Date']['input']>;
  watchedBefore?: InputMaybe<Scalars['ISO8601Date']['input']>;
};

export type UserAvatar = {
  __typename?: 'UserAvatar';
  generatedUrl: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};


export type UserAvatarGeneratedUrlArgs = {
  type?: InputMaybe<GeneratedAvatar>;
};

export type UserName = {
  __typename?: 'UserName';
  first?: Maybe<Scalars['String']['output']>;
  full?: Maybe<Scalars['String']['output']>;
  last?: Maybe<Scalars['String']['output']>;
};

/** Everyone thinks we work for TED Talks. These are those famous talks. */
export type Video = {
  __typename?: 'Video';
  acmePlayerData: Scalars['AcmePlayerData']['output'];
  audioDownload?: Maybe<Scalars['URL']['output']>;
  /** The language the speaker is speaking in. */
  audioInternalLanguageCode?: Maybe<Scalars['String']['output']>;
  /** We're not 100% sure this should go here? It could be calculated from the slug. Otoh, it's nice to centralize that logic. */
  canonicalUrl: Scalars['String']['output'];
  /** Should comments be enabled for this video? */
  commentsEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** If comments are enabled, should they only show for logged-in users? */
  commentsLoggedInOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Has this video been reviewed and approved by TED editorial staff? */
  curatorApproved?: Maybe<Scalars['Boolean']['output']>;
  /**
   * For custom-content videos (yet another variety of partnership), we use this
   * data to override the 'Speaker' block, to make it seem like the partner is the
   * speaker. This is a hack until we get ~better support for this in Talkstar.
   */
  customContentDetails?: Maybe<CustomContentDetails>;
  /** Paragraph-length description of the video's content. May be blank in some cases. */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * Perform a descending-order sort on this value to achieve the ordering
   * intended by TED editors. (Collections will be ordered by this value by
   * default.) Actual value is an arbitrary numeric value. Note that this value can vary per channel.
   */
  displayOrder?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Duration of the video, in seconds. */
  duration: Scalars['Int']['output'];
  /** These only apply to certain videos. It'll be there if it needs to be. */
  eventBadge?: Maybe<EventBadge>;
  /** A fallback URL if the hls URL does not work. */
  fallbackUrl: Scalars['String']['output'];
  /** Was this video published to TalkStar's 'featured' channel? ...which also syncs videos to Symfony? */
  featured: Scalars['Boolean']['output'];
  hasTranslations: Scalars['Boolean']['output'];
  /** HLS URL for the current ProjctMaster media. */
  hlsUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /**
   * The language the title, description, speaker name, and transcripts are in.
   * It's probably what was requested, but not guaranteed...sometimes we fall back
   * to English, or the language the talk was given in.
   */
  internalLanguageCode?: Maybe<Scalars['String']['output']>;
  /**
   * Is the video currently published in the selected channel?
   * In most cases, non-published videos should not be displayed to clients.
   * true or false
   * Note that this value can vary per channel.
   * 'any' can also be passed to return records of any value for this field
   */
  isPublished: Scalars['Boolean']['output'];
  /**
   * Should subtitles be automatically displayed when video playback starts? This
   * value is advice from the TED editorial staff, intended for a primarily
   * English-speaking audience. It typically identifies non-English TED Talks or
   * videos where the speaker's speech is difficult to understand.
   */
  isSubtitleRequired?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  /** The single topic that is used by the learning product */
  learningProductTopic?: Maybe<Topic>;
  nativeDownloads?: Maybe<NativeDownloads>;
  /**
   * For a Salon or Institute talk, this will be the partner name (extracted from
   * the video's context field. For anything else (including a custom-content
   * video), it'll be null.
   */
  partnerName?: Maybe<Scalars['String']['output']>;
  /** A string of JSON, that can be parsed, and passed to the TED video player. We may turn this into a real object? Not sure. */
  playerData: Scalars['PlayerData']['output'];
  /** Includes podcast platform views */
  podcastsPercentage?: Maybe<Scalars['Decimal']['output']>;
  /**
   * A single string describing the speaker(s) in a video. Intended for display
   * purposes only. Use the `speakers` relationship for more detailed information.
   */
  presenterDisplayName?: Maybe<Scalars['String']['output']>;
  /** A video can have >1 photoset in talkstar. This is its primary one. */
  primaryImageSet?: Maybe<Array<PhotoSize>>;
  /**
   * Time at which the video was most recently published. Most
   * videos are only published once, but in the rare cases where a video is
   * unpublished and then later re-published, this field will contain the
   * most recent publication date. Note that this value can vary per channel.
   */
  publishedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The subtitles that have been published for the talk. */
  publishedSubtitleLanguages?: Maybe<AcmeLanguageConnection>;
  /** Date that a video was created. Note this is the date of content creation, not publication. Can be null. */
  recordedOn?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Any curated watch-next videos from talkstar, back-filled from Rae. */
  relatedVideos: Array<Video>;
  /** A short human-readable identifier for this video. Suitable for building URLs. */
  slug?: Maybe<Scalars['String']['output']>;
  /** Use this description when sharing the video to social media. */
  socialDescription?: Maybe<Scalars['String']['output']>;
  /** Use this title when sharing the video to social media. */
  socialTitle?: Maybe<Scalars['String']['output']>;
  /** Speakers who are associated with this video. */
  speakers?: Maybe<AcmeSpeakerConnection>;
  subtitledDownloads: Array<SubtitledDownload>;
  takeaways?: Maybe<TalkTakeawayConnection>;
  /** Data from talk-extras, with just-enough modelling */
  talkExtras: TalkExtras;
  /** Includes React Native app, Apple TV views, etc. */
  tedappsPercentage?: Maybe<Scalars['Decimal']['output']>;
  /** Includes TED.com and embed player views */
  tedcomPercentage?: Maybe<Scalars['Decimal']['output']>;
  /** The video title. No speaker name prepended. */
  title: Scalars['String']['output'];
  topics?: Maybe<TopicConnection>;
  type: TypeOfVideo;
  /**
   * Unique identifier for the this master's current media stream. This value
   * should be delivered & cached alongside the hls_url and metadata_url. It
   * identifies unique values of those fields.
   */
  versionIdentifier: Scalars['String']['output'];
  /**
   * Often, the event the talk was given at. It's 'TED-Ed' for TED-Ed videos. We
   * pull partner info out of these for Institute and Salon talks. Ultimately, this
   * is controlled by editorial.
   */
  videoContext: Scalars['String']['output'];
  /** Zero or more Consus-encoded video downloads for this talk. */
  videoDownloads: VideoDownloadConnection;
  videometricsVideoId?: Maybe<Scalars['ID']['output']>;
  /**
   * The count of times the video has been watched. We don't display these if
   * they're <10k, but that's up to the client (currently).
   */
  viewedCount: Scalars['Int']['output'];
  /** Includes YouTube views */
  youtubePercentage?: Maybe<Scalars['Decimal']['output']>;
};


/** Everyone thinks we work for TED Talks. These are those famous talks. */
export type VideoAcmePlayerDataArgs = {
  playlistReferrerSlug?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Everyone thinks we work for TED Talks. These are those famous talks. */
export type VideoPublishedSubtitleLanguagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Everyone thinks we work for TED Talks. These are those famous talks. */
export type VideoRelatedVideosArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
};


/** Everyone thinks we work for TED Talks. These are those famous talks. */
export type VideoSpeakersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Everyone thinks we work for TED Talks. These are those famous talks. */
export type VideoTakeawaysArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/** Everyone thinks we work for TED Talks. These are those famous talks. */
export type VideoTopicsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/** Everyone thinks we work for TED Talks. These are those famous talks. */
export type VideoVideoDownloadsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for Video. */
export type VideoConnection = {
  __typename?: 'VideoConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<VideoEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Video>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type VideoDownload = {
  __typename?: 'VideoDownload';
  /** Video height in pixels */
  height: Scalars['Int']['output'];
  /** Location of video download */
  url: Scalars['String']['output'];
};

/** The connection type for VideoDownload. */
export type VideoDownloadConnection = {
  __typename?: 'VideoDownloadConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<VideoDownloadEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<VideoDownload>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type VideoDownloadEdge = {
  __typename?: 'VideoDownloadEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<VideoDownload>;
};

/** An edge in a connection. */
export type VideoEdge = {
  __typename?: 'VideoEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Video>;
};

export type WatchedTalk = {
  __typename?: 'WatchedTalk';
  autoplayed?: Maybe<Scalars['Boolean']['output']>;
  secondsPlayed: Scalars['Int']['output'];
  talk: IdentityTalkType;
};

export type WatchedTalkInput = {
  autoplayed?: InputMaybe<Scalars['Boolean']['input']>;
  secondsPlayed: Scalars['Int']['input'];
  talkId: Scalars['ID']['input'];
};

/** An item on a list of a user's saved videos & playlists, to watch later. */
export type YourListItem = {
  __typename?: 'YourListItem';
  id: Scalars['ID']['output'];
  itemId: Scalars['ID']['output'];
  itemType: YourListItemType;
  secondsPlayed: Scalars['Int']['output'];
};

/** Types of things that can be saved to Your-List */
export enum YourListItemType {
  Playlist = 'PLAYLIST',
  Video = 'VIDEO'
}

export type BasicVideoInfoFragment = { __typename?: 'Video', id: string, title: string, slug?: string | null, primaryImageSet?: Array<{ __typename?: 'PhotoSize', url?: string | null, aspectRatioName?: string | null }> | null };

export type FavoriteNodeFragment = { __typename?: 'Favorite', id: string, favoriteable?: { __typename?: 'Favoriteable', id: string, type: string } | null, favoriteableEntity?: { __typename?: 'IdentityTalkType' } | { __typename?: 'Playlist' } | { __typename?: 'TalkTakeaway', id: string, text: string, talkstarTalkId: number, offsetSeconds: number, videos: { __typename?: 'VideoConnection', nodes?: Array<{ __typename?: 'Video', title: string, slug?: string | null, recordedOn?: any | null, language?: string | null, duration: number, presenterDisplayName?: string | null, primaryImageSet?: Array<{ __typename?: 'PhotoSize', url?: string | null, aspectRatioName?: string | null }> | null, topics?: { __typename?: 'TopicConnection', nodes?: Array<{ __typename?: 'Topic', id: string, name?: string | null, slug?: string | null } | null> | null } | null, speakers?: { __typename?: 'AcmeSpeakerConnection', nodes?: Array<{ __typename?: 'AcmeSpeaker', photoUrl?: string | null, firstname?: string | null, middlename?: string | null, lastname?: string | null, description?: string | null, isLive?: boolean | null, title?: string | null, whatOthersSay?: string | null, whoTheyAre?: string | null, whyListen?: string | null, slug?: string | null } | null> | null } | null, learningProductTopic?: { __typename?: 'Topic', id: string, name?: string | null, slug?: string | null } | null } | null> | null } } | { __typename?: 'User' } | null };

export type FullVideoInfoFragment = { __typename?: 'Video', description?: string | null, socialTitle?: string | null, internalLanguageCode?: string | null, commentsEnabled?: boolean | null, commentsLoggedInOnly?: boolean | null, recordedOn?: any | null, curatorApproved?: boolean | null, socialDescription?: string | null, partnerName?: string | null, videoContext: string, audioInternalLanguageCode?: string | null, language?: string | null, hasTranslations: boolean, featured: boolean, presenterDisplayName?: string | null, duration: number, canonicalUrl: string, viewedCount: number, tedcomPercentage?: any | null, youtubePercentage?: any | null, podcastsPercentage?: any | null, tedappsPercentage?: any | null, publishedAt?: any | null, id: string, title: string, slug?: string | null, customContentDetails?: { __typename?: 'CustomContentDetails', partnerName?: string | null } | null, topics?: { __typename?: 'TopicConnection', nodes?: Array<{ __typename?: 'Topic', id: string, name?: string | null, slug?: string | null } | null> | null } | null, primaryImageSet?: Array<{ __typename?: 'PhotoSize', url?: string | null, aspectRatioName?: string | null }> | null };

export type LearningProductTopicFragment = { __typename?: 'Video', learningProductTopic?: { __typename?: 'Topic', id: string, name?: string | null, slug?: string | null } | null };

export type PlaylistInfoFragment = { __typename?: 'Playlist', id: string, slug: string, title: string, description?: string | null, author: string, seasonNumber?: string | null, primaryImageSet: Array<{ __typename?: 'PhotoSize', url?: string | null, aspectRatioName?: string | null }> };

export type SailthruInfoFragment = { __typename?: 'Video', presenterDisplayName?: string | null, duration: number, viewedCount: number, publishedAt?: any | null, id: string, title: string, slug?: string | null, topics?: { __typename?: 'TopicConnection', nodes?: Array<{ __typename?: 'Topic', name?: string | null } | null> | null } | null, primaryImageSet?: Array<{ __typename?: 'PhotoSize', url?: string | null, aspectRatioName?: string | null }> | null };

export type SpeakerInfoFragment = { __typename?: 'AcmeSpeaker', photoUrl?: string | null, firstname?: string | null, middlename?: string | null, lastname?: string | null, description?: string | null, isLive?: boolean | null, title?: string | null, whatOthersSay?: string | null, whoTheyAre?: string | null, whyListen?: string | null, slug?: string | null };

export type TopicInfoFragment = { __typename?: 'Topic', id: string, name?: string | null, slug?: string | null };

export type TranslationInfoFragment = { __typename?: 'Translation', id: string, language?: { __typename?: 'AcmeLanguage', id: string, endonym?: string | null, englishName?: string | null, internalLanguageCode?: string | null, rtl: boolean } | null, reviewer?: { __typename?: 'User', id: string, profilePath?: any | null, avatar: { __typename?: 'UserAvatar', url?: string | null, generatedUrl: string }, name: { __typename?: 'UserName', full?: string | null } } | null, translator?: { __typename?: 'User', id: string, profilePath?: any | null, avatar: { __typename?: 'UserAvatar', url?: string | null, generatedUrl: string }, name: { __typename?: 'UserName', full?: string | null } } | null };

export type UserInfoFragment = { __typename?: 'User', id: string, primaryEmailAddress?: string | null, name: { __typename?: 'UserName', full?: string | null, first?: string | null, last?: string | null } };

export type VideoInfoFragment = { __typename?: 'Video', presenterDisplayName?: string | null, duration: number, videoContext: string, canonicalUrl: string, viewedCount: number, tedcomPercentage?: any | null, youtubePercentage?: any | null, podcastsPercentage?: any | null, tedappsPercentage?: any | null, publishedAt?: any | null, id: string, title: string, slug?: string | null, topics?: { __typename?: 'TopicConnection', nodes?: Array<{ __typename?: 'Topic', name?: string | null } | null> | null } | null, primaryImageSet?: Array<{ __typename?: 'PhotoSize', url?: string | null, aspectRatioName?: string | null }> | null };

export type AddPaymentMethodMutationVariables = Exact<{
  paymentMethodId: Scalars['String']['input'];
}>;


export type AddPaymentMethodMutation = { __typename?: 'Mutation', addPaymentMethod?: { __typename?: 'AddPaymentMethodPayload', status: string } | null };

export type AddWatchedTalkMutationVariables = Exact<{
  talkInput: WatchedTalkInput;
}>;


export type AddWatchedTalkMutation = { __typename?: 'Mutation', addWatchedTalk?: { __typename?: 'AddWatchedTalkPayload', success: boolean } | null };

export type CancelMembershipEventRegistrationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CancelMembershipEventRegistrationMutation = { __typename?: 'Mutation', cancelMembershipEventRegistration?: { __typename?: 'CancelMembershipEventRegistrationPayload', membershipEvent?: { __typename?: 'MembershipEvent', id: string } | null } | null };

export type CancelSupporterMutationVariables = Exact<{
  subscriptionId: Scalars['ID']['input'];
  additionalComments?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  paymentAmount: Scalars['String']['input'];
  paymentInterval: Scalars['String']['input'];
  reason: Scalars['String']['input'];
}>;


export type CancelSupporterMutation = { __typename?: 'Mutation', cancelStripeSupporterSubscription?: { __typename?: 'CancelStripeSupporterSubscriptionPayload', success?: boolean | null } | null };

export type CreateOpenwebUserSessionMutationVariables = Exact<{
  codeA: Scalars['String']['input'];
}>;


export type CreateOpenwebUserSessionMutation = { __typename?: 'Mutation', createOpenwebUserSession?: { __typename?: 'CreateOpenwebUserSessionPayload', codeB?: string | null } | null };

export type CreateSupporterMutationVariables = Exact<{
  paymentMethodId?: InputMaybe<Scalars['ID']['input']>;
  priceAmountUsdCents: Scalars['Int']['input'];
  sku: Scalars['ID']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  subscriptionMetadata?: InputMaybe<Scalars['SubscriptionMetadata']['input']>;
  recaptchaToken: Scalars['String']['input'];
}>;


export type CreateSupporterMutation = { __typename?: 'Mutation', createStripeSupporterSubscription?: { __typename?: 'CreateStripeSupporterSubscriptionPayload', redemptionToken?: string | null } | null };

export type PurchaseGiftMembershipMutationVariables = Exact<{
  cardTokenId: Scalars['ID']['input'];
  recaptchaToken: Scalars['String']['input'];
  senderEmail: Scalars['String']['input'];
  senderLastName: Scalars['String']['input'];
  senderFirstName: Scalars['String']['input'];
  recipientEmail: Scalars['String']['input'];
  recipientLastName: Scalars['String']['input'];
  recipientFirstName: Scalars['String']['input'];
  dateToSend: Scalars['ISO8601DateTime']['input'];
  personalMessage?: InputMaybe<Scalars['String']['input']>;
  giftMembershipMetadata?: InputMaybe<Scalars['SubscriptionMetadata']['input']>;
}>;


export type PurchaseGiftMembershipMutation = { __typename?: 'Mutation', purchaseGiftMembership?: { __typename?: 'PurchaseGiftMembershipPayload', success?: boolean | null, giftMembershipToken?: string | null } | null };

export type RedeemGiftMembershipMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type RedeemGiftMembershipMutation = { __typename?: 'Mutation', redeemGiftMembership?: { __typename?: 'RedeemGiftMembershipPayload', status: string } | null };

export type RedeemSubscriptionRedemptionTokenMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type RedeemSubscriptionRedemptionTokenMutation = { __typename?: 'Mutation', redeemStripeSubscriptionToken?: { __typename?: 'RedeemStripeSubscriptionTokenPayload', status: RedeemSubscriptionTokenStatus } | null };

export type RegisterMembershipEventMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RegisterMembershipEventMutation = { __typename?: 'Mutation', registerMembershipEvent?: { __typename?: 'RegisterMembershipEventPayload', membershipEvent?: { __typename?: 'MembershipEvent', id: string } | null } | null };

export type RemovePaymentMethodMutationVariables = Exact<{
  paymentMethodId: Scalars['String']['input'];
}>;


export type RemovePaymentMethodMutation = { __typename?: 'Mutation', removePaymentMethod?: { __typename?: 'RemovePaymentMethodPayload', status: string } | null };

export type RemoveVideoFromYourLikesMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RemoveVideoFromYourLikesMutation = { __typename?: 'Mutation', unlikeItem?: { __typename?: 'UnlikeItemPayload', errors?: Array<string> | null } | null };

export type RemoveVideoFromYourListMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RemoveVideoFromYourListMutation = { __typename?: 'Mutation', removeYourListItem?: { __typename?: 'RemoveYourListItemPayload', errors: Array<string>, item?: { __typename?: 'YourListItem', id: string, itemId: string } | null } | null };

export type RenewSubscriptionTokenMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type RenewSubscriptionTokenMutation = { __typename?: 'Mutation', renewExpiredStripeSubscriptionToken?: { __typename?: 'RenewExpiredStripeSubscriptionTokenPayload', status: RenewExpiredSubscriptionTokenStatus } | null };

export type SaveVideoToYourLikesMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SaveVideoToYourLikesMutation = { __typename?: 'Mutation', likeItem?: { __typename?: 'LikeItemPayload', errors?: Array<string> | null, item?: { __typename?: 'LikedItem', id: string, itemId: string } | null } | null };

export type SaveVideoToYourListMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  secondsPlayed: Scalars['Int']['input'];
}>;


export type SaveVideoToYourListMutation = { __typename?: 'Mutation', saveVideoToYourList?: { __typename?: 'SaveVideoToYourListPayload', errors: Array<string> } | null };

export type ToggleFavoritePlaylistMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  shouldSaveForLater?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ToggleFavoritePlaylistMutation = { __typename?: 'Mutation', toggleSavedPlaylist?: { __typename?: 'ToggleSavedPlaylistMutationPayload', updatedPlaylists?: Array<{ __typename?: 'Playlist', id: string }> | null } | null };

export type ToggleFavoriteMutationVariables = Exact<{
  favoriteInput: FavoriteInput;
  shouldFavorite?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ToggleFavoriteMutation = { __typename?: 'Mutation', toggleFavorite?: { __typename?: 'ToggleFavoriteMutationPayload', viewer?: { __typename?: 'User', id: string } | null } | null };

export type UpdateDefaultPaymentMethodMutationVariables = Exact<{
  paymentMethodId: Scalars['String']['input'];
}>;


export type UpdateDefaultPaymentMethodMutation = { __typename?: 'Mutation', updateDefaultPaymentMethod?: { __typename?: 'UpdateDefaultPaymentMethodPayload', status: string } | null };

export type UpdatePreferredLanguageMutationVariables = Exact<{
  languageId: Scalars['Int']['input'];
}>;


export type UpdatePreferredLanguageMutation = { __typename?: 'Mutation', updatePreferredLanguage?: { __typename?: 'UpdatePreferredLanguagePayload', viewer: { __typename?: 'User', id: string } } | null };

export type UpdateSailthruVarsMutationVariables = Exact<{
  email: Scalars['String']['input'];
  varsData: Array<SailthruVarsInput> | SailthruVarsInput;
}>;


export type UpdateSailthruVarsMutation = { __typename?: 'Mutation', updateSailthruVarsMutation?: { __typename?: 'UpdateSailthruVarsMutationPayload', success: boolean } | null };

export type UpdateUserMutationVariables = Exact<{
  industryId?: InputMaybe<Scalars['Int']['input']>;
  bornOn?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUserMutation?: { __typename?: 'UpdateUserMutationPayload', viewer: { __typename?: 'User', id: string } } | null };

export type UserInformationChatQueryVariables = Exact<{ [key: string]: never; }>;


export type UserInformationChatQuery = { __typename?: 'Query', viewer?: { __typename?: 'User', id: string, primaryEmailAddress?: string | null, name: { __typename?: 'UserName', full?: string | null, first?: string | null, last?: string | null } } | null };

export type EndCardPlaylistQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type EndCardPlaylistQuery = { __typename?: 'Query', playlist?: { __typename?: 'Playlist', id: string, videos: { __typename?: 'VideoConnection', nodes?: Array<{ __typename?: 'Video', id: string, title: string, slug?: string | null, primaryImageSet?: Array<{ __typename?: 'PhotoSize', url?: string | null, aspectRatioName?: string | null }> | null } | null> | null } } | null };

export type EndCardRelatedQueryVariables = Exact<{
  id?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  isPublished?: InputMaybe<Array<Scalars['Boolean']['input']> | Scalars['Boolean']['input']>;
}>;


export type EndCardRelatedQuery = { __typename?: 'Query', videos?: { __typename?: 'VideoConnection', nodes?: Array<{ __typename?: 'Video', id: string, relatedVideos: Array<{ __typename?: 'Video', id: string, title: string, slug?: string | null, primaryImageSet?: Array<{ __typename?: 'PhotoSize', url?: string | null, aspectRatioName?: string | null }> | null }> } | null> | null } | null };

export type EventsDashboardQueryVariables = Exact<{ [key: string]: never; }>;


export type EventsDashboardQuery = { __typename?: 'Query', viewer?: { __typename?: 'User', isMember: boolean, hasMembersMightyNetworkAccess: boolean, id: string, primaryEmailAddress?: string | null, name: { __typename?: 'UserName', full?: string | null, first?: string | null, last?: string | null } } | null, membershipEvents?: Array<{ __typename?: 'MembershipEvent', endAt: any, beginAt: any, id: string, isRegistered: boolean, isSoldOut: boolean, timezoneName: string, title: string, membershipEventSessions: Array<{ __typename?: 'MembershipEventSession', beginAt: any, description: string, endAt: any, eventId: string, id: string, sessionFormatName: string, sessionSignupLabel: string, sessionSignupUrl: string, title: string, membershipEventSpeakers: Array<{ __typename?: 'MembershipEventSpeaker', id: string, avatar?: string | null, description: string, firstName: string, middleName: string, lastName: string, slug: string, speakerTalkTypeName: string, whatOthersSay?: string | null, whoTheyAre?: string | null, whyListen?: string | null }> }> }> | null };

export type FavoritesQueryVariables = Exact<{ [key: string]: never; }>;


export type FavoritesQuery = { __typename?: 'Query', viewer?: { __typename?: 'User', id: string, favorites?: { __typename?: 'FavoriteConnection', nodes?: Array<{ __typename?: 'Favorite', favoriteable?: { __typename?: 'Favoriteable', id: string } | null } | null> | null } | null } | null };

export type PlaylistsFeaturedSlotQueryVariables = Exact<{ [key: string]: never; }>;


export type PlaylistsFeaturedSlotQuery = { __typename?: 'Query', playlists?: { __typename?: 'PlaylistConnection', totalCount: number, nodes?: Array<{ __typename?: 'Playlist', id: string, slug: string } | null> | null } | null };

export type HistoryQueryVariables = Exact<{ [key: string]: never; }>;


export type HistoryQuery = { __typename?: 'Query', viewer?: { __typename?: 'User', id: string, activities?: { __typename?: 'ActivityConnection', nodes?: Array<{ __typename?: 'Activity', subjectId?: number | null } | null> | null } | null } | null };

export type HomePageDataQueryVariables = Exact<{
  trendingIds?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
}>;


export type HomePageDataQuery = { __typename?: 'Query', newestTalks?: { __typename?: 'VideoConnection', nodes?: Array<{ __typename?: 'Video', presenterDisplayName?: string | null, duration: number, videoContext: string, canonicalUrl: string, viewedCount: number, tedcomPercentage?: any | null, youtubePercentage?: any | null, podcastsPercentage?: any | null, tedappsPercentage?: any | null, publishedAt?: any | null, id: string, title: string, slug?: string | null, type: { __typename?: 'TypeOfVideo', name: string }, topics?: { __typename?: 'TopicConnection', nodes?: Array<{ __typename?: 'Topic', name?: string | null } | null> | null } | null, primaryImageSet?: Array<{ __typename?: 'PhotoSize', url?: string | null, aspectRatioName?: string | null }> | null } | null> | null } | null, trendingTalks?: { __typename?: 'VideoConnection', nodes?: Array<{ __typename?: 'Video', presenterDisplayName?: string | null, duration: number, videoContext: string, canonicalUrl: string, viewedCount: number, tedcomPercentage?: any | null, youtubePercentage?: any | null, podcastsPercentage?: any | null, tedappsPercentage?: any | null, publishedAt?: any | null, id: string, title: string, slug?: string | null, type: { __typename?: 'TypeOfVideo', name: string }, topics?: { __typename?: 'TopicConnection', nodes?: Array<{ __typename?: 'Topic', name?: string | null } | null> | null } | null, primaryImageSet?: Array<{ __typename?: 'PhotoSize', url?: string | null, aspectRatioName?: string | null }> | null } | null> | null } | null, platform?: { __typename?: 'Platform', ribbons?: { __typename?: 'RibbonConnection', nodes?: Array<{ __typename?: 'Ribbon', name?: string | null, sponsorLogo?: string | null, sponsorName?: string | null, sponsored?: boolean | null, live?: boolean | null, order?: number | null, slots?: { __typename?: 'SlotConnection', nodes?: Array<{ __typename?: 'Slot', title?: string | null, image?: string | null, link?: string | null, duration?: number | null, order?: number | null, video?: { __typename?: 'Video', description?: string | null, presenterDisplayName?: string | null, duration: number, videoContext: string, canonicalUrl: string, viewedCount: number, tedcomPercentage?: any | null, youtubePercentage?: any | null, podcastsPercentage?: any | null, tedappsPercentage?: any | null, publishedAt?: any | null, id: string, title: string, slug?: string | null, topics?: { __typename?: 'TopicConnection', nodes?: Array<{ __typename?: 'Topic', name?: string | null } | null> | null } | null, type: { __typename?: 'TypeOfVideo', name: string }, primaryImageSet?: Array<{ __typename?: 'PhotoSize', url?: string | null, aspectRatioName?: string | null }> | null } | null } | null> | null } | null } | null> | null } | null, pancakes?: { __typename?: 'PancakeConnection', nodes?: Array<{ __typename?: 'Pancake', playlists: { __typename?: 'PlaylistConnection', nodes?: Array<{ __typename?: 'Playlist', id: string, title: string, displayOrder: number, slug: string, primaryImageSet: Array<{ __typename?: 'PhotoSize', url?: string | null, aspectRatioName?: string | null }>, videos: { __typename?: 'VideoConnection', totalCount: number } } | null> | null } } | null> | null } | null, spotlightUnits?: { __typename?: 'SpotlightUnitConnection', nodes?: Array<{ __typename?: 'SpotlightUnit', id: string, position?: number | null, imageUrl?: string | null, content?: string | null, title?: string | null, published?: boolean | null, url?: string | null } | null> | null } | null } | null };

export type HomepageFeaturedVideoDataQueryVariables = Exact<{
  slug?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type HomepageFeaturedVideoDataQuery = { __typename?: 'Query', videos?: { __typename?: 'VideoConnection', nodes?: Array<{ __typename?: 'Video', description?: string | null, presenterDisplayName?: string | null, duration: number, videoContext: string, canonicalUrl: string, viewedCount: number, tedcomPercentage?: any | null, youtubePercentage?: any | null, podcastsPercentage?: any | null, tedappsPercentage?: any | null, publishedAt?: any | null, id: string, title: string, slug?: string | null, topics?: { __typename?: 'TopicConnection', nodes?: Array<{ __typename?: 'Topic', name?: string | null } | null> | null } | null, type: { __typename?: 'TypeOfVideo', name: string }, primaryImageSet?: Array<{ __typename?: 'PhotoSize', url?: string | null, aspectRatioName?: string | null }> | null } | null> | null } | null };

export type IdentityLanguagesQueryVariables = Exact<{ [key: string]: never; }>;


export type IdentityLanguagesQuery = { __typename?: 'Query', identityLanguages: Array<{ __typename?: 'IdentityLanguage', id: string, name: string }> };

export type IndustriesQueryVariables = Exact<{ [key: string]: never; }>;


export type IndustriesQuery = { __typename?: 'Query', industries: Array<{ __typename?: 'Industry', name?: string | null, id: string }> };

export type IsItemInYourLikesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type IsItemInYourLikesQuery = { __typename?: 'Query', doYouLikeItem?: { __typename?: 'LikedItem', id: string } | null };

export type IsItemInYourListQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type IsItemInYourListQuery = { __typename?: 'Query', yourListItem?: { __typename: 'YourListItem', id: string } | null };

export type IsPlaylistOnListQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type IsPlaylistOnListQuery = { __typename?: 'Query', yourListItem?: { __typename?: 'YourListItem', id: string, itemType: YourListItemType } | null };

export type LearningHubWatchedTalksQueryVariables = Exact<{ [key: string]: never; }>;


export type LearningHubWatchedTalksQuery = { __typename?: 'Query', viewer?: { __typename?: 'User', id: string, watchedTalks?: Array<{ __typename?: 'WatchedTalk', autoplayed?: boolean | null, secondsPlayed: number, talk: { __typename?: 'IdentityTalkType', id: string, slug: string, language: string, talkType: string, altheadline: string } }> | null } | null };

export type LearningHubCustomPlaylistVideosQueryVariables = Exact<{
  slug?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type LearningHubCustomPlaylistVideosQuery = { __typename?: 'Query', videos?: { __typename?: 'VideoConnection', nodes?: Array<{ __typename?: 'Video', presenterDisplayName?: string | null, duration: number, videoContext: string, canonicalUrl: string, viewedCount: number, tedcomPercentage?: any | null, youtubePercentage?: any | null, podcastsPercentage?: any | null, tedappsPercentage?: any | null, publishedAt?: any | null, id: string, title: string, slug?: string | null, learningProductTopic?: { __typename?: 'Topic', id: string, name?: string | null, slug?: string | null } | null, type: { __typename?: 'TypeOfVideo', name: string, id: string }, topics?: { __typename?: 'TopicConnection', nodes?: Array<{ __typename?: 'Topic', name?: string | null } | null> | null } | null, primaryImageSet?: Array<{ __typename?: 'PhotoSize', url?: string | null, aspectRatioName?: string | null }> | null } | null> | null } | null };

export type LearningHubDonutDataQueryVariables = Exact<{
  watchedBefore?: InputMaybe<Scalars['ISO8601Date']['input']>;
  watchedAfter?: InputMaybe<Scalars['ISO8601Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type LearningHubDonutDataQuery = { __typename?: 'Query', viewer?: { __typename?: 'User', id: string, watchedVideos?: { __typename?: 'VideoConnection', totalCount: number, edges?: Array<{ __typename?: 'VideoEdge', node?: { __typename?: 'Video', id: string, learningProductTopic?: { __typename?: 'Topic', id: string, name?: string | null, slug?: string | null } | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null } | null };

export type LearningHubSurpriseMeVideoQueryVariables = Exact<{
  id?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type LearningHubSurpriseMeVideoQuery = { __typename?: 'Query', videos?: { __typename?: 'VideoConnection', totalCount: number, edges?: Array<{ __typename?: 'VideoEdge', node?: { __typename?: 'Video', id: string, slug?: string | null, title: string, duration: number, viewedCount: number, presenterDisplayName?: string | null, recordedOn?: any | null, primaryImageSet?: Array<{ __typename?: 'PhotoSize', url?: string | null, aspectRatioName?: string | null }> | null, learningProductTopic?: { __typename?: 'Topic', id: string, name?: string | null, slug?: string | null } | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type LearningHubTopicsTakeawaysQueryVariables = Exact<{ [key: string]: never; }>;


export type LearningHubTopicsTakeawaysQuery = { __typename?: 'Query', viewer?: { __typename?: 'User', id: string, favorites?: { __typename?: 'FavoriteConnection', edges?: Array<{ __typename?: 'FavoriteEdge', node?: { __typename?: 'Favorite', id: string, favoriteable?: { __typename?: 'Favoriteable', type: string } | null, favoriteableEntity?: { __typename?: 'IdentityTalkType' } | { __typename?: 'Playlist' } | { __typename?: 'TalkTakeaway', id: string, text: string, talkstarTalkId: number, offsetSeconds: number } | { __typename?: 'User' } | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null } | null };

export type MembershipEmsQueryVariables = Exact<{ [key: string]: never; }>;


export type MembershipEmsQuery = { __typename?: 'Query', viewer?: { __typename?: 'User', id: string, isMember: boolean, name: { __typename?: 'UserName', full?: string | null } } | null, membershipEvents?: Array<{ __typename?: 'MembershipEvent', endAt: any, beginAt: any, id: string, isRegistered: boolean, isSoldOut: boolean, timezoneName: string, title: string, membershipEventSessions: Array<{ __typename?: 'MembershipEventSession', beginAt: any, description: string, endAt: any, eventId: string, id: string, sessionFormatName: string, sessionSignupLabel: string, sessionSignupUrl: string, title: string, membershipEventSpeakers: Array<{ __typename?: 'MembershipEventSpeaker', id: string, avatar?: string | null, description: string, firstName: string, middleName: string, lastName: string, slug: string, speakerTalkTypeName: string, whatOthersSay?: string | null, whoTheyAre?: string | null, whyListen?: string | null }> }> }> | null };

export type NavUserInformationQueryVariables = Exact<{ [key: string]: never; }>;


export type NavUserInformationQuery = { __typename?: 'Query', viewer?: { __typename?: 'User', isMember: boolean, id: string, primaryEmailAddress?: string | null, avatar: { __typename?: 'UserAvatar', url?: string | null, generatedUrl: string }, name: { __typename?: 'UserName', full?: string | null, first?: string | null, last?: string | null } } | null };

export type PlaylistVideosQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type PlaylistVideosQuery = { __typename?: 'Query', playlist?: { __typename?: 'Playlist', id: string, slug: string, title: string, description?: string | null, author: string, seasonNumber?: string | null, videos: { __typename?: 'VideoConnection', nodes?: Array<{ __typename?: 'Video', presenterDisplayName?: string | null, duration: number, videoContext: string, canonicalUrl: string, viewedCount: number, tedcomPercentage?: any | null, youtubePercentage?: any | null, podcastsPercentage?: any | null, tedappsPercentage?: any | null, publishedAt?: any | null, id: string, title: string, slug?: string | null, type: { __typename?: 'TypeOfVideo', name: string, id: string }, topics?: { __typename?: 'TopicConnection', nodes?: Array<{ __typename?: 'Topic', name?: string | null } | null> | null } | null, primaryImageSet?: Array<{ __typename?: 'PhotoSize', url?: string | null, aspectRatioName?: string | null }> | null } | null> | null }, primaryImageSet: Array<{ __typename?: 'PhotoSize', url?: string | null, aspectRatioName?: string | null }> } | null };

export type PlaylistsGridQueryVariables = Exact<{
  topics?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  curator?: InputMaybe<CuratorOptions>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type PlaylistsGridQuery = { __typename?: 'Query', playlists?: { __typename?: 'PlaylistConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean }, nodes?: Array<{ __typename?: 'Playlist', id: string, slug: string, title: string, description?: string | null, author: string, seasonNumber?: string | null, videos: { __typename?: 'VideoConnection', totalCount: number }, primaryImageSet: Array<{ __typename?: 'PhotoSize', url?: string | null, aspectRatioName?: string | null }> } | null> | null } | null };

export type PlaylistLandingDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PlaylistLandingDataQuery = { __typename?: 'Query', playlist?: { __typename?: 'Playlist', id: string, slug: string, title: string, description?: string | null, author: string, seasonNumber?: string | null, videos: { __typename?: 'VideoConnection', totalCount: number, nodes?: Array<{ __typename?: 'Video', presenterDisplayName?: string | null, duration: number, videoContext: string, canonicalUrl: string, viewedCount: number, tedcomPercentage?: any | null, youtubePercentage?: any | null, podcastsPercentage?: any | null, tedappsPercentage?: any | null, publishedAt?: any | null, id: string, title: string, slug?: string | null, type: { __typename?: 'TypeOfVideo', name: string }, topics?: { __typename?: 'TopicConnection', nodes?: Array<{ __typename?: 'Topic', name?: string | null } | null> | null } | null, primaryImageSet?: Array<{ __typename?: 'PhotoSize', url?: string | null, aspectRatioName?: string | null }> | null } | null> | null }, series?: { __typename?: 'Series', slug: string } | null, primaryImageSet: Array<{ __typename?: 'PhotoSize', url?: string | null, aspectRatioName?: string | null }> } | null };

export type PlaylistsLandingQueryVariables = Exact<{ [key: string]: never; }>;


export type PlaylistsLandingQuery = { __typename?: 'Query', featuredPlaylists?: { __typename?: 'PlaylistConnection', nodes?: Array<{ __typename?: 'Playlist', featuredSlotNumber?: number | null, id: string, slug: string, title: string, description?: string | null, author: string, seasonNumber?: string | null, videos: { __typename?: 'VideoConnection', totalCount: number }, primaryImageSet: Array<{ __typename?: 'PhotoSize', url?: string | null, aspectRatioName?: string | null }> } | null> | null } | null, topicList?: { __typename?: 'TopicListItemConnection', nodes?: Array<{ __typename?: 'TopicListItem', name?: string | null, slug?: string | null } | null> | null } | null };

export type PodcastDashboardQueryVariables = Exact<{ [key: string]: never; }>;


export type PodcastDashboardQuery = { __typename?: 'Query', viewer?: { __typename?: 'User', isMember: boolean, isSupporter: boolean, hasMembersMightyNetworkAccess: boolean, id: string, primaryEmailAddress?: string | null, name: { __typename?: 'UserName', full?: string | null, first?: string | null, last?: string | null } } | null };

export type GetRecommendationsSailthruHomePageQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
}>;


export type GetRecommendationsSailthruHomePageQuery = { __typename?: 'Query', videos?: { __typename?: 'VideoConnection', nodes?: Array<{ __typename?: 'Video', description?: string | null, socialTitle?: string | null, internalLanguageCode?: string | null, commentsEnabled?: boolean | null, commentsLoggedInOnly?: boolean | null, recordedOn?: any | null, curatorApproved?: boolean | null, socialDescription?: string | null, partnerName?: string | null, videoContext: string, audioInternalLanguageCode?: string | null, language?: string | null, hasTranslations: boolean, featured: boolean, presenterDisplayName?: string | null, duration: number, canonicalUrl: string, viewedCount: number, tedcomPercentage?: any | null, youtubePercentage?: any | null, podcastsPercentage?: any | null, tedappsPercentage?: any | null, publishedAt?: any | null, id: string, title: string, slug?: string | null, customContentDetails?: { __typename?: 'CustomContentDetails', partnerName?: string | null } | null, topics?: { __typename?: 'TopicConnection', nodes?: Array<{ __typename?: 'Topic', id: string, name?: string | null, slug?: string | null } | null> | null } | null, primaryImageSet?: Array<{ __typename?: 'PhotoSize', url?: string | null, aspectRatioName?: string | null }> | null } | null> | null } | null };

export type RedeemViewerQueryVariables = Exact<{ [key: string]: never; }>;


export type RedeemViewerQuery = { __typename?: 'Query', viewer?: { __typename?: 'User', isMember: boolean, id: string, primaryEmailAddress?: string | null, name: { __typename?: 'UserName', full?: string | null, first?: string | null, last?: string | null } } | null };

export type SailthruFallbackNewestQueryVariables = Exact<{ [key: string]: never; }>;


export type SailthruFallbackNewestQuery = { __typename?: 'Query', newestTalks?: { __typename?: 'VideoConnection', nodes?: Array<{ __typename?: 'Video', presenterDisplayName?: string | null, duration: number, viewedCount: number, publishedAt?: any | null, id: string, title: string, slug?: string | null, type: { __typename?: 'TypeOfVideo', name: string }, topics?: { __typename?: 'TopicConnection', nodes?: Array<{ __typename?: 'Topic', name?: string | null } | null> | null } | null, primaryImageSet?: Array<{ __typename?: 'PhotoSize', url?: string | null, aspectRatioName?: string | null }> | null } | null> | null } | null };

export type SailthruFallbackTrendingQueryVariables = Exact<{
  topicSlug: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SailthruFallbackTrendingQuery = { __typename?: 'Query', trendingTalks?: { __typename?: 'Topic', videos?: { __typename?: 'VideoConnection', nodes?: Array<{ __typename?: 'Video', presenterDisplayName?: string | null, duration: number, viewedCount: number, publishedAt?: any | null, id: string, title: string, slug?: string | null, type: { __typename?: 'TypeOfVideo', name: string }, topics?: { __typename?: 'TopicConnection', nodes?: Array<{ __typename?: 'Topic', name?: string | null } | null> | null } | null, primaryImageSet?: Array<{ __typename?: 'PhotoSize', url?: string | null, aspectRatioName?: string | null }> | null } | null> | null } | null } | null };

export type SailthruFallbackPodcastQueryVariables = Exact<{ [key: string]: never; }>;


export type SailthruFallbackPodcastQuery = { __typename?: 'Query', podcasts?: { __typename?: 'Topic', videos?: { __typename?: 'VideoConnection', nodes?: Array<{ __typename?: 'Video', presenterDisplayName?: string | null, duration: number, viewedCount: number, publishedAt?: any | null, id: string, title: string, slug?: string | null, type: { __typename?: 'TypeOfVideo', name: string }, topics?: { __typename?: 'TopicConnection', nodes?: Array<{ __typename?: 'Topic', name?: string | null } | null> | null } | null, primaryImageSet?: Array<{ __typename?: 'PhotoSize', url?: string | null, aspectRatioName?: string | null }> | null } | null> | null } | null } | null };

export type SailthruNewslettersQueryVariables = Exact<{ [key: string]: never; }>;


export type SailthruNewslettersQuery = { __typename?: 'Query', viewer?: { __typename?: 'User', id: string, primaryEmailAddress?: string | null, sailthruVars?: { __typename?: 'SailthruVars', vars?: { __typename?: 'SailthruUserVars', tedRecommendsNewsletterSubscriber?: string | null, tedTalksDailyNewsletterSubscriber?: string | null, tedEdWeeklyNewsletterSubscriber?: string | null, tedTalksTechNewsletterSubscriber?: string | null } | null } | null } | null };

export type SavedListQueryVariables = Exact<{ [key: string]: never; }>;


export type SavedListQuery = { __typename?: 'Query', viewer?: { __typename?: 'User', id: string, savedTalks?: { __typename?: 'PlaylistItemConnection', nodes?: Array<{ __typename?: 'PlaylistItem', itemId: number } | null> | null } | null, savedPlaylists?: Array<{ __typename?: 'Playlist', id: string, title: string, primaryImageSet: Array<{ __typename?: 'PhotoSize', url?: string | null }>, videos: { __typename?: 'VideoConnection', nodes?: Array<{ __typename?: 'Video', id: string } | null> | null } }> | null } | null };

export type SeriesQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
}>;


export type SeriesQuery = { __typename?: 'Query', series?: { __typename?: 'Series', id: string, name: string, publishedPlaylistCount: number, slug: string, playlists?: { __typename?: 'PlaylistConnection', nodes?: Array<{ __typename?: 'Playlist', id: string, slug: string, title: string, description?: string | null, author: string, seasonNumber?: string | null, videos: { __typename?: 'VideoConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, nodes?: Array<{ __typename?: 'Video', presenterDisplayName?: string | null, duration: number, videoContext: string, canonicalUrl: string, viewedCount: number, tedcomPercentage?: any | null, youtubePercentage?: any | null, podcastsPercentage?: any | null, tedappsPercentage?: any | null, publishedAt?: any | null, id: string, title: string, slug?: string | null, type: { __typename?: 'TypeOfVideo', name: string }, topics?: { __typename?: 'TopicConnection', nodes?: Array<{ __typename?: 'Topic', name?: string | null } | null> | null } | null, primaryImageSet?: Array<{ __typename?: 'PhotoSize', url?: string | null, aspectRatioName?: string | null }> | null } | null> | null }, primaryImageSet: Array<{ __typename?: 'PhotoSize', url?: string | null, aspectRatioName?: string | null }> } | null> | null } | null } | null };

export type SettingsDashboardQueryVariables = Exact<{ [key: string]: never; }>;


export type SettingsDashboardQuery = { __typename?: 'Query', viewer?: { __typename?: 'User', isMember: boolean, isGiftedMember: boolean, hasMembersMightyNetworkAccess: boolean, isSupporter: boolean, id: string, primaryEmailAddress?: string | null, giftMembership?: { __typename?: 'GiftMembership', createdAt: any, expiresAt: any, durationMonths?: number | null, redeemedAt: any } | null, membershipSubscription?: { __typename?: 'MembershipSubscription', id: string, transactionId: string, expiresAt: any, createdAt: any, skuId?: string | null, stripePrice?: string | null, isCancelled: boolean } | null, defaultPaymentMethod?: { __typename?: 'PaymentMethod', id: string, card?: { __typename?: 'Card', last4: string } | null } | null, paymentMethods?: Array<{ __typename?: 'PaymentMethod', id: string, card?: { __typename?: 'Card', brand: string, expYear: string, expMonth: string, last4: string } | null }> | null, name: { __typename?: 'UserName', full?: string | null, first?: string | null, last?: string | null } } | null };

export type ShareLinksQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
}>;


export type ShareLinksQuery = { __typename?: 'Query', videos?: { __typename?: 'VideoConnection', nodes?: Array<{ __typename?: 'Video', id: string, canonicalUrl: string, audioDownload?: any | null, nativeDownloads?: { __typename?: 'NativeDownloads', low?: any | null, medium?: any | null, high?: any | null } | null, subtitledDownloads: Array<{ __typename?: 'SubtitledDownload', low?: any | null, high?: any | null, internalLanguageCode: string, languageName: string }> } | null> | null } | null };

export type RelatedVideosQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
  count: Scalars['Int']['input'];
}>;


export type RelatedVideosQuery = { __typename?: 'Query', videos?: { __typename?: 'VideoConnection', nodes?: Array<{ __typename?: 'Video', relatedVideos: Array<{ __typename?: 'Video', presenterDisplayName?: string | null, duration: number, videoContext: string, canonicalUrl: string, viewedCount: number, tedcomPercentage?: any | null, youtubePercentage?: any | null, podcastsPercentage?: any | null, tedappsPercentage?: any | null, publishedAt?: any | null, id: string, title: string, slug?: string | null, topics?: { __typename?: 'TopicConnection', nodes?: Array<{ __typename?: 'Topic', name?: string | null } | null> | null } | null, primaryImageSet?: Array<{ __typename?: 'PhotoSize', url?: string | null, aspectRatioName?: string | null }> | null }> } | null> | null } | null };

export type SubtitleCreditsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  language: Scalars['String']['input'];
}>;


export type SubtitleCreditsQuery = { __typename?: 'Query', translation?: { __typename?: 'Translation', id: string, language?: { __typename?: 'AcmeLanguage', id: string, endonym?: string | null, englishName?: string | null, internalLanguageCode?: string | null, rtl: boolean } | null, reviewer?: { __typename?: 'User', id: string, profilePath?: any | null, avatar: { __typename?: 'UserAvatar', url?: string | null, generatedUrl: string }, name: { __typename?: 'UserName', full?: string | null } } | null, translator?: { __typename?: 'User', id: string, profilePath?: any | null, avatar: { __typename?: 'UserAvatar', url?: string | null, generatedUrl: string }, name: { __typename?: 'UserName', full?: string | null } } | null } | null };

export type SupportViewerQueryVariables = Exact<{ [key: string]: never; }>;


export type SupportViewerQuery = { __typename?: 'Query', viewer?: { __typename?: 'User', isMember: boolean, id: string, primaryEmailAddress?: string | null, name: { __typename?: 'UserName', full?: string | null, first?: string | null, last?: string | null } } | null };

export type TalkDetailsBySlugQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']['input']>;
}>;


export type TalkDetailsBySlugQuery = { __typename?: 'Query', video?: { __typename?: 'Video', playerData: any, description?: string | null, presenterDisplayName?: string | null, duration: number, videoContext: string, canonicalUrl: string, viewedCount: number, tedcomPercentage?: any | null, youtubePercentage?: any | null, podcastsPercentage?: any | null, tedappsPercentage?: any | null, publishedAt?: any | null, id: string, title: string, slug?: string | null, topics?: { __typename?: 'TopicConnection', nodes?: Array<{ __typename?: 'Topic', name?: string | null } | null> | null } | null, type: { __typename?: 'TypeOfVideo', name: string }, primaryImageSet?: Array<{ __typename?: 'PhotoSize', url?: string | null, aspectRatioName?: string | null }> | null } | null };

export type TalkDetailsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
}>;


export type TalkDetailsQuery = { __typename?: 'Query', video?: { __typename?: 'Video', id: string, title: string, description?: string | null } | null };

export type VideoSlugQueryVariables = Exact<{
  id?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  isPublished?: InputMaybe<Array<Scalars['Boolean']['input']> | Scalars['Boolean']['input']>;
}>;


export type VideoSlugQuery = { __typename?: 'Query', videos?: { __typename?: 'VideoConnection', nodes?: Array<{ __typename?: 'Video', id: string, slug?: string | null } | null> | null } | null };

export type TopicLandingDataQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  playlistsCount?: InputMaybe<Scalars['Int']['input']>;
  talksCount?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TopicLandingDataQuery = { __typename?: 'Query', topic?: { __typename?: 'Topic', id: string, name?: string | null, playlists?: { __typename?: 'PlaylistConnection', totalCount: number, nodes?: Array<{ __typename?: 'Playlist', id: string, slug: string, title: string, description?: string | null, author: string, seasonNumber?: string | null, videos: { __typename?: 'VideoConnection', totalCount: number }, primaryImageSet: Array<{ __typename?: 'PhotoSize', url?: string | null, aspectRatioName?: string | null }> } | null> | null } | null, videos?: { __typename?: 'VideoConnection', totalCount: number, nodes?: Array<{ __typename?: 'Video', presenterDisplayName?: string | null, duration: number, videoContext: string, canonicalUrl: string, viewedCount: number, tedcomPercentage?: any | null, youtubePercentage?: any | null, podcastsPercentage?: any | null, tedappsPercentage?: any | null, publishedAt?: any | null, id: string, title: string, slug?: string | null, type: { __typename?: 'TypeOfVideo', name: string }, topics?: { __typename?: 'TopicConnection', nodes?: Array<{ __typename?: 'Topic', name?: string | null } | null> | null } | null, primaryImageSet?: Array<{ __typename?: 'PhotoSize', url?: string | null, aspectRatioName?: string | null }> | null } | null> | null } | null } | null };

export type TopicListQueryVariables = Exact<{ [key: string]: never; }>;


export type TopicListQuery = { __typename?: 'Query', topicList?: { __typename?: 'TopicListItemConnection', nodes?: Array<{ __typename?: 'TopicListItem', name?: string | null, slug?: string | null } | null> | null } | null };

export type TranscriptQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  language: Scalars['String']['input'];
}>;


export type TranscriptQuery = { __typename?: 'Query', translation?: { __typename?: 'Translation', id: string, paragraphs: Array<{ __typename?: 'Paragraph', cues: Array<{ __typename?: 'Cue', text: string, time: number }> }>, language?: { __typename?: 'AcmeLanguage', id: string, endonym?: string | null, englishName?: string | null, internalLanguageCode?: string | null, rtl: boolean } | null, reviewer?: { __typename?: 'User', id: string, profilePath?: any | null, avatar: { __typename?: 'UserAvatar', url?: string | null, generatedUrl: string }, name: { __typename?: 'UserName', full?: string | null } } | null, translator?: { __typename?: 'User', id: string, profilePath?: any | null, avatar: { __typename?: 'UserAvatar', url?: string | null, generatedUrl: string }, name: { __typename?: 'UserName', full?: string | null } } | null } | null, video?: { __typename?: 'Video', id: string, talkExtras: { __typename?: 'TalkExtras', footnotes: Array<{ __typename?: 'Footnote', author?: string | null, annotation?: string | null, date?: string | null, linkUrl?: any | null, source?: string | null, text?: string | null, timecode?: string | null, title?: string | null, category?: string | null }> } } | null };

export type UserAccountInterestsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserAccountInterestsQuery = { __typename?: 'Query', viewer?: { __typename?: 'User', id: string, bornOn?: any | null, primaryEmailAddress?: string | null, preferredLanguage?: { __typename?: 'PreferredUserLanguage', id: string, name: string } | null, industry?: { __typename?: 'Industry', id: string, name?: string | null } | null, sailthruVars?: { __typename?: 'SailthruVars', vars?: { __typename?: 'SailthruUserVars', tedRecommendsNewsletterSubscriber?: string | null, tedTalksDailyNewsletterSubscriber?: string | null, tedEdDailyNewsletterSubscriber?: string | null, tedEdWeeklyNewsletterSubscriber?: string | null, countdownNewsletterSubscriber?: string | null, tedTalksTechNewsletterSubscriber?: string | null, supertopicArtAndDesign?: string | null, supertopicBusiness?: string | null, supertopicClimateChange?: string | null, supertopicEducation?: string | null, supertopicHealth?: string | null, supertopicMusicAndPerformance?: string | null, supertopicNature?: string | null, supertopicPersonalGrowth?: string | null, supertopicPsychology?: string | null, supertopicScience?: string | null, supertopicSocietyAndCulture?: string | null, supertopicSurpriseMe?: string | null, supertopicTechnology?: string | null, tedUpdatesSubscriber?: string | null, tedUpdatesConferences?: string | null, tedUpdatesOnlineEvents?: string | null, tedUpdatesImpact?: string | null, tedUpdatesSupport?: string | null } | null } | null } | null };

export type VideoDataQueryVariables = Exact<{
  id?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  slug?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  isPublished?: InputMaybe<Array<Scalars['Boolean']['input']> | Scalars['Boolean']['input']>;
}>;


export type VideoDataQuery = { __typename?: 'Query', videos?: { __typename?: 'VideoConnection', nodes?: Array<{ __typename?: 'Video', playerData: any, description?: string | null, socialTitle?: string | null, internalLanguageCode?: string | null, commentsEnabled?: boolean | null, commentsLoggedInOnly?: boolean | null, recordedOn?: any | null, curatorApproved?: boolean | null, socialDescription?: string | null, partnerName?: string | null, videoContext: string, audioInternalLanguageCode?: string | null, language?: string | null, hasTranslations: boolean, featured: boolean, presenterDisplayName?: string | null, duration: number, canonicalUrl: string, viewedCount: number, tedcomPercentage?: any | null, youtubePercentage?: any | null, podcastsPercentage?: any | null, tedappsPercentage?: any | null, publishedAt?: any | null, id: string, title: string, slug?: string | null, takeaways?: { __typename?: 'TalkTakeawayConnection', nodes?: Array<{ __typename?: 'TalkTakeaway', id: string, text: string, talkstarTalkId: number, offsetSeconds: number } | null> | null } | null, talkExtras: { __typename?: 'TalkExtras', learnModules: Array<{ __typename?: 'LearnModule', author?: string | null, blurb?: string | null, eyebrow?: string | null, headline?: string | null, imageUrl?: any | null, linkUrl?: any | null, published: boolean, publisher?: string | null, status: ExtraStatus, type: LearnModuleTypes, visibleUrl?: string | null, year?: string | null }>, takeAction: Array<{ __typename?: 'TakeActionModule', blurb?: string | null, endAt?: any | null, eyebrow?: string | null, linkUrl?: any | null, published: boolean, startAt?: any | null, status: ExtraStatus, verb: string, visibleUrl?: string | null }>, recommendations: Array<{ __typename?: 'Recommendation', blurb: string, recLists: Array<{ __typename?: 'RecommendationList', title: string, description: string, recItems: Array<{ __typename?: 'RecommendationItem', blurb: string, eyebrow?: string | null, headline: string, isPdf: boolean, label: RecItemLabel, linkUrl: string, note?: string | null }> }> }> }, relatedVideos: Array<{ __typename?: 'Video', slug?: string | null, id: string }>, speakers?: { __typename?: 'AcmeSpeakerConnection', nodes?: Array<{ __typename?: 'AcmeSpeaker', photoUrl?: string | null, firstname?: string | null, middlename?: string | null, lastname?: string | null, description?: string | null, isLive?: boolean | null, title?: string | null, whatOthersSay?: string | null, whoTheyAre?: string | null, whyListen?: string | null, slug?: string | null } | null> | null } | null, type: { __typename?: 'TypeOfVideo', id: string, name: string }, customContentDetails?: { __typename?: 'CustomContentDetails', partnerName?: string | null } | null, topics?: { __typename?: 'TopicConnection', nodes?: Array<{ __typename?: 'Topic', id: string, name?: string | null, slug?: string | null } | null> | null } | null, primaryImageSet?: Array<{ __typename?: 'PhotoSize', url?: string | null, aspectRatioName?: string | null }> | null } | null> | null } | null };

export type VideosByIdQueryVariables = Exact<{
  id?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
}>;


export type VideosByIdQuery = { __typename?: 'Query', videos?: { __typename?: 'VideoConnection', edges?: Array<{ __typename?: 'VideoEdge', node?: { __typename?: 'Video', description?: string | null, presenterDisplayName?: string | null, duration: number, videoContext: string, canonicalUrl: string, viewedCount: number, tedcomPercentage?: any | null, youtubePercentage?: any | null, podcastsPercentage?: any | null, tedappsPercentage?: any | null, publishedAt?: any | null, id: string, title: string, slug?: string | null, topics?: { __typename?: 'TopicConnection', nodes?: Array<{ __typename?: 'Topic', name?: string | null } | null> | null } | null, primaryImageSet?: Array<{ __typename?: 'PhotoSize', url?: string | null, aspectRatioName?: string | null }> | null } | null } | null> | null } | null };

export type VideosQueryVariables = Exact<{
  id?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type VideosQuery = { __typename?: 'Query', videos?: { __typename?: 'VideoConnection', totalCount: number, edges?: Array<{ __typename?: 'VideoEdge', cursor: string, node?: { __typename?: 'Video', presenterDisplayName?: string | null, duration: number, videoContext: string, canonicalUrl: string, viewedCount: number, tedcomPercentage?: any | null, youtubePercentage?: any | null, podcastsPercentage?: any | null, tedappsPercentage?: any | null, publishedAt?: any | null, id: string, title: string, slug?: string | null, type: { __typename?: 'TypeOfVideo', name: string }, speakers?: { __typename?: 'AcmeSpeakerConnection', nodes?: Array<{ __typename?: 'AcmeSpeaker', firstname?: string | null, middlename?: string | null, lastname?: string | null } | null> | null } | null, topics?: { __typename?: 'TopicConnection', nodes?: Array<{ __typename?: 'Topic', name?: string | null } | null> | null } | null, primaryImageSet?: Array<{ __typename?: 'PhotoSize', url?: string | null, aspectRatioName?: string | null }> | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type VideosBySlugQueryVariables = Exact<{
  id?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  slug?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  isPublished?: InputMaybe<Array<Scalars['Boolean']['input']> | Scalars['Boolean']['input']>;
}>;


export type VideosBySlugQuery = { __typename?: 'Query', videos?: { __typename?: 'VideoConnection', nodes?: Array<{ __typename?: 'Video', description?: string | null, socialTitle?: string | null, internalLanguageCode?: string | null, commentsEnabled?: boolean | null, commentsLoggedInOnly?: boolean | null, recordedOn?: any | null, curatorApproved?: boolean | null, socialDescription?: string | null, partnerName?: string | null, videoContext: string, audioInternalLanguageCode?: string | null, language?: string | null, hasTranslations: boolean, featured: boolean, presenterDisplayName?: string | null, duration: number, canonicalUrl: string, viewedCount: number, tedcomPercentage?: any | null, youtubePercentage?: any | null, podcastsPercentage?: any | null, tedappsPercentage?: any | null, publishedAt?: any | null, id: string, title: string, slug?: string | null, speakers?: { __typename?: 'AcmeSpeakerConnection', nodes?: Array<{ __typename?: 'AcmeSpeaker', photoUrl?: string | null, firstname?: string | null, middlename?: string | null, lastname?: string | null, description?: string | null, isLive?: boolean | null, title?: string | null, whatOthersSay?: string | null, whoTheyAre?: string | null, whyListen?: string | null, slug?: string | null } | null> | null } | null, type: { __typename?: 'TypeOfVideo', id: string, name: string }, customContentDetails?: { __typename?: 'CustomContentDetails', partnerName?: string | null } | null, topics?: { __typename?: 'TopicConnection', nodes?: Array<{ __typename?: 'Topic', id: string, name?: string | null, slug?: string | null } | null> | null } | null, primaryImageSet?: Array<{ __typename?: 'PhotoSize', url?: string | null, aspectRatioName?: string | null }> | null } | null> | null } | null };

export type TakeawaysViewerDataQueryVariables = Exact<{
  filter?: InputMaybe<FavoritesFilter>;
  order?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type TakeawaysViewerDataQuery = { __typename?: 'Query', viewer?: { __typename?: 'User', id: string, favorites?: { __typename?: 'FavoriteConnection', edges?: Array<{ __typename?: 'FavoriteEdge', cursor: string, node?: { __typename?: 'Favorite', id: string, favoriteable?: { __typename?: 'Favoriteable', id: string, type: string } | null, favoriteableEntity?: { __typename?: 'IdentityTalkType' } | { __typename?: 'Playlist' } | { __typename?: 'TalkTakeaway', id: string, text: string, talkstarTalkId: number, offsetSeconds: number, videos: { __typename?: 'VideoConnection', nodes?: Array<{ __typename?: 'Video', title: string, slug?: string | null, recordedOn?: any | null, language?: string | null, duration: number, presenterDisplayName?: string | null, primaryImageSet?: Array<{ __typename?: 'PhotoSize', url?: string | null, aspectRatioName?: string | null }> | null, topics?: { __typename?: 'TopicConnection', nodes?: Array<{ __typename?: 'Topic', id: string, name?: string | null, slug?: string | null } | null> | null } | null, speakers?: { __typename?: 'AcmeSpeakerConnection', nodes?: Array<{ __typename?: 'AcmeSpeaker', photoUrl?: string | null, firstname?: string | null, middlename?: string | null, lastname?: string | null, description?: string | null, isLive?: boolean | null, title?: string | null, whatOthersSay?: string | null, whoTheyAre?: string | null, whyListen?: string | null, slug?: string | null } | null> | null } | null, learningProductTopic?: { __typename?: 'Topic', id: string, name?: string | null, slug?: string | null } | null } | null> | null } } | { __typename?: 'User' } | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, endCursor?: string | null } } | null } | null };

export type TakeawaysViewerQueryVariables = Exact<{
  order?: InputMaybe<Scalars['String']['input']>;
}>;


export type TakeawaysViewerQuery = { __typename?: 'Query', viewer?: { __typename?: 'User', id: string, favorites?: { __typename?: 'FavoriteConnection', nodes?: Array<{ __typename?: 'Favorite', id: string, favoriteable?: { __typename?: 'Favoriteable', id: string, type: string } | null } | null> | null } | null } | null };

export type GetWatchedVideosCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWatchedVideosCountQuery = { __typename?: 'Query', viewer?: { __typename?: 'User', id: string, primaryEmailAddress?: string | null, watchedVideos?: { __typename?: 'VideoConnection', totalCount: number } | null } | null };

export const LearningProductTopicFragmentDoc = gql`
    fragment LearningProductTopic on Video {
  learningProductTopic {
    id
    name
    slug
  }
}
    `;
export const SpeakerInfoFragmentDoc = gql`
    fragment SpeakerInfo on AcmeSpeaker {
  photoUrl
  firstname
  middlename
  lastname
  description
  isLive
  title
  whatOthersSay
  whoTheyAre
  whyListen
  slug
}
    `;
export const FavoriteNodeFragmentDoc = gql`
    fragment FavoriteNode on Favorite {
  id
  favoriteable {
    id
    type
  }
  favoriteableEntity {
    ... on TalkTakeaway {
      id
      text
      talkstarTalkId
      offsetSeconds
      videos {
        nodes {
          title
          slug
          primaryImageSet {
            url
            aspectRatioName
          }
          recordedOn
          language
          duration
          presenterDisplayName
          topics {
            nodes {
              id
              name
              slug
            }
          }
          ...LearningProductTopic
          speakers {
            nodes {
              ...SpeakerInfo
            }
          }
        }
      }
    }
  }
}
    ${LearningProductTopicFragmentDoc}
${SpeakerInfoFragmentDoc}`;
export const BasicVideoInfoFragmentDoc = gql`
    fragment BasicVideoInfo on Video {
  id
  title
  slug
  primaryImageSet {
    url
    aspectRatioName
  }
}
    `;
export const VideoInfoFragmentDoc = gql`
    fragment VideoInfo on Video {
  ...BasicVideoInfo
  presenterDisplayName
  duration
  videoContext
  canonicalUrl
  viewedCount
  tedcomPercentage
  youtubePercentage
  podcastsPercentage
  tedappsPercentage
  publishedAt
  topics {
    nodes {
      name
    }
  }
}
    ${BasicVideoInfoFragmentDoc}`;
export const FullVideoInfoFragmentDoc = gql`
    fragment FullVideoInfo on Video {
  ...VideoInfo
  description
  socialTitle
  internalLanguageCode
  commentsEnabled
  commentsLoggedInOnly
  recordedOn
  curatorApproved
  socialDescription
  partnerName
  videoContext
  audioInternalLanguageCode
  language
  hasTranslations
  featured
  customContentDetails {
    partnerName
  }
  topics {
    nodes {
      id
      name
      slug
    }
  }
}
    ${VideoInfoFragmentDoc}`;
export const PlaylistInfoFragmentDoc = gql`
    fragment PlaylistInfo on Playlist {
  id
  slug
  title
  description
  author
  seasonNumber
  primaryImageSet {
    url
    aspectRatioName
  }
}
    `;
export const SailthruInfoFragmentDoc = gql`
    fragment SailthruInfo on Video {
  ...BasicVideoInfo
  presenterDisplayName
  duration
  viewedCount
  publishedAt
  topics {
    nodes {
      name
    }
  }
}
    ${BasicVideoInfoFragmentDoc}`;
export const TopicInfoFragmentDoc = gql`
    fragment TopicInfo on Topic {
  id
  name
  slug
}
    `;
export const TranslationInfoFragmentDoc = gql`
    fragment TranslationInfo on Translation {
  id
  language {
    id
    endonym
    englishName
    internalLanguageCode
    rtl
  }
  reviewer {
    id
    profilePath
    avatar {
      url
      generatedUrl(type: SVG)
    }
    name {
      full
    }
  }
  translator {
    id
    profilePath
    avatar {
      url
      generatedUrl(type: SVG)
    }
    name {
      full
    }
  }
}
    `;
export const UserInfoFragmentDoc = gql`
    fragment UserInfo on User {
  id
  primaryEmailAddress
  name {
    full
    first
    last
  }
}
    `;
export const AddPaymentMethodDocument = gql`
    mutation addPaymentMethod($paymentMethodId: String!) {
  addPaymentMethod(paymentMethodId: $paymentMethodId, makeDefault: true) {
    status
  }
}
    `;
export type AddPaymentMethodMutationFn = Apollo.MutationFunction<AddPaymentMethodMutation, AddPaymentMethodMutationVariables>;

/**
 * __useAddPaymentMethodMutation__
 *
 * To run a mutation, you first call `useAddPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPaymentMethodMutation, { data, loading, error }] = useAddPaymentMethodMutation({
 *   variables: {
 *      paymentMethodId: // value for 'paymentMethodId'
 *   },
 * });
 */
export function useAddPaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<AddPaymentMethodMutation, AddPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPaymentMethodMutation, AddPaymentMethodMutationVariables>(AddPaymentMethodDocument, options);
      }
export type AddPaymentMethodMutationHookResult = ReturnType<typeof useAddPaymentMethodMutation>;
export type AddPaymentMethodMutationResult = Apollo.MutationResult<AddPaymentMethodMutation>;
export type AddPaymentMethodMutationOptions = Apollo.BaseMutationOptions<AddPaymentMethodMutation, AddPaymentMethodMutationVariables>;
export const AddWatchedTalkDocument = gql`
    mutation addWatchedTalk($talkInput: WatchedTalkInput!) {
  addWatchedTalk(talkInput: $talkInput) {
    success
  }
}
    `;
export type AddWatchedTalkMutationFn = Apollo.MutationFunction<AddWatchedTalkMutation, AddWatchedTalkMutationVariables>;

/**
 * __useAddWatchedTalkMutation__
 *
 * To run a mutation, you first call `useAddWatchedTalkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddWatchedTalkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addWatchedTalkMutation, { data, loading, error }] = useAddWatchedTalkMutation({
 *   variables: {
 *      talkInput: // value for 'talkInput'
 *   },
 * });
 */
export function useAddWatchedTalkMutation(baseOptions?: Apollo.MutationHookOptions<AddWatchedTalkMutation, AddWatchedTalkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddWatchedTalkMutation, AddWatchedTalkMutationVariables>(AddWatchedTalkDocument, options);
      }
export type AddWatchedTalkMutationHookResult = ReturnType<typeof useAddWatchedTalkMutation>;
export type AddWatchedTalkMutationResult = Apollo.MutationResult<AddWatchedTalkMutation>;
export type AddWatchedTalkMutationOptions = Apollo.BaseMutationOptions<AddWatchedTalkMutation, AddWatchedTalkMutationVariables>;
export const CancelMembershipEventRegistrationDocument = gql`
    mutation cancelMembershipEventRegistration($id: ID!) {
  cancelMembershipEventRegistration(id: $id) {
    membershipEvent {
      id
    }
  }
}
    `;
export type CancelMembershipEventRegistrationMutationFn = Apollo.MutationFunction<CancelMembershipEventRegistrationMutation, CancelMembershipEventRegistrationMutationVariables>;

/**
 * __useCancelMembershipEventRegistrationMutation__
 *
 * To run a mutation, you first call `useCancelMembershipEventRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelMembershipEventRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelMembershipEventRegistrationMutation, { data, loading, error }] = useCancelMembershipEventRegistrationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelMembershipEventRegistrationMutation(baseOptions?: Apollo.MutationHookOptions<CancelMembershipEventRegistrationMutation, CancelMembershipEventRegistrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelMembershipEventRegistrationMutation, CancelMembershipEventRegistrationMutationVariables>(CancelMembershipEventRegistrationDocument, options);
      }
export type CancelMembershipEventRegistrationMutationHookResult = ReturnType<typeof useCancelMembershipEventRegistrationMutation>;
export type CancelMembershipEventRegistrationMutationResult = Apollo.MutationResult<CancelMembershipEventRegistrationMutation>;
export type CancelMembershipEventRegistrationMutationOptions = Apollo.BaseMutationOptions<CancelMembershipEventRegistrationMutation, CancelMembershipEventRegistrationMutationVariables>;
export const CancelSupporterDocument = gql`
    mutation CancelSupporter($subscriptionId: ID!, $additionalComments: String, $email: String!, $name: String!, $paymentAmount: String!, $paymentInterval: String!, $reason: String!) {
  cancelStripeSupporterSubscription(
    subscriptionId: $subscriptionId
    additionalComments: $additionalComments
    email: $email
    name: $name
    paymentAmount: $paymentAmount
    paymentInterval: $paymentInterval
    reason: $reason
  ) {
    success
  }
}
    `;
export type CancelSupporterMutationFn = Apollo.MutationFunction<CancelSupporterMutation, CancelSupporterMutationVariables>;

/**
 * __useCancelSupporterMutation__
 *
 * To run a mutation, you first call `useCancelSupporterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelSupporterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelSupporterMutation, { data, loading, error }] = useCancelSupporterMutation({
 *   variables: {
 *      subscriptionId: // value for 'subscriptionId'
 *      additionalComments: // value for 'additionalComments'
 *      email: // value for 'email'
 *      name: // value for 'name'
 *      paymentAmount: // value for 'paymentAmount'
 *      paymentInterval: // value for 'paymentInterval'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useCancelSupporterMutation(baseOptions?: Apollo.MutationHookOptions<CancelSupporterMutation, CancelSupporterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelSupporterMutation, CancelSupporterMutationVariables>(CancelSupporterDocument, options);
      }
export type CancelSupporterMutationHookResult = ReturnType<typeof useCancelSupporterMutation>;
export type CancelSupporterMutationResult = Apollo.MutationResult<CancelSupporterMutation>;
export type CancelSupporterMutationOptions = Apollo.BaseMutationOptions<CancelSupporterMutation, CancelSupporterMutationVariables>;
export const CreateOpenwebUserSessionDocument = gql`
    mutation createOpenwebUserSession($codeA: String!) {
  createOpenwebUserSession(codeA: $codeA) {
    codeB
  }
}
    `;
export type CreateOpenwebUserSessionMutationFn = Apollo.MutationFunction<CreateOpenwebUserSessionMutation, CreateOpenwebUserSessionMutationVariables>;

/**
 * __useCreateOpenwebUserSessionMutation__
 *
 * To run a mutation, you first call `useCreateOpenwebUserSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOpenwebUserSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOpenwebUserSessionMutation, { data, loading, error }] = useCreateOpenwebUserSessionMutation({
 *   variables: {
 *      codeA: // value for 'codeA'
 *   },
 * });
 */
export function useCreateOpenwebUserSessionMutation(baseOptions?: Apollo.MutationHookOptions<CreateOpenwebUserSessionMutation, CreateOpenwebUserSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOpenwebUserSessionMutation, CreateOpenwebUserSessionMutationVariables>(CreateOpenwebUserSessionDocument, options);
      }
export type CreateOpenwebUserSessionMutationHookResult = ReturnType<typeof useCreateOpenwebUserSessionMutation>;
export type CreateOpenwebUserSessionMutationResult = Apollo.MutationResult<CreateOpenwebUserSessionMutation>;
export type CreateOpenwebUserSessionMutationOptions = Apollo.BaseMutationOptions<CreateOpenwebUserSessionMutation, CreateOpenwebUserSessionMutationVariables>;
export const CreateSupporterDocument = gql`
    mutation CreateSupporter($paymentMethodId: ID, $priceAmountUsdCents: Int!, $sku: ID!, $email: String, $subscriptionMetadata: SubscriptionMetadata, $recaptchaToken: String!) {
  createStripeSupporterSubscription(
    paymentMethodId: $paymentMethodId
    priceAmountUsdCents: $priceAmountUsdCents
    sku: $sku
    email: $email
    subscriptionMetadata: $subscriptionMetadata
    recaptchaToken: $recaptchaToken
  ) {
    redemptionToken
  }
}
    `;
export type CreateSupporterMutationFn = Apollo.MutationFunction<CreateSupporterMutation, CreateSupporterMutationVariables>;

/**
 * __useCreateSupporterMutation__
 *
 * To run a mutation, you first call `useCreateSupporterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSupporterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSupporterMutation, { data, loading, error }] = useCreateSupporterMutation({
 *   variables: {
 *      paymentMethodId: // value for 'paymentMethodId'
 *      priceAmountUsdCents: // value for 'priceAmountUsdCents'
 *      sku: // value for 'sku'
 *      email: // value for 'email'
 *      subscriptionMetadata: // value for 'subscriptionMetadata'
 *      recaptchaToken: // value for 'recaptchaToken'
 *   },
 * });
 */
export function useCreateSupporterMutation(baseOptions?: Apollo.MutationHookOptions<CreateSupporterMutation, CreateSupporterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSupporterMutation, CreateSupporterMutationVariables>(CreateSupporterDocument, options);
      }
export type CreateSupporterMutationHookResult = ReturnType<typeof useCreateSupporterMutation>;
export type CreateSupporterMutationResult = Apollo.MutationResult<CreateSupporterMutation>;
export type CreateSupporterMutationOptions = Apollo.BaseMutationOptions<CreateSupporterMutation, CreateSupporterMutationVariables>;
export const PurchaseGiftMembershipDocument = gql`
    mutation PurchaseGiftMembership($cardTokenId: ID!, $recaptchaToken: String!, $senderEmail: String!, $senderLastName: String!, $senderFirstName: String!, $recipientEmail: String!, $recipientLastName: String!, $recipientFirstName: String!, $dateToSend: ISO8601DateTime!, $personalMessage: String, $giftMembershipMetadata: SubscriptionMetadata) {
  purchaseGiftMembership(
    cardTokenId: $cardTokenId
    recaptchaToken: $recaptchaToken
    senderEmail: $senderEmail
    senderLastName: $senderLastName
    senderFirstName: $senderFirstName
    recipientEmail: $recipientEmail
    recipientLastName: $recipientLastName
    recipientFirstName: $recipientFirstName
    dateToSend: $dateToSend
    personalMessage: $personalMessage
    giftMembershipMetadata: $giftMembershipMetadata
  ) {
    success
    giftMembershipToken
  }
}
    `;
export type PurchaseGiftMembershipMutationFn = Apollo.MutationFunction<PurchaseGiftMembershipMutation, PurchaseGiftMembershipMutationVariables>;

/**
 * __usePurchaseGiftMembershipMutation__
 *
 * To run a mutation, you first call `usePurchaseGiftMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePurchaseGiftMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [purchaseGiftMembershipMutation, { data, loading, error }] = usePurchaseGiftMembershipMutation({
 *   variables: {
 *      cardTokenId: // value for 'cardTokenId'
 *      recaptchaToken: // value for 'recaptchaToken'
 *      senderEmail: // value for 'senderEmail'
 *      senderLastName: // value for 'senderLastName'
 *      senderFirstName: // value for 'senderFirstName'
 *      recipientEmail: // value for 'recipientEmail'
 *      recipientLastName: // value for 'recipientLastName'
 *      recipientFirstName: // value for 'recipientFirstName'
 *      dateToSend: // value for 'dateToSend'
 *      personalMessage: // value for 'personalMessage'
 *      giftMembershipMetadata: // value for 'giftMembershipMetadata'
 *   },
 * });
 */
export function usePurchaseGiftMembershipMutation(baseOptions?: Apollo.MutationHookOptions<PurchaseGiftMembershipMutation, PurchaseGiftMembershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PurchaseGiftMembershipMutation, PurchaseGiftMembershipMutationVariables>(PurchaseGiftMembershipDocument, options);
      }
export type PurchaseGiftMembershipMutationHookResult = ReturnType<typeof usePurchaseGiftMembershipMutation>;
export type PurchaseGiftMembershipMutationResult = Apollo.MutationResult<PurchaseGiftMembershipMutation>;
export type PurchaseGiftMembershipMutationOptions = Apollo.BaseMutationOptions<PurchaseGiftMembershipMutation, PurchaseGiftMembershipMutationVariables>;
export const RedeemGiftMembershipDocument = gql`
    mutation RedeemGiftMembership($token: String!) {
  redeemGiftMembership(token: $token) {
    status
  }
}
    `;
export type RedeemGiftMembershipMutationFn = Apollo.MutationFunction<RedeemGiftMembershipMutation, RedeemGiftMembershipMutationVariables>;

/**
 * __useRedeemGiftMembershipMutation__
 *
 * To run a mutation, you first call `useRedeemGiftMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRedeemGiftMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [redeemGiftMembershipMutation, { data, loading, error }] = useRedeemGiftMembershipMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useRedeemGiftMembershipMutation(baseOptions?: Apollo.MutationHookOptions<RedeemGiftMembershipMutation, RedeemGiftMembershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RedeemGiftMembershipMutation, RedeemGiftMembershipMutationVariables>(RedeemGiftMembershipDocument, options);
      }
export type RedeemGiftMembershipMutationHookResult = ReturnType<typeof useRedeemGiftMembershipMutation>;
export type RedeemGiftMembershipMutationResult = Apollo.MutationResult<RedeemGiftMembershipMutation>;
export type RedeemGiftMembershipMutationOptions = Apollo.BaseMutationOptions<RedeemGiftMembershipMutation, RedeemGiftMembershipMutationVariables>;
export const RedeemSubscriptionRedemptionTokenDocument = gql`
    mutation RedeemSubscriptionRedemptionToken($token: String!) {
  redeemStripeSubscriptionToken(token: $token) {
    status
  }
}
    `;
export type RedeemSubscriptionRedemptionTokenMutationFn = Apollo.MutationFunction<RedeemSubscriptionRedemptionTokenMutation, RedeemSubscriptionRedemptionTokenMutationVariables>;

/**
 * __useRedeemSubscriptionRedemptionTokenMutation__
 *
 * To run a mutation, you first call `useRedeemSubscriptionRedemptionTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRedeemSubscriptionRedemptionTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [redeemSubscriptionRedemptionTokenMutation, { data, loading, error }] = useRedeemSubscriptionRedemptionTokenMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useRedeemSubscriptionRedemptionTokenMutation(baseOptions?: Apollo.MutationHookOptions<RedeemSubscriptionRedemptionTokenMutation, RedeemSubscriptionRedemptionTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RedeemSubscriptionRedemptionTokenMutation, RedeemSubscriptionRedemptionTokenMutationVariables>(RedeemSubscriptionRedemptionTokenDocument, options);
      }
export type RedeemSubscriptionRedemptionTokenMutationHookResult = ReturnType<typeof useRedeemSubscriptionRedemptionTokenMutation>;
export type RedeemSubscriptionRedemptionTokenMutationResult = Apollo.MutationResult<RedeemSubscriptionRedemptionTokenMutation>;
export type RedeemSubscriptionRedemptionTokenMutationOptions = Apollo.BaseMutationOptions<RedeemSubscriptionRedemptionTokenMutation, RedeemSubscriptionRedemptionTokenMutationVariables>;
export const RegisterMembershipEventDocument = gql`
    mutation registerMembershipEvent($id: ID!) {
  registerMembershipEvent(id: $id) {
    membershipEvent {
      id
    }
  }
}
    `;
export type RegisterMembershipEventMutationFn = Apollo.MutationFunction<RegisterMembershipEventMutation, RegisterMembershipEventMutationVariables>;

/**
 * __useRegisterMembershipEventMutation__
 *
 * To run a mutation, you first call `useRegisterMembershipEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterMembershipEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerMembershipEventMutation, { data, loading, error }] = useRegisterMembershipEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRegisterMembershipEventMutation(baseOptions?: Apollo.MutationHookOptions<RegisterMembershipEventMutation, RegisterMembershipEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterMembershipEventMutation, RegisterMembershipEventMutationVariables>(RegisterMembershipEventDocument, options);
      }
export type RegisterMembershipEventMutationHookResult = ReturnType<typeof useRegisterMembershipEventMutation>;
export type RegisterMembershipEventMutationResult = Apollo.MutationResult<RegisterMembershipEventMutation>;
export type RegisterMembershipEventMutationOptions = Apollo.BaseMutationOptions<RegisterMembershipEventMutation, RegisterMembershipEventMutationVariables>;
export const RemovePaymentMethodDocument = gql`
    mutation removePaymentMethod($paymentMethodId: String!) {
  removePaymentMethod(paymentMethodId: $paymentMethodId) {
    status
  }
}
    `;
export type RemovePaymentMethodMutationFn = Apollo.MutationFunction<RemovePaymentMethodMutation, RemovePaymentMethodMutationVariables>;

/**
 * __useRemovePaymentMethodMutation__
 *
 * To run a mutation, you first call `useRemovePaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePaymentMethodMutation, { data, loading, error }] = useRemovePaymentMethodMutation({
 *   variables: {
 *      paymentMethodId: // value for 'paymentMethodId'
 *   },
 * });
 */
export function useRemovePaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<RemovePaymentMethodMutation, RemovePaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePaymentMethodMutation, RemovePaymentMethodMutationVariables>(RemovePaymentMethodDocument, options);
      }
export type RemovePaymentMethodMutationHookResult = ReturnType<typeof useRemovePaymentMethodMutation>;
export type RemovePaymentMethodMutationResult = Apollo.MutationResult<RemovePaymentMethodMutation>;
export type RemovePaymentMethodMutationOptions = Apollo.BaseMutationOptions<RemovePaymentMethodMutation, RemovePaymentMethodMutationVariables>;
export const RemoveVideoFromYourLikesDocument = gql`
    mutation removeVideoFromYourLikes($id: ID!) {
  unlikeItem(id: $id) {
    errors
  }
}
    `;
export type RemoveVideoFromYourLikesMutationFn = Apollo.MutationFunction<RemoveVideoFromYourLikesMutation, RemoveVideoFromYourLikesMutationVariables>;

/**
 * __useRemoveVideoFromYourLikesMutation__
 *
 * To run a mutation, you first call `useRemoveVideoFromYourLikesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveVideoFromYourLikesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeVideoFromYourLikesMutation, { data, loading, error }] = useRemoveVideoFromYourLikesMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveVideoFromYourLikesMutation(baseOptions?: Apollo.MutationHookOptions<RemoveVideoFromYourLikesMutation, RemoveVideoFromYourLikesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveVideoFromYourLikesMutation, RemoveVideoFromYourLikesMutationVariables>(RemoveVideoFromYourLikesDocument, options);
      }
export type RemoveVideoFromYourLikesMutationHookResult = ReturnType<typeof useRemoveVideoFromYourLikesMutation>;
export type RemoveVideoFromYourLikesMutationResult = Apollo.MutationResult<RemoveVideoFromYourLikesMutation>;
export type RemoveVideoFromYourLikesMutationOptions = Apollo.BaseMutationOptions<RemoveVideoFromYourLikesMutation, RemoveVideoFromYourLikesMutationVariables>;
export const RemoveVideoFromYourListDocument = gql`
    mutation removeVideoFromYourList($id: ID!) {
  removeYourListItem(id: $id) {
    item {
      id
      itemId
    }
    errors
  }
}
    `;
export type RemoveVideoFromYourListMutationFn = Apollo.MutationFunction<RemoveVideoFromYourListMutation, RemoveVideoFromYourListMutationVariables>;

/**
 * __useRemoveVideoFromYourListMutation__
 *
 * To run a mutation, you first call `useRemoveVideoFromYourListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveVideoFromYourListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeVideoFromYourListMutation, { data, loading, error }] = useRemoveVideoFromYourListMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveVideoFromYourListMutation(baseOptions?: Apollo.MutationHookOptions<RemoveVideoFromYourListMutation, RemoveVideoFromYourListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveVideoFromYourListMutation, RemoveVideoFromYourListMutationVariables>(RemoveVideoFromYourListDocument, options);
      }
export type RemoveVideoFromYourListMutationHookResult = ReturnType<typeof useRemoveVideoFromYourListMutation>;
export type RemoveVideoFromYourListMutationResult = Apollo.MutationResult<RemoveVideoFromYourListMutation>;
export type RemoveVideoFromYourListMutationOptions = Apollo.BaseMutationOptions<RemoveVideoFromYourListMutation, RemoveVideoFromYourListMutationVariables>;
export const RenewSubscriptionTokenDocument = gql`
    mutation RenewSubscriptionToken($token: String!) {
  renewExpiredStripeSubscriptionToken(token: $token) {
    status
  }
}
    `;
export type RenewSubscriptionTokenMutationFn = Apollo.MutationFunction<RenewSubscriptionTokenMutation, RenewSubscriptionTokenMutationVariables>;

/**
 * __useRenewSubscriptionTokenMutation__
 *
 * To run a mutation, you first call `useRenewSubscriptionTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenewSubscriptionTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renewSubscriptionTokenMutation, { data, loading, error }] = useRenewSubscriptionTokenMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useRenewSubscriptionTokenMutation(baseOptions?: Apollo.MutationHookOptions<RenewSubscriptionTokenMutation, RenewSubscriptionTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenewSubscriptionTokenMutation, RenewSubscriptionTokenMutationVariables>(RenewSubscriptionTokenDocument, options);
      }
export type RenewSubscriptionTokenMutationHookResult = ReturnType<typeof useRenewSubscriptionTokenMutation>;
export type RenewSubscriptionTokenMutationResult = Apollo.MutationResult<RenewSubscriptionTokenMutation>;
export type RenewSubscriptionTokenMutationOptions = Apollo.BaseMutationOptions<RenewSubscriptionTokenMutation, RenewSubscriptionTokenMutationVariables>;
export const SaveVideoToYourLikesDocument = gql`
    mutation saveVideoToYourLikes($id: ID!) {
  likeItem(id: $id, itemType: VIDEO) {
    item {
      id
      itemId
    }
    errors
  }
}
    `;
export type SaveVideoToYourLikesMutationFn = Apollo.MutationFunction<SaveVideoToYourLikesMutation, SaveVideoToYourLikesMutationVariables>;

/**
 * __useSaveVideoToYourLikesMutation__
 *
 * To run a mutation, you first call `useSaveVideoToYourLikesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveVideoToYourLikesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveVideoToYourLikesMutation, { data, loading, error }] = useSaveVideoToYourLikesMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSaveVideoToYourLikesMutation(baseOptions?: Apollo.MutationHookOptions<SaveVideoToYourLikesMutation, SaveVideoToYourLikesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveVideoToYourLikesMutation, SaveVideoToYourLikesMutationVariables>(SaveVideoToYourLikesDocument, options);
      }
export type SaveVideoToYourLikesMutationHookResult = ReturnType<typeof useSaveVideoToYourLikesMutation>;
export type SaveVideoToYourLikesMutationResult = Apollo.MutationResult<SaveVideoToYourLikesMutation>;
export type SaveVideoToYourLikesMutationOptions = Apollo.BaseMutationOptions<SaveVideoToYourLikesMutation, SaveVideoToYourLikesMutationVariables>;
export const SaveVideoToYourListDocument = gql`
    mutation saveVideoToYourList($id: ID!, $secondsPlayed: Int!) {
  saveVideoToYourList(id: $id, secondsPlayed: $secondsPlayed) {
    errors
  }
}
    `;
export type SaveVideoToYourListMutationFn = Apollo.MutationFunction<SaveVideoToYourListMutation, SaveVideoToYourListMutationVariables>;

/**
 * __useSaveVideoToYourListMutation__
 *
 * To run a mutation, you first call `useSaveVideoToYourListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveVideoToYourListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveVideoToYourListMutation, { data, loading, error }] = useSaveVideoToYourListMutation({
 *   variables: {
 *      id: // value for 'id'
 *      secondsPlayed: // value for 'secondsPlayed'
 *   },
 * });
 */
export function useSaveVideoToYourListMutation(baseOptions?: Apollo.MutationHookOptions<SaveVideoToYourListMutation, SaveVideoToYourListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveVideoToYourListMutation, SaveVideoToYourListMutationVariables>(SaveVideoToYourListDocument, options);
      }
export type SaveVideoToYourListMutationHookResult = ReturnType<typeof useSaveVideoToYourListMutation>;
export type SaveVideoToYourListMutationResult = Apollo.MutationResult<SaveVideoToYourListMutation>;
export type SaveVideoToYourListMutationOptions = Apollo.BaseMutationOptions<SaveVideoToYourListMutation, SaveVideoToYourListMutationVariables>;
export const ToggleFavoritePlaylistDocument = gql`
    mutation toggleFavoritePlaylist($id: ID!, $shouldSaveForLater: Boolean) {
  toggleSavedPlaylist(shouldSaveForLater: $shouldSaveForLater, playlistId: $id) {
    updatedPlaylists {
      id
    }
  }
}
    `;
export type ToggleFavoritePlaylistMutationFn = Apollo.MutationFunction<ToggleFavoritePlaylistMutation, ToggleFavoritePlaylistMutationVariables>;

/**
 * __useToggleFavoritePlaylistMutation__
 *
 * To run a mutation, you first call `useToggleFavoritePlaylistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleFavoritePlaylistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleFavoritePlaylistMutation, { data, loading, error }] = useToggleFavoritePlaylistMutation({
 *   variables: {
 *      id: // value for 'id'
 *      shouldSaveForLater: // value for 'shouldSaveForLater'
 *   },
 * });
 */
export function useToggleFavoritePlaylistMutation(baseOptions?: Apollo.MutationHookOptions<ToggleFavoritePlaylistMutation, ToggleFavoritePlaylistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleFavoritePlaylistMutation, ToggleFavoritePlaylistMutationVariables>(ToggleFavoritePlaylistDocument, options);
      }
export type ToggleFavoritePlaylistMutationHookResult = ReturnType<typeof useToggleFavoritePlaylistMutation>;
export type ToggleFavoritePlaylistMutationResult = Apollo.MutationResult<ToggleFavoritePlaylistMutation>;
export type ToggleFavoritePlaylistMutationOptions = Apollo.BaseMutationOptions<ToggleFavoritePlaylistMutation, ToggleFavoritePlaylistMutationVariables>;
export const ToggleFavoriteDocument = gql`
    mutation toggleFavorite($favoriteInput: FavoriteInput!, $shouldFavorite: Boolean) {
  toggleFavorite(favoriteable: $favoriteInput, shouldFavorite: $shouldFavorite) {
    viewer {
      id
    }
  }
}
    `;
export type ToggleFavoriteMutationFn = Apollo.MutationFunction<ToggleFavoriteMutation, ToggleFavoriteMutationVariables>;

/**
 * __useToggleFavoriteMutation__
 *
 * To run a mutation, you first call `useToggleFavoriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleFavoriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleFavoriteMutation, { data, loading, error }] = useToggleFavoriteMutation({
 *   variables: {
 *      favoriteInput: // value for 'favoriteInput'
 *      shouldFavorite: // value for 'shouldFavorite'
 *   },
 * });
 */
export function useToggleFavoriteMutation(baseOptions?: Apollo.MutationHookOptions<ToggleFavoriteMutation, ToggleFavoriteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleFavoriteMutation, ToggleFavoriteMutationVariables>(ToggleFavoriteDocument, options);
      }
export type ToggleFavoriteMutationHookResult = ReturnType<typeof useToggleFavoriteMutation>;
export type ToggleFavoriteMutationResult = Apollo.MutationResult<ToggleFavoriteMutation>;
export type ToggleFavoriteMutationOptions = Apollo.BaseMutationOptions<ToggleFavoriteMutation, ToggleFavoriteMutationVariables>;
export const UpdateDefaultPaymentMethodDocument = gql`
    mutation updateDefaultPaymentMethod($paymentMethodId: String!) {
  updateDefaultPaymentMethod(paymentMethodId: $paymentMethodId) {
    status
  }
}
    `;
export type UpdateDefaultPaymentMethodMutationFn = Apollo.MutationFunction<UpdateDefaultPaymentMethodMutation, UpdateDefaultPaymentMethodMutationVariables>;

/**
 * __useUpdateDefaultPaymentMethodMutation__
 *
 * To run a mutation, you first call `useUpdateDefaultPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDefaultPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDefaultPaymentMethodMutation, { data, loading, error }] = useUpdateDefaultPaymentMethodMutation({
 *   variables: {
 *      paymentMethodId: // value for 'paymentMethodId'
 *   },
 * });
 */
export function useUpdateDefaultPaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDefaultPaymentMethodMutation, UpdateDefaultPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDefaultPaymentMethodMutation, UpdateDefaultPaymentMethodMutationVariables>(UpdateDefaultPaymentMethodDocument, options);
      }
export type UpdateDefaultPaymentMethodMutationHookResult = ReturnType<typeof useUpdateDefaultPaymentMethodMutation>;
export type UpdateDefaultPaymentMethodMutationResult = Apollo.MutationResult<UpdateDefaultPaymentMethodMutation>;
export type UpdateDefaultPaymentMethodMutationOptions = Apollo.BaseMutationOptions<UpdateDefaultPaymentMethodMutation, UpdateDefaultPaymentMethodMutationVariables>;
export const UpdatePreferredLanguageDocument = gql`
    mutation updatePreferredLanguage($languageId: Int!) {
  updatePreferredLanguage(languageId: $languageId) {
    viewer {
      id
    }
  }
}
    `;
export type UpdatePreferredLanguageMutationFn = Apollo.MutationFunction<UpdatePreferredLanguageMutation, UpdatePreferredLanguageMutationVariables>;

/**
 * __useUpdatePreferredLanguageMutation__
 *
 * To run a mutation, you first call `useUpdatePreferredLanguageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePreferredLanguageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePreferredLanguageMutation, { data, loading, error }] = useUpdatePreferredLanguageMutation({
 *   variables: {
 *      languageId: // value for 'languageId'
 *   },
 * });
 */
export function useUpdatePreferredLanguageMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePreferredLanguageMutation, UpdatePreferredLanguageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePreferredLanguageMutation, UpdatePreferredLanguageMutationVariables>(UpdatePreferredLanguageDocument, options);
      }
export type UpdatePreferredLanguageMutationHookResult = ReturnType<typeof useUpdatePreferredLanguageMutation>;
export type UpdatePreferredLanguageMutationResult = Apollo.MutationResult<UpdatePreferredLanguageMutation>;
export type UpdatePreferredLanguageMutationOptions = Apollo.BaseMutationOptions<UpdatePreferredLanguageMutation, UpdatePreferredLanguageMutationVariables>;
export const UpdateSailthruVarsDocument = gql`
    mutation updateSailthruVars($email: String!, $varsData: [SailthruVarsInput!]!) {
  updateSailthruVarsMutation(email: $email, varsData: $varsData) {
    success
  }
}
    `;
export type UpdateSailthruVarsMutationFn = Apollo.MutationFunction<UpdateSailthruVarsMutation, UpdateSailthruVarsMutationVariables>;

/**
 * __useUpdateSailthruVarsMutation__
 *
 * To run a mutation, you first call `useUpdateSailthruVarsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSailthruVarsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSailthruVarsMutation, { data, loading, error }] = useUpdateSailthruVarsMutation({
 *   variables: {
 *      email: // value for 'email'
 *      varsData: // value for 'varsData'
 *   },
 * });
 */
export function useUpdateSailthruVarsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSailthruVarsMutation, UpdateSailthruVarsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSailthruVarsMutation, UpdateSailthruVarsMutationVariables>(UpdateSailthruVarsDocument, options);
      }
export type UpdateSailthruVarsMutationHookResult = ReturnType<typeof useUpdateSailthruVarsMutation>;
export type UpdateSailthruVarsMutationResult = Apollo.MutationResult<UpdateSailthruVarsMutation>;
export type UpdateSailthruVarsMutationOptions = Apollo.BaseMutationOptions<UpdateSailthruVarsMutation, UpdateSailthruVarsMutationVariables>;
export const UpdateUserDocument = gql`
    mutation updateUser($industryId: Int, $bornOn: String) {
  updateUserMutation(industryId: $industryId, bornOn: $bornOn) {
    viewer {
      id
    }
  }
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      industryId: // value for 'industryId'
 *      bornOn: // value for 'bornOn'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const UserInformationChatDocument = gql`
    query userInformationChat {
  viewer {
    ...UserInfo
  }
}
    ${UserInfoFragmentDoc}`;

/**
 * __useUserInformationChatQuery__
 *
 * To run a query within a React component, call `useUserInformationChatQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserInformationChatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserInformationChatQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserInformationChatQuery(baseOptions?: Apollo.QueryHookOptions<UserInformationChatQuery, UserInformationChatQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserInformationChatQuery, UserInformationChatQueryVariables>(UserInformationChatDocument, options);
      }
export function useUserInformationChatLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserInformationChatQuery, UserInformationChatQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserInformationChatQuery, UserInformationChatQueryVariables>(UserInformationChatDocument, options);
        }
export function useUserInformationChatSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserInformationChatQuery, UserInformationChatQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserInformationChatQuery, UserInformationChatQueryVariables>(UserInformationChatDocument, options);
        }
export type UserInformationChatQueryHookResult = ReturnType<typeof useUserInformationChatQuery>;
export type UserInformationChatLazyQueryHookResult = ReturnType<typeof useUserInformationChatLazyQuery>;
export type UserInformationChatSuspenseQueryHookResult = ReturnType<typeof useUserInformationChatSuspenseQuery>;
export type UserInformationChatQueryResult = Apollo.QueryResult<UserInformationChatQuery, UserInformationChatQueryVariables>;
export const EndCardPlaylistDocument = gql`
    query endCardPlaylist($slug: String!) {
  playlist(slug: $slug) {
    id
    videos {
      nodes {
        ...BasicVideoInfo
      }
    }
  }
}
    ${BasicVideoInfoFragmentDoc}`;

/**
 * __useEndCardPlaylistQuery__
 *
 * To run a query within a React component, call `useEndCardPlaylistQuery` and pass it any options that fit your needs.
 * When your component renders, `useEndCardPlaylistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEndCardPlaylistQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useEndCardPlaylistQuery(baseOptions: Apollo.QueryHookOptions<EndCardPlaylistQuery, EndCardPlaylistQueryVariables> & ({ variables: EndCardPlaylistQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EndCardPlaylistQuery, EndCardPlaylistQueryVariables>(EndCardPlaylistDocument, options);
      }
export function useEndCardPlaylistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EndCardPlaylistQuery, EndCardPlaylistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EndCardPlaylistQuery, EndCardPlaylistQueryVariables>(EndCardPlaylistDocument, options);
        }
export function useEndCardPlaylistSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EndCardPlaylistQuery, EndCardPlaylistQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EndCardPlaylistQuery, EndCardPlaylistQueryVariables>(EndCardPlaylistDocument, options);
        }
export type EndCardPlaylistQueryHookResult = ReturnType<typeof useEndCardPlaylistQuery>;
export type EndCardPlaylistLazyQueryHookResult = ReturnType<typeof useEndCardPlaylistLazyQuery>;
export type EndCardPlaylistSuspenseQueryHookResult = ReturnType<typeof useEndCardPlaylistSuspenseQuery>;
export type EndCardPlaylistQueryResult = Apollo.QueryResult<EndCardPlaylistQuery, EndCardPlaylistQueryVariables>;
export const EndCardRelatedDocument = gql`
    query endCardRelated($id: [Int!], $language: String, $isPublished: [Boolean!]) {
  videos(
    id: $id
    language: $language
    isPublished: $isPublished
    first: 1
    channel: ALL
  ) {
    nodes {
      id
      relatedVideos {
        ...BasicVideoInfo
      }
    }
  }
}
    ${BasicVideoInfoFragmentDoc}`;

/**
 * __useEndCardRelatedQuery__
 *
 * To run a query within a React component, call `useEndCardRelatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useEndCardRelatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEndCardRelatedQuery({
 *   variables: {
 *      id: // value for 'id'
 *      language: // value for 'language'
 *      isPublished: // value for 'isPublished'
 *   },
 * });
 */
export function useEndCardRelatedQuery(baseOptions?: Apollo.QueryHookOptions<EndCardRelatedQuery, EndCardRelatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EndCardRelatedQuery, EndCardRelatedQueryVariables>(EndCardRelatedDocument, options);
      }
export function useEndCardRelatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EndCardRelatedQuery, EndCardRelatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EndCardRelatedQuery, EndCardRelatedQueryVariables>(EndCardRelatedDocument, options);
        }
export function useEndCardRelatedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EndCardRelatedQuery, EndCardRelatedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EndCardRelatedQuery, EndCardRelatedQueryVariables>(EndCardRelatedDocument, options);
        }
export type EndCardRelatedQueryHookResult = ReturnType<typeof useEndCardRelatedQuery>;
export type EndCardRelatedLazyQueryHookResult = ReturnType<typeof useEndCardRelatedLazyQuery>;
export type EndCardRelatedSuspenseQueryHookResult = ReturnType<typeof useEndCardRelatedSuspenseQuery>;
export type EndCardRelatedQueryResult = Apollo.QueryResult<EndCardRelatedQuery, EndCardRelatedQueryVariables>;
export const EventsDashboardDocument = gql`
    query eventsDashboard {
  viewer {
    ...UserInfo
    isMember
    hasMembersMightyNetworkAccess
  }
  membershipEvents {
    endAt
    beginAt
    id
    isRegistered
    isSoldOut
    timezoneName
    title
    membershipEventSessions {
      beginAt
      description
      endAt
      eventId
      id
      sessionFormatName
      sessionSignupLabel
      sessionSignupUrl
      title
      membershipEventSpeakers {
        id
        avatar
        description
        firstName
        middleName
        lastName
        slug
        speakerTalkTypeName
        whatOthersSay
        whoTheyAre
        whyListen
      }
    }
  }
}
    ${UserInfoFragmentDoc}`;

/**
 * __useEventsDashboardQuery__
 *
 * To run a query within a React component, call `useEventsDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventsDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventsDashboardQuery({
 *   variables: {
 *   },
 * });
 */
export function useEventsDashboardQuery(baseOptions?: Apollo.QueryHookOptions<EventsDashboardQuery, EventsDashboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventsDashboardQuery, EventsDashboardQueryVariables>(EventsDashboardDocument, options);
      }
export function useEventsDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventsDashboardQuery, EventsDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventsDashboardQuery, EventsDashboardQueryVariables>(EventsDashboardDocument, options);
        }
export function useEventsDashboardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventsDashboardQuery, EventsDashboardQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventsDashboardQuery, EventsDashboardQueryVariables>(EventsDashboardDocument, options);
        }
export type EventsDashboardQueryHookResult = ReturnType<typeof useEventsDashboardQuery>;
export type EventsDashboardLazyQueryHookResult = ReturnType<typeof useEventsDashboardLazyQuery>;
export type EventsDashboardSuspenseQueryHookResult = ReturnType<typeof useEventsDashboardSuspenseQuery>;
export type EventsDashboardQueryResult = Apollo.QueryResult<EventsDashboardQuery, EventsDashboardQueryVariables>;
export const FavoritesDocument = gql`
    query favorites {
  viewer {
    id
    favorites {
      nodes {
        favoriteable {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useFavoritesQuery__
 *
 * To run a query within a React component, call `useFavoritesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFavoritesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFavoritesQuery({
 *   variables: {
 *   },
 * });
 */
export function useFavoritesQuery(baseOptions?: Apollo.QueryHookOptions<FavoritesQuery, FavoritesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FavoritesQuery, FavoritesQueryVariables>(FavoritesDocument, options);
      }
export function useFavoritesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FavoritesQuery, FavoritesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FavoritesQuery, FavoritesQueryVariables>(FavoritesDocument, options);
        }
export function useFavoritesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FavoritesQuery, FavoritesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FavoritesQuery, FavoritesQueryVariables>(FavoritesDocument, options);
        }
export type FavoritesQueryHookResult = ReturnType<typeof useFavoritesQuery>;
export type FavoritesLazyQueryHookResult = ReturnType<typeof useFavoritesLazyQuery>;
export type FavoritesSuspenseQueryHookResult = ReturnType<typeof useFavoritesSuspenseQuery>;
export type FavoritesQueryResult = Apollo.QueryResult<FavoritesQuery, FavoritesQueryVariables>;
export const PlaylistsFeaturedSlotDocument = gql`
    query playlistsFeaturedSlot {
  playlists(inFeaturedSlot: true) {
    totalCount
    nodes {
      id
      slug
    }
  }
}
    `;

/**
 * __usePlaylistsFeaturedSlotQuery__
 *
 * To run a query within a React component, call `usePlaylistsFeaturedSlotQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlaylistsFeaturedSlotQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlaylistsFeaturedSlotQuery({
 *   variables: {
 *   },
 * });
 */
export function usePlaylistsFeaturedSlotQuery(baseOptions?: Apollo.QueryHookOptions<PlaylistsFeaturedSlotQuery, PlaylistsFeaturedSlotQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlaylistsFeaturedSlotQuery, PlaylistsFeaturedSlotQueryVariables>(PlaylistsFeaturedSlotDocument, options);
      }
export function usePlaylistsFeaturedSlotLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlaylistsFeaturedSlotQuery, PlaylistsFeaturedSlotQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlaylistsFeaturedSlotQuery, PlaylistsFeaturedSlotQueryVariables>(PlaylistsFeaturedSlotDocument, options);
        }
export function usePlaylistsFeaturedSlotSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlaylistsFeaturedSlotQuery, PlaylistsFeaturedSlotQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlaylistsFeaturedSlotQuery, PlaylistsFeaturedSlotQueryVariables>(PlaylistsFeaturedSlotDocument, options);
        }
export type PlaylistsFeaturedSlotQueryHookResult = ReturnType<typeof usePlaylistsFeaturedSlotQuery>;
export type PlaylistsFeaturedSlotLazyQueryHookResult = ReturnType<typeof usePlaylistsFeaturedSlotLazyQuery>;
export type PlaylistsFeaturedSlotSuspenseQueryHookResult = ReturnType<typeof usePlaylistsFeaturedSlotSuspenseQuery>;
export type PlaylistsFeaturedSlotQueryResult = Apollo.QueryResult<PlaylistsFeaturedSlotQuery, PlaylistsFeaturedSlotQueryVariables>;
export const HistoryDocument = gql`
    query history {
  viewer {
    id
    activities(name: "watched", first: 100) {
      nodes {
        subjectId
      }
    }
  }
}
    `;

/**
 * __useHistoryQuery__
 *
 * To run a query within a React component, call `useHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHistoryQuery({
 *   variables: {
 *   },
 * });
 */
export function useHistoryQuery(baseOptions?: Apollo.QueryHookOptions<HistoryQuery, HistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HistoryQuery, HistoryQueryVariables>(HistoryDocument, options);
      }
export function useHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HistoryQuery, HistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HistoryQuery, HistoryQueryVariables>(HistoryDocument, options);
        }
export function useHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HistoryQuery, HistoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HistoryQuery, HistoryQueryVariables>(HistoryDocument, options);
        }
export type HistoryQueryHookResult = ReturnType<typeof useHistoryQuery>;
export type HistoryLazyQueryHookResult = ReturnType<typeof useHistoryLazyQuery>;
export type HistorySuspenseQueryHookResult = ReturnType<typeof useHistorySuspenseQuery>;
export type HistoryQueryResult = Apollo.QueryResult<HistoryQuery, HistoryQueryVariables>;
export const HomePageDataDocument = gql`
    query homePageData($trendingIds: [Int!]) {
  newestTalks: videos(first: 24, channel: FEATURED) {
    nodes {
      ...VideoInfo
      type {
        name
      }
    }
  }
  trendingTalks: videos(id: $trendingIds) {
    nodes {
      ...VideoInfo
      type {
        name
      }
    }
  }
  platform(id: 1) {
    ribbons {
      nodes {
        name
        sponsorLogo
        sponsorName
        sponsored
        live
        order
        slots {
          nodes {
            title
            image
            link
            duration
            order
            video {
              ...VideoInfo
              description
              topics {
                nodes {
                  name
                }
              }
              type {
                name
              }
            }
          }
        }
      }
    }
    pancakes {
      nodes {
        playlists {
          nodes {
            id
            title
            displayOrder
            slug
            primaryImageSet {
              url
              aspectRatioName
            }
            videos {
              totalCount
            }
          }
        }
      }
    }
    spotlightUnits(last: 3) {
      nodes {
        id
        position
        imageUrl
        content
        title
        published
        url
      }
    }
  }
}
    ${VideoInfoFragmentDoc}`;

/**
 * __useHomePageDataQuery__
 *
 * To run a query within a React component, call `useHomePageDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomePageDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomePageDataQuery({
 *   variables: {
 *      trendingIds: // value for 'trendingIds'
 *   },
 * });
 */
export function useHomePageDataQuery(baseOptions?: Apollo.QueryHookOptions<HomePageDataQuery, HomePageDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomePageDataQuery, HomePageDataQueryVariables>(HomePageDataDocument, options);
      }
export function useHomePageDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomePageDataQuery, HomePageDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomePageDataQuery, HomePageDataQueryVariables>(HomePageDataDocument, options);
        }
export function useHomePageDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HomePageDataQuery, HomePageDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HomePageDataQuery, HomePageDataQueryVariables>(HomePageDataDocument, options);
        }
export type HomePageDataQueryHookResult = ReturnType<typeof useHomePageDataQuery>;
export type HomePageDataLazyQueryHookResult = ReturnType<typeof useHomePageDataLazyQuery>;
export type HomePageDataSuspenseQueryHookResult = ReturnType<typeof useHomePageDataSuspenseQuery>;
export type HomePageDataQueryResult = Apollo.QueryResult<HomePageDataQuery, HomePageDataQueryVariables>;
export const HomepageFeaturedVideoDataDocument = gql`
    query homepageFeaturedVideoData($slug: [String!]) {
  videos(slug: $slug, first: 1, channel: FEATURED) {
    nodes {
      ...VideoInfo
      description
      topics {
        nodes {
          name
        }
      }
      type {
        name
      }
    }
  }
}
    ${VideoInfoFragmentDoc}`;

/**
 * __useHomepageFeaturedVideoDataQuery__
 *
 * To run a query within a React component, call `useHomepageFeaturedVideoDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomepageFeaturedVideoDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomepageFeaturedVideoDataQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useHomepageFeaturedVideoDataQuery(baseOptions?: Apollo.QueryHookOptions<HomepageFeaturedVideoDataQuery, HomepageFeaturedVideoDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomepageFeaturedVideoDataQuery, HomepageFeaturedVideoDataQueryVariables>(HomepageFeaturedVideoDataDocument, options);
      }
export function useHomepageFeaturedVideoDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomepageFeaturedVideoDataQuery, HomepageFeaturedVideoDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomepageFeaturedVideoDataQuery, HomepageFeaturedVideoDataQueryVariables>(HomepageFeaturedVideoDataDocument, options);
        }
export function useHomepageFeaturedVideoDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HomepageFeaturedVideoDataQuery, HomepageFeaturedVideoDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HomepageFeaturedVideoDataQuery, HomepageFeaturedVideoDataQueryVariables>(HomepageFeaturedVideoDataDocument, options);
        }
export type HomepageFeaturedVideoDataQueryHookResult = ReturnType<typeof useHomepageFeaturedVideoDataQuery>;
export type HomepageFeaturedVideoDataLazyQueryHookResult = ReturnType<typeof useHomepageFeaturedVideoDataLazyQuery>;
export type HomepageFeaturedVideoDataSuspenseQueryHookResult = ReturnType<typeof useHomepageFeaturedVideoDataSuspenseQuery>;
export type HomepageFeaturedVideoDataQueryResult = Apollo.QueryResult<HomepageFeaturedVideoDataQuery, HomepageFeaturedVideoDataQueryVariables>;
export const IdentityLanguagesDocument = gql`
    query IdentityLanguages {
  identityLanguages {
    id
    name
  }
}
    `;

/**
 * __useIdentityLanguagesQuery__
 *
 * To run a query within a React component, call `useIdentityLanguagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useIdentityLanguagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIdentityLanguagesQuery({
 *   variables: {
 *   },
 * });
 */
export function useIdentityLanguagesQuery(baseOptions?: Apollo.QueryHookOptions<IdentityLanguagesQuery, IdentityLanguagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IdentityLanguagesQuery, IdentityLanguagesQueryVariables>(IdentityLanguagesDocument, options);
      }
export function useIdentityLanguagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IdentityLanguagesQuery, IdentityLanguagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IdentityLanguagesQuery, IdentityLanguagesQueryVariables>(IdentityLanguagesDocument, options);
        }
export function useIdentityLanguagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IdentityLanguagesQuery, IdentityLanguagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IdentityLanguagesQuery, IdentityLanguagesQueryVariables>(IdentityLanguagesDocument, options);
        }
export type IdentityLanguagesQueryHookResult = ReturnType<typeof useIdentityLanguagesQuery>;
export type IdentityLanguagesLazyQueryHookResult = ReturnType<typeof useIdentityLanguagesLazyQuery>;
export type IdentityLanguagesSuspenseQueryHookResult = ReturnType<typeof useIdentityLanguagesSuspenseQuery>;
export type IdentityLanguagesQueryResult = Apollo.QueryResult<IdentityLanguagesQuery, IdentityLanguagesQueryVariables>;
export const IndustriesDocument = gql`
    query Industries {
  industries {
    name
    id
  }
}
    `;

/**
 * __useIndustriesQuery__
 *
 * To run a query within a React component, call `useIndustriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useIndustriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIndustriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useIndustriesQuery(baseOptions?: Apollo.QueryHookOptions<IndustriesQuery, IndustriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IndustriesQuery, IndustriesQueryVariables>(IndustriesDocument, options);
      }
export function useIndustriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IndustriesQuery, IndustriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IndustriesQuery, IndustriesQueryVariables>(IndustriesDocument, options);
        }
export function useIndustriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IndustriesQuery, IndustriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IndustriesQuery, IndustriesQueryVariables>(IndustriesDocument, options);
        }
export type IndustriesQueryHookResult = ReturnType<typeof useIndustriesQuery>;
export type IndustriesLazyQueryHookResult = ReturnType<typeof useIndustriesLazyQuery>;
export type IndustriesSuspenseQueryHookResult = ReturnType<typeof useIndustriesSuspenseQuery>;
export type IndustriesQueryResult = Apollo.QueryResult<IndustriesQuery, IndustriesQueryVariables>;
export const IsItemInYourLikesDocument = gql`
    query isItemInYourLikes($id: ID!) {
  doYouLikeItem(itemId: $id, itemType: VIDEO) {
    id
  }
}
    `;

/**
 * __useIsItemInYourLikesQuery__
 *
 * To run a query within a React component, call `useIsItemInYourLikesQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsItemInYourLikesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsItemInYourLikesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIsItemInYourLikesQuery(baseOptions: Apollo.QueryHookOptions<IsItemInYourLikesQuery, IsItemInYourLikesQueryVariables> & ({ variables: IsItemInYourLikesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsItemInYourLikesQuery, IsItemInYourLikesQueryVariables>(IsItemInYourLikesDocument, options);
      }
export function useIsItemInYourLikesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsItemInYourLikesQuery, IsItemInYourLikesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsItemInYourLikesQuery, IsItemInYourLikesQueryVariables>(IsItemInYourLikesDocument, options);
        }
export function useIsItemInYourLikesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IsItemInYourLikesQuery, IsItemInYourLikesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IsItemInYourLikesQuery, IsItemInYourLikesQueryVariables>(IsItemInYourLikesDocument, options);
        }
export type IsItemInYourLikesQueryHookResult = ReturnType<typeof useIsItemInYourLikesQuery>;
export type IsItemInYourLikesLazyQueryHookResult = ReturnType<typeof useIsItemInYourLikesLazyQuery>;
export type IsItemInYourLikesSuspenseQueryHookResult = ReturnType<typeof useIsItemInYourLikesSuspenseQuery>;
export type IsItemInYourLikesQueryResult = Apollo.QueryResult<IsItemInYourLikesQuery, IsItemInYourLikesQueryVariables>;
export const IsItemInYourListDocument = gql`
    query isItemInYourList($id: ID!) {
  yourListItem(itemId: $id, itemType: VIDEO) {
    __typename
    id
  }
}
    `;

/**
 * __useIsItemInYourListQuery__
 *
 * To run a query within a React component, call `useIsItemInYourListQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsItemInYourListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsItemInYourListQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIsItemInYourListQuery(baseOptions: Apollo.QueryHookOptions<IsItemInYourListQuery, IsItemInYourListQueryVariables> & ({ variables: IsItemInYourListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsItemInYourListQuery, IsItemInYourListQueryVariables>(IsItemInYourListDocument, options);
      }
export function useIsItemInYourListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsItemInYourListQuery, IsItemInYourListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsItemInYourListQuery, IsItemInYourListQueryVariables>(IsItemInYourListDocument, options);
        }
export function useIsItemInYourListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IsItemInYourListQuery, IsItemInYourListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IsItemInYourListQuery, IsItemInYourListQueryVariables>(IsItemInYourListDocument, options);
        }
export type IsItemInYourListQueryHookResult = ReturnType<typeof useIsItemInYourListQuery>;
export type IsItemInYourListLazyQueryHookResult = ReturnType<typeof useIsItemInYourListLazyQuery>;
export type IsItemInYourListSuspenseQueryHookResult = ReturnType<typeof useIsItemInYourListSuspenseQuery>;
export type IsItemInYourListQueryResult = Apollo.QueryResult<IsItemInYourListQuery, IsItemInYourListQueryVariables>;
export const IsPlaylistOnListDocument = gql`
    query isPlaylistOnList($id: ID!) {
  yourListItem(itemId: $id, itemType: PLAYLIST) {
    id
    itemType
  }
}
    `;

/**
 * __useIsPlaylistOnListQuery__
 *
 * To run a query within a React component, call `useIsPlaylistOnListQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsPlaylistOnListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsPlaylistOnListQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIsPlaylistOnListQuery(baseOptions: Apollo.QueryHookOptions<IsPlaylistOnListQuery, IsPlaylistOnListQueryVariables> & ({ variables: IsPlaylistOnListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsPlaylistOnListQuery, IsPlaylistOnListQueryVariables>(IsPlaylistOnListDocument, options);
      }
export function useIsPlaylistOnListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsPlaylistOnListQuery, IsPlaylistOnListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsPlaylistOnListQuery, IsPlaylistOnListQueryVariables>(IsPlaylistOnListDocument, options);
        }
export function useIsPlaylistOnListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IsPlaylistOnListQuery, IsPlaylistOnListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IsPlaylistOnListQuery, IsPlaylistOnListQueryVariables>(IsPlaylistOnListDocument, options);
        }
export type IsPlaylistOnListQueryHookResult = ReturnType<typeof useIsPlaylistOnListQuery>;
export type IsPlaylistOnListLazyQueryHookResult = ReturnType<typeof useIsPlaylistOnListLazyQuery>;
export type IsPlaylistOnListSuspenseQueryHookResult = ReturnType<typeof useIsPlaylistOnListSuspenseQuery>;
export type IsPlaylistOnListQueryResult = Apollo.QueryResult<IsPlaylistOnListQuery, IsPlaylistOnListQueryVariables>;
export const LearningHubWatchedTalksDocument = gql`
    query learningHubWatchedTalks {
  viewer {
    id
    watchedTalks {
      autoplayed
      secondsPlayed
      talk {
        id
        slug
        language
        talkType
        altheadline
      }
    }
  }
}
    `;

/**
 * __useLearningHubWatchedTalksQuery__
 *
 * To run a query within a React component, call `useLearningHubWatchedTalksQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearningHubWatchedTalksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningHubWatchedTalksQuery({
 *   variables: {
 *   },
 * });
 */
export function useLearningHubWatchedTalksQuery(baseOptions?: Apollo.QueryHookOptions<LearningHubWatchedTalksQuery, LearningHubWatchedTalksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LearningHubWatchedTalksQuery, LearningHubWatchedTalksQueryVariables>(LearningHubWatchedTalksDocument, options);
      }
export function useLearningHubWatchedTalksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LearningHubWatchedTalksQuery, LearningHubWatchedTalksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LearningHubWatchedTalksQuery, LearningHubWatchedTalksQueryVariables>(LearningHubWatchedTalksDocument, options);
        }
export function useLearningHubWatchedTalksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LearningHubWatchedTalksQuery, LearningHubWatchedTalksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LearningHubWatchedTalksQuery, LearningHubWatchedTalksQueryVariables>(LearningHubWatchedTalksDocument, options);
        }
export type LearningHubWatchedTalksQueryHookResult = ReturnType<typeof useLearningHubWatchedTalksQuery>;
export type LearningHubWatchedTalksLazyQueryHookResult = ReturnType<typeof useLearningHubWatchedTalksLazyQuery>;
export type LearningHubWatchedTalksSuspenseQueryHookResult = ReturnType<typeof useLearningHubWatchedTalksSuspenseQuery>;
export type LearningHubWatchedTalksQueryResult = Apollo.QueryResult<LearningHubWatchedTalksQuery, LearningHubWatchedTalksQueryVariables>;
export const LearningHubCustomPlaylistVideosDocument = gql`
    query LearningHubCustomPlaylistVideos($slug: [String!]) {
  videos(slug: $slug, channel: ALL) {
    nodes {
      ...VideoInfo
      learningProductTopic {
        id
        name
        slug
      }
      type {
        name
        id
      }
    }
  }
}
    ${VideoInfoFragmentDoc}`;

/**
 * __useLearningHubCustomPlaylistVideosQuery__
 *
 * To run a query within a React component, call `useLearningHubCustomPlaylistVideosQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearningHubCustomPlaylistVideosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningHubCustomPlaylistVideosQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useLearningHubCustomPlaylistVideosQuery(baseOptions?: Apollo.QueryHookOptions<LearningHubCustomPlaylistVideosQuery, LearningHubCustomPlaylistVideosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LearningHubCustomPlaylistVideosQuery, LearningHubCustomPlaylistVideosQueryVariables>(LearningHubCustomPlaylistVideosDocument, options);
      }
export function useLearningHubCustomPlaylistVideosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LearningHubCustomPlaylistVideosQuery, LearningHubCustomPlaylistVideosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LearningHubCustomPlaylistVideosQuery, LearningHubCustomPlaylistVideosQueryVariables>(LearningHubCustomPlaylistVideosDocument, options);
        }
export function useLearningHubCustomPlaylistVideosSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LearningHubCustomPlaylistVideosQuery, LearningHubCustomPlaylistVideosQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LearningHubCustomPlaylistVideosQuery, LearningHubCustomPlaylistVideosQueryVariables>(LearningHubCustomPlaylistVideosDocument, options);
        }
export type LearningHubCustomPlaylistVideosQueryHookResult = ReturnType<typeof useLearningHubCustomPlaylistVideosQuery>;
export type LearningHubCustomPlaylistVideosLazyQueryHookResult = ReturnType<typeof useLearningHubCustomPlaylistVideosLazyQuery>;
export type LearningHubCustomPlaylistVideosSuspenseQueryHookResult = ReturnType<typeof useLearningHubCustomPlaylistVideosSuspenseQuery>;
export type LearningHubCustomPlaylistVideosQueryResult = Apollo.QueryResult<LearningHubCustomPlaylistVideosQuery, LearningHubCustomPlaylistVideosQueryVariables>;
export const LearningHubDonutDataDocument = gql`
    query LearningHubDonutData($watchedBefore: ISO8601Date, $watchedAfter: ISO8601Date, $first: Int = 100, $after: String) {
  viewer {
    id
    watchedVideos(
      watchedAfter: $watchedAfter
      watchedBefore: $watchedBefore
      first: $first
      after: $after
    ) {
      edges {
        node {
          id
          ...LearningProductTopic
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
      totalCount
    }
  }
}
    ${LearningProductTopicFragmentDoc}`;

/**
 * __useLearningHubDonutDataQuery__
 *
 * To run a query within a React component, call `useLearningHubDonutDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearningHubDonutDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningHubDonutDataQuery({
 *   variables: {
 *      watchedBefore: // value for 'watchedBefore'
 *      watchedAfter: // value for 'watchedAfter'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useLearningHubDonutDataQuery(baseOptions?: Apollo.QueryHookOptions<LearningHubDonutDataQuery, LearningHubDonutDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LearningHubDonutDataQuery, LearningHubDonutDataQueryVariables>(LearningHubDonutDataDocument, options);
      }
export function useLearningHubDonutDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LearningHubDonutDataQuery, LearningHubDonutDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LearningHubDonutDataQuery, LearningHubDonutDataQueryVariables>(LearningHubDonutDataDocument, options);
        }
export function useLearningHubDonutDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LearningHubDonutDataQuery, LearningHubDonutDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LearningHubDonutDataQuery, LearningHubDonutDataQueryVariables>(LearningHubDonutDataDocument, options);
        }
export type LearningHubDonutDataQueryHookResult = ReturnType<typeof useLearningHubDonutDataQuery>;
export type LearningHubDonutDataLazyQueryHookResult = ReturnType<typeof useLearningHubDonutDataLazyQuery>;
export type LearningHubDonutDataSuspenseQueryHookResult = ReturnType<typeof useLearningHubDonutDataSuspenseQuery>;
export type LearningHubDonutDataQueryResult = Apollo.QueryResult<LearningHubDonutDataQuery, LearningHubDonutDataQueryVariables>;
export const LearningHubSurpriseMeVideoDocument = gql`
    query learningHubSurpriseMeVideo($id: [Int!], $first: Int) {
  videos(id: $id, isPublished: true, channel: ALL, first: $first) {
    edges {
      node {
        id
        slug
        title
        duration
        viewedCount
        presenterDisplayName
        recordedOn
        primaryImageSet {
          url
          aspectRatioName
        }
        ...LearningProductTopic
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
    totalCount
  }
}
    ${LearningProductTopicFragmentDoc}`;

/**
 * __useLearningHubSurpriseMeVideoQuery__
 *
 * To run a query within a React component, call `useLearningHubSurpriseMeVideoQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearningHubSurpriseMeVideoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningHubSurpriseMeVideoQuery({
 *   variables: {
 *      id: // value for 'id'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useLearningHubSurpriseMeVideoQuery(baseOptions?: Apollo.QueryHookOptions<LearningHubSurpriseMeVideoQuery, LearningHubSurpriseMeVideoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LearningHubSurpriseMeVideoQuery, LearningHubSurpriseMeVideoQueryVariables>(LearningHubSurpriseMeVideoDocument, options);
      }
export function useLearningHubSurpriseMeVideoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LearningHubSurpriseMeVideoQuery, LearningHubSurpriseMeVideoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LearningHubSurpriseMeVideoQuery, LearningHubSurpriseMeVideoQueryVariables>(LearningHubSurpriseMeVideoDocument, options);
        }
export function useLearningHubSurpriseMeVideoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LearningHubSurpriseMeVideoQuery, LearningHubSurpriseMeVideoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LearningHubSurpriseMeVideoQuery, LearningHubSurpriseMeVideoQueryVariables>(LearningHubSurpriseMeVideoDocument, options);
        }
export type LearningHubSurpriseMeVideoQueryHookResult = ReturnType<typeof useLearningHubSurpriseMeVideoQuery>;
export type LearningHubSurpriseMeVideoLazyQueryHookResult = ReturnType<typeof useLearningHubSurpriseMeVideoLazyQuery>;
export type LearningHubSurpriseMeVideoSuspenseQueryHookResult = ReturnType<typeof useLearningHubSurpriseMeVideoSuspenseQuery>;
export type LearningHubSurpriseMeVideoQueryResult = Apollo.QueryResult<LearningHubSurpriseMeVideoQuery, LearningHubSurpriseMeVideoQueryVariables>;
export const LearningHubTopicsTakeawaysDocument = gql`
    query learningHubTopicsTakeaways {
  viewer {
    id
    favorites(first: 100) {
      edges {
        node {
          id
          favoriteable {
            type
          }
          favoriteableEntity {
            ... on TalkTakeaway {
              id
              text
              talkstarTalkId
              offsetSeconds
            }
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
}
    `;

/**
 * __useLearningHubTopicsTakeawaysQuery__
 *
 * To run a query within a React component, call `useLearningHubTopicsTakeawaysQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearningHubTopicsTakeawaysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningHubTopicsTakeawaysQuery({
 *   variables: {
 *   },
 * });
 */
export function useLearningHubTopicsTakeawaysQuery(baseOptions?: Apollo.QueryHookOptions<LearningHubTopicsTakeawaysQuery, LearningHubTopicsTakeawaysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LearningHubTopicsTakeawaysQuery, LearningHubTopicsTakeawaysQueryVariables>(LearningHubTopicsTakeawaysDocument, options);
      }
export function useLearningHubTopicsTakeawaysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LearningHubTopicsTakeawaysQuery, LearningHubTopicsTakeawaysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LearningHubTopicsTakeawaysQuery, LearningHubTopicsTakeawaysQueryVariables>(LearningHubTopicsTakeawaysDocument, options);
        }
export function useLearningHubTopicsTakeawaysSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LearningHubTopicsTakeawaysQuery, LearningHubTopicsTakeawaysQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LearningHubTopicsTakeawaysQuery, LearningHubTopicsTakeawaysQueryVariables>(LearningHubTopicsTakeawaysDocument, options);
        }
export type LearningHubTopicsTakeawaysQueryHookResult = ReturnType<typeof useLearningHubTopicsTakeawaysQuery>;
export type LearningHubTopicsTakeawaysLazyQueryHookResult = ReturnType<typeof useLearningHubTopicsTakeawaysLazyQuery>;
export type LearningHubTopicsTakeawaysSuspenseQueryHookResult = ReturnType<typeof useLearningHubTopicsTakeawaysSuspenseQuery>;
export type LearningHubTopicsTakeawaysQueryResult = Apollo.QueryResult<LearningHubTopicsTakeawaysQuery, LearningHubTopicsTakeawaysQueryVariables>;
export const MembershipEmsDocument = gql`
    query MembershipEms {
  viewer {
    id
    isMember
    name {
      full
    }
  }
  membershipEvents(public: true) {
    endAt
    beginAt
    id
    isRegistered
    isSoldOut
    timezoneName
    title
    membershipEventSessions {
      beginAt
      description
      endAt
      eventId
      id
      sessionFormatName
      sessionSignupLabel
      sessionSignupUrl
      title
      membershipEventSpeakers {
        id
        avatar
        description
        firstName
        middleName
        lastName
        slug
        speakerTalkTypeName
        whatOthersSay
        whoTheyAre
        whyListen
      }
    }
  }
}
    `;

/**
 * __useMembershipEmsQuery__
 *
 * To run a query within a React component, call `useMembershipEmsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMembershipEmsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMembershipEmsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMembershipEmsQuery(baseOptions?: Apollo.QueryHookOptions<MembershipEmsQuery, MembershipEmsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MembershipEmsQuery, MembershipEmsQueryVariables>(MembershipEmsDocument, options);
      }
export function useMembershipEmsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MembershipEmsQuery, MembershipEmsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MembershipEmsQuery, MembershipEmsQueryVariables>(MembershipEmsDocument, options);
        }
export function useMembershipEmsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MembershipEmsQuery, MembershipEmsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MembershipEmsQuery, MembershipEmsQueryVariables>(MembershipEmsDocument, options);
        }
export type MembershipEmsQueryHookResult = ReturnType<typeof useMembershipEmsQuery>;
export type MembershipEmsLazyQueryHookResult = ReturnType<typeof useMembershipEmsLazyQuery>;
export type MembershipEmsSuspenseQueryHookResult = ReturnType<typeof useMembershipEmsSuspenseQuery>;
export type MembershipEmsQueryResult = Apollo.QueryResult<MembershipEmsQuery, MembershipEmsQueryVariables>;
export const NavUserInformationDocument = gql`
    query navUserInformation {
  viewer {
    ...UserInfo
    avatar {
      url
      generatedUrl(type: SVG)
    }
    isMember
  }
}
    ${UserInfoFragmentDoc}`;

/**
 * __useNavUserInformationQuery__
 *
 * To run a query within a React component, call `useNavUserInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useNavUserInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNavUserInformationQuery({
 *   variables: {
 *   },
 * });
 */
export function useNavUserInformationQuery(baseOptions?: Apollo.QueryHookOptions<NavUserInformationQuery, NavUserInformationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NavUserInformationQuery, NavUserInformationQueryVariables>(NavUserInformationDocument, options);
      }
export function useNavUserInformationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NavUserInformationQuery, NavUserInformationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NavUserInformationQuery, NavUserInformationQueryVariables>(NavUserInformationDocument, options);
        }
export function useNavUserInformationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NavUserInformationQuery, NavUserInformationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NavUserInformationQuery, NavUserInformationQueryVariables>(NavUserInformationDocument, options);
        }
export type NavUserInformationQueryHookResult = ReturnType<typeof useNavUserInformationQuery>;
export type NavUserInformationLazyQueryHookResult = ReturnType<typeof useNavUserInformationLazyQuery>;
export type NavUserInformationSuspenseQueryHookResult = ReturnType<typeof useNavUserInformationSuspenseQuery>;
export type NavUserInformationQueryResult = Apollo.QueryResult<NavUserInformationQuery, NavUserInformationQueryVariables>;
export const PlaylistVideosDocument = gql`
    query playlistVideos($slug: String!) {
  playlist(slug: $slug) {
    ...PlaylistInfo
    videos {
      nodes {
        ...VideoInfo
        type {
          name
          id
        }
      }
    }
  }
}
    ${PlaylistInfoFragmentDoc}
${VideoInfoFragmentDoc}`;

/**
 * __usePlaylistVideosQuery__
 *
 * To run a query within a React component, call `usePlaylistVideosQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlaylistVideosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlaylistVideosQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function usePlaylistVideosQuery(baseOptions: Apollo.QueryHookOptions<PlaylistVideosQuery, PlaylistVideosQueryVariables> & ({ variables: PlaylistVideosQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlaylistVideosQuery, PlaylistVideosQueryVariables>(PlaylistVideosDocument, options);
      }
export function usePlaylistVideosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlaylistVideosQuery, PlaylistVideosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlaylistVideosQuery, PlaylistVideosQueryVariables>(PlaylistVideosDocument, options);
        }
export function usePlaylistVideosSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlaylistVideosQuery, PlaylistVideosQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlaylistVideosQuery, PlaylistVideosQueryVariables>(PlaylistVideosDocument, options);
        }
export type PlaylistVideosQueryHookResult = ReturnType<typeof usePlaylistVideosQuery>;
export type PlaylistVideosLazyQueryHookResult = ReturnType<typeof usePlaylistVideosLazyQuery>;
export type PlaylistVideosSuspenseQueryHookResult = ReturnType<typeof usePlaylistVideosSuspenseQuery>;
export type PlaylistVideosQueryResult = Apollo.QueryResult<PlaylistVideosQuery, PlaylistVideosQueryVariables>;
export const PlaylistsGridDocument = gql`
    query playlistsGrid($topics: [String!], $curator: CuratorOptions, $first: Int, $after: String) {
  playlists(topics: $topics, curator: $curator, first: $first, after: $after) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    nodes {
      ...PlaylistInfo
      videos {
        totalCount
      }
    }
  }
}
    ${PlaylistInfoFragmentDoc}`;

/**
 * __usePlaylistsGridQuery__
 *
 * To run a query within a React component, call `usePlaylistsGridQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlaylistsGridQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlaylistsGridQuery({
 *   variables: {
 *      topics: // value for 'topics'
 *      curator: // value for 'curator'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function usePlaylistsGridQuery(baseOptions?: Apollo.QueryHookOptions<PlaylistsGridQuery, PlaylistsGridQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlaylistsGridQuery, PlaylistsGridQueryVariables>(PlaylistsGridDocument, options);
      }
export function usePlaylistsGridLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlaylistsGridQuery, PlaylistsGridQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlaylistsGridQuery, PlaylistsGridQueryVariables>(PlaylistsGridDocument, options);
        }
export function usePlaylistsGridSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlaylistsGridQuery, PlaylistsGridQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlaylistsGridQuery, PlaylistsGridQueryVariables>(PlaylistsGridDocument, options);
        }
export type PlaylistsGridQueryHookResult = ReturnType<typeof usePlaylistsGridQuery>;
export type PlaylistsGridLazyQueryHookResult = ReturnType<typeof usePlaylistsGridLazyQuery>;
export type PlaylistsGridSuspenseQueryHookResult = ReturnType<typeof usePlaylistsGridSuspenseQuery>;
export type PlaylistsGridQueryResult = Apollo.QueryResult<PlaylistsGridQuery, PlaylistsGridQueryVariables>;
export const PlaylistLandingDataDocument = gql`
    query playlistLandingData($id: ID!) {
  playlist(id: $id) {
    ...PlaylistInfo
    videos {
      totalCount
      nodes {
        ...VideoInfo
        type {
          name
        }
      }
    }
    series {
      slug
    }
  }
}
    ${PlaylistInfoFragmentDoc}
${VideoInfoFragmentDoc}`;

/**
 * __usePlaylistLandingDataQuery__
 *
 * To run a query within a React component, call `usePlaylistLandingDataQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlaylistLandingDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlaylistLandingDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePlaylistLandingDataQuery(baseOptions: Apollo.QueryHookOptions<PlaylistLandingDataQuery, PlaylistLandingDataQueryVariables> & ({ variables: PlaylistLandingDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlaylistLandingDataQuery, PlaylistLandingDataQueryVariables>(PlaylistLandingDataDocument, options);
      }
export function usePlaylistLandingDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlaylistLandingDataQuery, PlaylistLandingDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlaylistLandingDataQuery, PlaylistLandingDataQueryVariables>(PlaylistLandingDataDocument, options);
        }
export function usePlaylistLandingDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlaylistLandingDataQuery, PlaylistLandingDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlaylistLandingDataQuery, PlaylistLandingDataQueryVariables>(PlaylistLandingDataDocument, options);
        }
export type PlaylistLandingDataQueryHookResult = ReturnType<typeof usePlaylistLandingDataQuery>;
export type PlaylistLandingDataLazyQueryHookResult = ReturnType<typeof usePlaylistLandingDataLazyQuery>;
export type PlaylistLandingDataSuspenseQueryHookResult = ReturnType<typeof usePlaylistLandingDataSuspenseQuery>;
export type PlaylistLandingDataQueryResult = Apollo.QueryResult<PlaylistLandingDataQuery, PlaylistLandingDataQueryVariables>;
export const PlaylistsLandingDocument = gql`
    query playlistsLanding {
  featuredPlaylists: playlists(inFeaturedSlot: true, order: {featuredSlot: ASC}) {
    nodes {
      ...PlaylistInfo
      featuredSlotNumber
      videos {
        totalCount
      }
    }
  }
  topicList {
    nodes {
      name
      slug
    }
  }
}
    ${PlaylistInfoFragmentDoc}`;

/**
 * __usePlaylistsLandingQuery__
 *
 * To run a query within a React component, call `usePlaylistsLandingQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlaylistsLandingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlaylistsLandingQuery({
 *   variables: {
 *   },
 * });
 */
export function usePlaylistsLandingQuery(baseOptions?: Apollo.QueryHookOptions<PlaylistsLandingQuery, PlaylistsLandingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlaylistsLandingQuery, PlaylistsLandingQueryVariables>(PlaylistsLandingDocument, options);
      }
export function usePlaylistsLandingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlaylistsLandingQuery, PlaylistsLandingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlaylistsLandingQuery, PlaylistsLandingQueryVariables>(PlaylistsLandingDocument, options);
        }
export function usePlaylistsLandingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlaylistsLandingQuery, PlaylistsLandingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlaylistsLandingQuery, PlaylistsLandingQueryVariables>(PlaylistsLandingDocument, options);
        }
export type PlaylistsLandingQueryHookResult = ReturnType<typeof usePlaylistsLandingQuery>;
export type PlaylistsLandingLazyQueryHookResult = ReturnType<typeof usePlaylistsLandingLazyQuery>;
export type PlaylistsLandingSuspenseQueryHookResult = ReturnType<typeof usePlaylistsLandingSuspenseQuery>;
export type PlaylistsLandingQueryResult = Apollo.QueryResult<PlaylistsLandingQuery, PlaylistsLandingQueryVariables>;
export const PodcastDashboardDocument = gql`
    query podcastDashboard {
  viewer {
    ...UserInfo
    isMember
    isSupporter
    hasMembersMightyNetworkAccess
  }
}
    ${UserInfoFragmentDoc}`;

/**
 * __usePodcastDashboardQuery__
 *
 * To run a query within a React component, call `usePodcastDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `usePodcastDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePodcastDashboardQuery({
 *   variables: {
 *   },
 * });
 */
export function usePodcastDashboardQuery(baseOptions?: Apollo.QueryHookOptions<PodcastDashboardQuery, PodcastDashboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PodcastDashboardQuery, PodcastDashboardQueryVariables>(PodcastDashboardDocument, options);
      }
export function usePodcastDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PodcastDashboardQuery, PodcastDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PodcastDashboardQuery, PodcastDashboardQueryVariables>(PodcastDashboardDocument, options);
        }
export function usePodcastDashboardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PodcastDashboardQuery, PodcastDashboardQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PodcastDashboardQuery, PodcastDashboardQueryVariables>(PodcastDashboardDocument, options);
        }
export type PodcastDashboardQueryHookResult = ReturnType<typeof usePodcastDashboardQuery>;
export type PodcastDashboardLazyQueryHookResult = ReturnType<typeof usePodcastDashboardLazyQuery>;
export type PodcastDashboardSuspenseQueryHookResult = ReturnType<typeof usePodcastDashboardSuspenseQuery>;
export type PodcastDashboardQueryResult = Apollo.QueryResult<PodcastDashboardQuery, PodcastDashboardQueryVariables>;
export const GetRecommendationsSailthruHomePageDocument = gql`
    query getRecommendationsSailthruHomePage($ids: [Int!]) {
  videos(id: $ids) {
    nodes {
      ...FullVideoInfo
    }
  }
}
    ${FullVideoInfoFragmentDoc}`;

/**
 * __useGetRecommendationsSailthruHomePageQuery__
 *
 * To run a query within a React component, call `useGetRecommendationsSailthruHomePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecommendationsSailthruHomePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecommendationsSailthruHomePageQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetRecommendationsSailthruHomePageQuery(baseOptions?: Apollo.QueryHookOptions<GetRecommendationsSailthruHomePageQuery, GetRecommendationsSailthruHomePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecommendationsSailthruHomePageQuery, GetRecommendationsSailthruHomePageQueryVariables>(GetRecommendationsSailthruHomePageDocument, options);
      }
export function useGetRecommendationsSailthruHomePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecommendationsSailthruHomePageQuery, GetRecommendationsSailthruHomePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecommendationsSailthruHomePageQuery, GetRecommendationsSailthruHomePageQueryVariables>(GetRecommendationsSailthruHomePageDocument, options);
        }
export function useGetRecommendationsSailthruHomePageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRecommendationsSailthruHomePageQuery, GetRecommendationsSailthruHomePageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRecommendationsSailthruHomePageQuery, GetRecommendationsSailthruHomePageQueryVariables>(GetRecommendationsSailthruHomePageDocument, options);
        }
export type GetRecommendationsSailthruHomePageQueryHookResult = ReturnType<typeof useGetRecommendationsSailthruHomePageQuery>;
export type GetRecommendationsSailthruHomePageLazyQueryHookResult = ReturnType<typeof useGetRecommendationsSailthruHomePageLazyQuery>;
export type GetRecommendationsSailthruHomePageSuspenseQueryHookResult = ReturnType<typeof useGetRecommendationsSailthruHomePageSuspenseQuery>;
export type GetRecommendationsSailthruHomePageQueryResult = Apollo.QueryResult<GetRecommendationsSailthruHomePageQuery, GetRecommendationsSailthruHomePageQueryVariables>;
export const RedeemViewerDocument = gql`
    query RedeemViewer {
  viewer {
    ...UserInfo
    isMember
  }
}
    ${UserInfoFragmentDoc}`;

/**
 * __useRedeemViewerQuery__
 *
 * To run a query within a React component, call `useRedeemViewerQuery` and pass it any options that fit your needs.
 * When your component renders, `useRedeemViewerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRedeemViewerQuery({
 *   variables: {
 *   },
 * });
 */
export function useRedeemViewerQuery(baseOptions?: Apollo.QueryHookOptions<RedeemViewerQuery, RedeemViewerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RedeemViewerQuery, RedeemViewerQueryVariables>(RedeemViewerDocument, options);
      }
export function useRedeemViewerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RedeemViewerQuery, RedeemViewerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RedeemViewerQuery, RedeemViewerQueryVariables>(RedeemViewerDocument, options);
        }
export function useRedeemViewerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RedeemViewerQuery, RedeemViewerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RedeemViewerQuery, RedeemViewerQueryVariables>(RedeemViewerDocument, options);
        }
export type RedeemViewerQueryHookResult = ReturnType<typeof useRedeemViewerQuery>;
export type RedeemViewerLazyQueryHookResult = ReturnType<typeof useRedeemViewerLazyQuery>;
export type RedeemViewerSuspenseQueryHookResult = ReturnType<typeof useRedeemViewerSuspenseQuery>;
export type RedeemViewerQueryResult = Apollo.QueryResult<RedeemViewerQuery, RedeemViewerQueryVariables>;
export const SailthruFallbackNewestDocument = gql`
    query SailthruFallbackNewest {
  newestTalks: videos(first: 4, channel: FEATURED) {
    nodes {
      ...SailthruInfo
      type {
        name
      }
    }
  }
}
    ${SailthruInfoFragmentDoc}`;

/**
 * __useSailthruFallbackNewestQuery__
 *
 * To run a query within a React component, call `useSailthruFallbackNewestQuery` and pass it any options that fit your needs.
 * When your component renders, `useSailthruFallbackNewestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSailthruFallbackNewestQuery({
 *   variables: {
 *   },
 * });
 */
export function useSailthruFallbackNewestQuery(baseOptions?: Apollo.QueryHookOptions<SailthruFallbackNewestQuery, SailthruFallbackNewestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SailthruFallbackNewestQuery, SailthruFallbackNewestQueryVariables>(SailthruFallbackNewestDocument, options);
      }
export function useSailthruFallbackNewestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SailthruFallbackNewestQuery, SailthruFallbackNewestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SailthruFallbackNewestQuery, SailthruFallbackNewestQueryVariables>(SailthruFallbackNewestDocument, options);
        }
export function useSailthruFallbackNewestSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SailthruFallbackNewestQuery, SailthruFallbackNewestQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SailthruFallbackNewestQuery, SailthruFallbackNewestQueryVariables>(SailthruFallbackNewestDocument, options);
        }
export type SailthruFallbackNewestQueryHookResult = ReturnType<typeof useSailthruFallbackNewestQuery>;
export type SailthruFallbackNewestLazyQueryHookResult = ReturnType<typeof useSailthruFallbackNewestLazyQuery>;
export type SailthruFallbackNewestSuspenseQueryHookResult = ReturnType<typeof useSailthruFallbackNewestSuspenseQuery>;
export type SailthruFallbackNewestQueryResult = Apollo.QueryResult<SailthruFallbackNewestQuery, SailthruFallbackNewestQueryVariables>;
export const SailthruFallbackTrendingDocument = gql`
    query SailthruFallbackTrending($topicSlug: String!, $first: Int) {
  trendingTalks: topic(slug: $topicSlug) {
    videos(first: $first) {
      nodes {
        ...SailthruInfo
        type {
          name
        }
      }
    }
  }
}
    ${SailthruInfoFragmentDoc}`;

/**
 * __useSailthruFallbackTrendingQuery__
 *
 * To run a query within a React component, call `useSailthruFallbackTrendingQuery` and pass it any options that fit your needs.
 * When your component renders, `useSailthruFallbackTrendingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSailthruFallbackTrendingQuery({
 *   variables: {
 *      topicSlug: // value for 'topicSlug'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useSailthruFallbackTrendingQuery(baseOptions: Apollo.QueryHookOptions<SailthruFallbackTrendingQuery, SailthruFallbackTrendingQueryVariables> & ({ variables: SailthruFallbackTrendingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SailthruFallbackTrendingQuery, SailthruFallbackTrendingQueryVariables>(SailthruFallbackTrendingDocument, options);
      }
export function useSailthruFallbackTrendingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SailthruFallbackTrendingQuery, SailthruFallbackTrendingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SailthruFallbackTrendingQuery, SailthruFallbackTrendingQueryVariables>(SailthruFallbackTrendingDocument, options);
        }
export function useSailthruFallbackTrendingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SailthruFallbackTrendingQuery, SailthruFallbackTrendingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SailthruFallbackTrendingQuery, SailthruFallbackTrendingQueryVariables>(SailthruFallbackTrendingDocument, options);
        }
export type SailthruFallbackTrendingQueryHookResult = ReturnType<typeof useSailthruFallbackTrendingQuery>;
export type SailthruFallbackTrendingLazyQueryHookResult = ReturnType<typeof useSailthruFallbackTrendingLazyQuery>;
export type SailthruFallbackTrendingSuspenseQueryHookResult = ReturnType<typeof useSailthruFallbackTrendingSuspenseQuery>;
export type SailthruFallbackTrendingQueryResult = Apollo.QueryResult<SailthruFallbackTrendingQuery, SailthruFallbackTrendingQueryVariables>;
export const SailthruFallbackPodcastDocument = gql`
    query SailthruFallbackPodcast {
  podcasts: topic(slug: "podcast") {
    videos(first: 4) {
      nodes {
        ...SailthruInfo
        type {
          name
        }
      }
    }
  }
}
    ${SailthruInfoFragmentDoc}`;

/**
 * __useSailthruFallbackPodcastQuery__
 *
 * To run a query within a React component, call `useSailthruFallbackPodcastQuery` and pass it any options that fit your needs.
 * When your component renders, `useSailthruFallbackPodcastQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSailthruFallbackPodcastQuery({
 *   variables: {
 *   },
 * });
 */
export function useSailthruFallbackPodcastQuery(baseOptions?: Apollo.QueryHookOptions<SailthruFallbackPodcastQuery, SailthruFallbackPodcastQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SailthruFallbackPodcastQuery, SailthruFallbackPodcastQueryVariables>(SailthruFallbackPodcastDocument, options);
      }
export function useSailthruFallbackPodcastLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SailthruFallbackPodcastQuery, SailthruFallbackPodcastQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SailthruFallbackPodcastQuery, SailthruFallbackPodcastQueryVariables>(SailthruFallbackPodcastDocument, options);
        }
export function useSailthruFallbackPodcastSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SailthruFallbackPodcastQuery, SailthruFallbackPodcastQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SailthruFallbackPodcastQuery, SailthruFallbackPodcastQueryVariables>(SailthruFallbackPodcastDocument, options);
        }
export type SailthruFallbackPodcastQueryHookResult = ReturnType<typeof useSailthruFallbackPodcastQuery>;
export type SailthruFallbackPodcastLazyQueryHookResult = ReturnType<typeof useSailthruFallbackPodcastLazyQuery>;
export type SailthruFallbackPodcastSuspenseQueryHookResult = ReturnType<typeof useSailthruFallbackPodcastSuspenseQuery>;
export type SailthruFallbackPodcastQueryResult = Apollo.QueryResult<SailthruFallbackPodcastQuery, SailthruFallbackPodcastQueryVariables>;
export const SailthruNewslettersDocument = gql`
    query SailthruNewsletters {
  viewer {
    id
    primaryEmailAddress
    sailthruVars {
      vars {
        tedRecommendsNewsletterSubscriber
        tedTalksDailyNewsletterSubscriber
        tedEdWeeklyNewsletterSubscriber
        tedTalksTechNewsletterSubscriber
      }
    }
  }
}
    `;

/**
 * __useSailthruNewslettersQuery__
 *
 * To run a query within a React component, call `useSailthruNewslettersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSailthruNewslettersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSailthruNewslettersQuery({
 *   variables: {
 *   },
 * });
 */
export function useSailthruNewslettersQuery(baseOptions?: Apollo.QueryHookOptions<SailthruNewslettersQuery, SailthruNewslettersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SailthruNewslettersQuery, SailthruNewslettersQueryVariables>(SailthruNewslettersDocument, options);
      }
export function useSailthruNewslettersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SailthruNewslettersQuery, SailthruNewslettersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SailthruNewslettersQuery, SailthruNewslettersQueryVariables>(SailthruNewslettersDocument, options);
        }
export function useSailthruNewslettersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SailthruNewslettersQuery, SailthruNewslettersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SailthruNewslettersQuery, SailthruNewslettersQueryVariables>(SailthruNewslettersDocument, options);
        }
export type SailthruNewslettersQueryHookResult = ReturnType<typeof useSailthruNewslettersQuery>;
export type SailthruNewslettersLazyQueryHookResult = ReturnType<typeof useSailthruNewslettersLazyQuery>;
export type SailthruNewslettersSuspenseQueryHookResult = ReturnType<typeof useSailthruNewslettersSuspenseQuery>;
export type SailthruNewslettersQueryResult = Apollo.QueryResult<SailthruNewslettersQuery, SailthruNewslettersQueryVariables>;
export const SavedListDocument = gql`
    query savedList {
  viewer {
    id
    savedTalks {
      nodes {
        itemId
      }
    }
    savedPlaylists {
      id
      title
      primaryImageSet {
        url
      }
      videos {
        nodes {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useSavedListQuery__
 *
 * To run a query within a React component, call `useSavedListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSavedListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSavedListQuery({
 *   variables: {
 *   },
 * });
 */
export function useSavedListQuery(baseOptions?: Apollo.QueryHookOptions<SavedListQuery, SavedListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SavedListQuery, SavedListQueryVariables>(SavedListDocument, options);
      }
export function useSavedListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SavedListQuery, SavedListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SavedListQuery, SavedListQueryVariables>(SavedListDocument, options);
        }
export function useSavedListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SavedListQuery, SavedListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SavedListQuery, SavedListQueryVariables>(SavedListDocument, options);
        }
export type SavedListQueryHookResult = ReturnType<typeof useSavedListQuery>;
export type SavedListLazyQueryHookResult = ReturnType<typeof useSavedListLazyQuery>;
export type SavedListSuspenseQueryHookResult = ReturnType<typeof useSavedListSuspenseQuery>;
export type SavedListQueryResult = Apollo.QueryResult<SavedListQuery, SavedListQueryVariables>;
export const SeriesDocument = gql`
    query series($slug: String!, $after: String, $before: String) {
  series(slug: $slug) {
    id
    name
    publishedPlaylistCount
    slug
    playlists {
      nodes {
        ...PlaylistInfo
        videos(after: $after, before: $before) {
          totalCount
          pageInfo {
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
          }
          nodes {
            ...VideoInfo
            type {
              name
            }
          }
        }
      }
    }
  }
}
    ${PlaylistInfoFragmentDoc}
${VideoInfoFragmentDoc}`;

/**
 * __useSeriesQuery__
 *
 * To run a query within a React component, call `useSeriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSeriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSeriesQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useSeriesQuery(baseOptions: Apollo.QueryHookOptions<SeriesQuery, SeriesQueryVariables> & ({ variables: SeriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SeriesQuery, SeriesQueryVariables>(SeriesDocument, options);
      }
export function useSeriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SeriesQuery, SeriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SeriesQuery, SeriesQueryVariables>(SeriesDocument, options);
        }
export function useSeriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SeriesQuery, SeriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SeriesQuery, SeriesQueryVariables>(SeriesDocument, options);
        }
export type SeriesQueryHookResult = ReturnType<typeof useSeriesQuery>;
export type SeriesLazyQueryHookResult = ReturnType<typeof useSeriesLazyQuery>;
export type SeriesSuspenseQueryHookResult = ReturnType<typeof useSeriesSuspenseQuery>;
export type SeriesQueryResult = Apollo.QueryResult<SeriesQuery, SeriesQueryVariables>;
export const SettingsDashboardDocument = gql`
    query settingsDashboard {
  viewer {
    ...UserInfo
    isMember
    isGiftedMember
    hasMembersMightyNetworkAccess
    isSupporter
    giftMembership {
      createdAt
      expiresAt
      durationMonths
      redeemedAt
    }
    membershipSubscription {
      id
      transactionId
      expiresAt
      createdAt
      skuId
      stripePrice
      isCancelled
    }
    defaultPaymentMethod {
      id
      card {
        last4
      }
    }
    paymentMethods {
      id
      card {
        brand
        expYear
        expMonth
        last4
      }
    }
  }
}
    ${UserInfoFragmentDoc}`;

/**
 * __useSettingsDashboardQuery__
 *
 * To run a query within a React component, call `useSettingsDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettingsDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSettingsDashboardQuery({
 *   variables: {
 *   },
 * });
 */
export function useSettingsDashboardQuery(baseOptions?: Apollo.QueryHookOptions<SettingsDashboardQuery, SettingsDashboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SettingsDashboardQuery, SettingsDashboardQueryVariables>(SettingsDashboardDocument, options);
      }
export function useSettingsDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SettingsDashboardQuery, SettingsDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SettingsDashboardQuery, SettingsDashboardQueryVariables>(SettingsDashboardDocument, options);
        }
export function useSettingsDashboardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SettingsDashboardQuery, SettingsDashboardQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SettingsDashboardQuery, SettingsDashboardQueryVariables>(SettingsDashboardDocument, options);
        }
export type SettingsDashboardQueryHookResult = ReturnType<typeof useSettingsDashboardQuery>;
export type SettingsDashboardLazyQueryHookResult = ReturnType<typeof useSettingsDashboardLazyQuery>;
export type SettingsDashboardSuspenseQueryHookResult = ReturnType<typeof useSettingsDashboardSuspenseQuery>;
export type SettingsDashboardQueryResult = Apollo.QueryResult<SettingsDashboardQuery, SettingsDashboardQueryVariables>;
export const ShareLinksDocument = gql`
    query shareLinks($slug: String!, $language: String) {
  videos(
    slug: [$slug]
    language: $language
    first: 1
    isPublished: [true, false]
    channel: ALL
  ) {
    nodes {
      id
      canonicalUrl
      audioDownload
      nativeDownloads {
        low
        medium
        high
      }
      subtitledDownloads {
        low
        high
        internalLanguageCode
        languageName
      }
    }
  }
}
    `;

/**
 * __useShareLinksQuery__
 *
 * To run a query within a React component, call `useShareLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useShareLinksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShareLinksQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useShareLinksQuery(baseOptions: Apollo.QueryHookOptions<ShareLinksQuery, ShareLinksQueryVariables> & ({ variables: ShareLinksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShareLinksQuery, ShareLinksQueryVariables>(ShareLinksDocument, options);
      }
export function useShareLinksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShareLinksQuery, ShareLinksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShareLinksQuery, ShareLinksQueryVariables>(ShareLinksDocument, options);
        }
export function useShareLinksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ShareLinksQuery, ShareLinksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ShareLinksQuery, ShareLinksQueryVariables>(ShareLinksDocument, options);
        }
export type ShareLinksQueryHookResult = ReturnType<typeof useShareLinksQuery>;
export type ShareLinksLazyQueryHookResult = ReturnType<typeof useShareLinksLazyQuery>;
export type ShareLinksSuspenseQueryHookResult = ReturnType<typeof useShareLinksSuspenseQuery>;
export type ShareLinksQueryResult = Apollo.QueryResult<ShareLinksQuery, ShareLinksQueryVariables>;
export const RelatedVideosDocument = gql`
    query relatedVideos($id: Int!, $language: String, $count: Int!) {
  videos(
    id: [$id]
    isPublished: [true, false]
    language: $language
    channel: ALL
    first: 1
  ) {
    nodes {
      relatedVideos(count: $count, language: $language) {
        ...VideoInfo
      }
    }
  }
}
    ${VideoInfoFragmentDoc}`;

/**
 * __useRelatedVideosQuery__
 *
 * To run a query within a React component, call `useRelatedVideosQuery` and pass it any options that fit your needs.
 * When your component renders, `useRelatedVideosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRelatedVideosQuery({
 *   variables: {
 *      id: // value for 'id'
 *      language: // value for 'language'
 *      count: // value for 'count'
 *   },
 * });
 */
export function useRelatedVideosQuery(baseOptions: Apollo.QueryHookOptions<RelatedVideosQuery, RelatedVideosQueryVariables> & ({ variables: RelatedVideosQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RelatedVideosQuery, RelatedVideosQueryVariables>(RelatedVideosDocument, options);
      }
export function useRelatedVideosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RelatedVideosQuery, RelatedVideosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RelatedVideosQuery, RelatedVideosQueryVariables>(RelatedVideosDocument, options);
        }
export function useRelatedVideosSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RelatedVideosQuery, RelatedVideosQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RelatedVideosQuery, RelatedVideosQueryVariables>(RelatedVideosDocument, options);
        }
export type RelatedVideosQueryHookResult = ReturnType<typeof useRelatedVideosQuery>;
export type RelatedVideosLazyQueryHookResult = ReturnType<typeof useRelatedVideosLazyQuery>;
export type RelatedVideosSuspenseQueryHookResult = ReturnType<typeof useRelatedVideosSuspenseQuery>;
export type RelatedVideosQueryResult = Apollo.QueryResult<RelatedVideosQuery, RelatedVideosQueryVariables>;
export const SubtitleCreditsDocument = gql`
    query subtitleCredits($id: ID!, $language: String!) {
  translation(videoId: $id, language: $language) {
    ...TranslationInfo
  }
}
    ${TranslationInfoFragmentDoc}`;

/**
 * __useSubtitleCreditsQuery__
 *
 * To run a query within a React component, call `useSubtitleCreditsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubtitleCreditsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubtitleCreditsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useSubtitleCreditsQuery(baseOptions: Apollo.QueryHookOptions<SubtitleCreditsQuery, SubtitleCreditsQueryVariables> & ({ variables: SubtitleCreditsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubtitleCreditsQuery, SubtitleCreditsQueryVariables>(SubtitleCreditsDocument, options);
      }
export function useSubtitleCreditsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubtitleCreditsQuery, SubtitleCreditsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubtitleCreditsQuery, SubtitleCreditsQueryVariables>(SubtitleCreditsDocument, options);
        }
export function useSubtitleCreditsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubtitleCreditsQuery, SubtitleCreditsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SubtitleCreditsQuery, SubtitleCreditsQueryVariables>(SubtitleCreditsDocument, options);
        }
export type SubtitleCreditsQueryHookResult = ReturnType<typeof useSubtitleCreditsQuery>;
export type SubtitleCreditsLazyQueryHookResult = ReturnType<typeof useSubtitleCreditsLazyQuery>;
export type SubtitleCreditsSuspenseQueryHookResult = ReturnType<typeof useSubtitleCreditsSuspenseQuery>;
export type SubtitleCreditsQueryResult = Apollo.QueryResult<SubtitleCreditsQuery, SubtitleCreditsQueryVariables>;
export const SupportViewerDocument = gql`
    query SupportViewer {
  viewer {
    ...UserInfo
    isMember
  }
}
    ${UserInfoFragmentDoc}`;

/**
 * __useSupportViewerQuery__
 *
 * To run a query within a React component, call `useSupportViewerQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupportViewerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupportViewerQuery({
 *   variables: {
 *   },
 * });
 */
export function useSupportViewerQuery(baseOptions?: Apollo.QueryHookOptions<SupportViewerQuery, SupportViewerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SupportViewerQuery, SupportViewerQueryVariables>(SupportViewerDocument, options);
      }
export function useSupportViewerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SupportViewerQuery, SupportViewerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SupportViewerQuery, SupportViewerQueryVariables>(SupportViewerDocument, options);
        }
export function useSupportViewerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SupportViewerQuery, SupportViewerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SupportViewerQuery, SupportViewerQueryVariables>(SupportViewerDocument, options);
        }
export type SupportViewerQueryHookResult = ReturnType<typeof useSupportViewerQuery>;
export type SupportViewerLazyQueryHookResult = ReturnType<typeof useSupportViewerLazyQuery>;
export type SupportViewerSuspenseQueryHookResult = ReturnType<typeof useSupportViewerSuspenseQuery>;
export type SupportViewerQueryResult = Apollo.QueryResult<SupportViewerQuery, SupportViewerQueryVariables>;
export const TalkDetailsBySlugDocument = gql`
    query talkDetailsBySlug($slug: String) {
  video(slug: $slug) {
    ...VideoInfo
    playerData
    description
    topics {
      nodes {
        name
      }
    }
    type {
      name
    }
  }
}
    ${VideoInfoFragmentDoc}`;

/**
 * __useTalkDetailsBySlugQuery__
 *
 * To run a query within a React component, call `useTalkDetailsBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useTalkDetailsBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTalkDetailsBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useTalkDetailsBySlugQuery(baseOptions?: Apollo.QueryHookOptions<TalkDetailsBySlugQuery, TalkDetailsBySlugQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TalkDetailsBySlugQuery, TalkDetailsBySlugQueryVariables>(TalkDetailsBySlugDocument, options);
      }
export function useTalkDetailsBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TalkDetailsBySlugQuery, TalkDetailsBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TalkDetailsBySlugQuery, TalkDetailsBySlugQueryVariables>(TalkDetailsBySlugDocument, options);
        }
export function useTalkDetailsBySlugSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TalkDetailsBySlugQuery, TalkDetailsBySlugQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TalkDetailsBySlugQuery, TalkDetailsBySlugQueryVariables>(TalkDetailsBySlugDocument, options);
        }
export type TalkDetailsBySlugQueryHookResult = ReturnType<typeof useTalkDetailsBySlugQuery>;
export type TalkDetailsBySlugLazyQueryHookResult = ReturnType<typeof useTalkDetailsBySlugLazyQuery>;
export type TalkDetailsBySlugSuspenseQueryHookResult = ReturnType<typeof useTalkDetailsBySlugSuspenseQuery>;
export type TalkDetailsBySlugQueryResult = Apollo.QueryResult<TalkDetailsBySlugQuery, TalkDetailsBySlugQueryVariables>;
export const TalkDetailsDocument = gql`
    query talkDetails($id: ID!, $language: String) {
  video(id: $id, language: $language) {
    id
    title
    description
  }
}
    `;

/**
 * __useTalkDetailsQuery__
 *
 * To run a query within a React component, call `useTalkDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTalkDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTalkDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useTalkDetailsQuery(baseOptions: Apollo.QueryHookOptions<TalkDetailsQuery, TalkDetailsQueryVariables> & ({ variables: TalkDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TalkDetailsQuery, TalkDetailsQueryVariables>(TalkDetailsDocument, options);
      }
export function useTalkDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TalkDetailsQuery, TalkDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TalkDetailsQuery, TalkDetailsQueryVariables>(TalkDetailsDocument, options);
        }
export function useTalkDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TalkDetailsQuery, TalkDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TalkDetailsQuery, TalkDetailsQueryVariables>(TalkDetailsDocument, options);
        }
export type TalkDetailsQueryHookResult = ReturnType<typeof useTalkDetailsQuery>;
export type TalkDetailsLazyQueryHookResult = ReturnType<typeof useTalkDetailsLazyQuery>;
export type TalkDetailsSuspenseQueryHookResult = ReturnType<typeof useTalkDetailsSuspenseQuery>;
export type TalkDetailsQueryResult = Apollo.QueryResult<TalkDetailsQuery, TalkDetailsQueryVariables>;
export const VideoSlugDocument = gql`
    query videoSlug($id: [Int!], $language: String, $isPublished: [Boolean!]) {
  videos(
    id: $id
    language: $language
    isPublished: $isPublished
    first: 1
    channel: ALL
  ) {
    nodes {
      id
      slug
    }
  }
}
    `;

/**
 * __useVideoSlugQuery__
 *
 * To run a query within a React component, call `useVideoSlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useVideoSlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVideoSlugQuery({
 *   variables: {
 *      id: // value for 'id'
 *      language: // value for 'language'
 *      isPublished: // value for 'isPublished'
 *   },
 * });
 */
export function useVideoSlugQuery(baseOptions?: Apollo.QueryHookOptions<VideoSlugQuery, VideoSlugQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VideoSlugQuery, VideoSlugQueryVariables>(VideoSlugDocument, options);
      }
export function useVideoSlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VideoSlugQuery, VideoSlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VideoSlugQuery, VideoSlugQueryVariables>(VideoSlugDocument, options);
        }
export function useVideoSlugSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VideoSlugQuery, VideoSlugQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VideoSlugQuery, VideoSlugQueryVariables>(VideoSlugDocument, options);
        }
export type VideoSlugQueryHookResult = ReturnType<typeof useVideoSlugQuery>;
export type VideoSlugLazyQueryHookResult = ReturnType<typeof useVideoSlugLazyQuery>;
export type VideoSlugSuspenseQueryHookResult = ReturnType<typeof useVideoSlugSuspenseQuery>;
export type VideoSlugQueryResult = Apollo.QueryResult<VideoSlugQuery, VideoSlugQueryVariables>;
export const TopicLandingDataDocument = gql`
    query topicLandingData($slug: String!, $playlistsCount: Int = 4, $talksCount: Int = 16) {
  topic(slug: $slug) {
    id
    name
    playlists(first: $playlistsCount) {
      totalCount
      nodes {
        ...PlaylistInfo
        videos {
          totalCount
        }
      }
    }
    videos(first: $talksCount) {
      totalCount
      nodes {
        ...VideoInfo
        type {
          name
        }
      }
    }
  }
}
    ${PlaylistInfoFragmentDoc}
${VideoInfoFragmentDoc}`;

/**
 * __useTopicLandingDataQuery__
 *
 * To run a query within a React component, call `useTopicLandingDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopicLandingDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopicLandingDataQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      playlistsCount: // value for 'playlistsCount'
 *      talksCount: // value for 'talksCount'
 *   },
 * });
 */
export function useTopicLandingDataQuery(baseOptions: Apollo.QueryHookOptions<TopicLandingDataQuery, TopicLandingDataQueryVariables> & ({ variables: TopicLandingDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TopicLandingDataQuery, TopicLandingDataQueryVariables>(TopicLandingDataDocument, options);
      }
export function useTopicLandingDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TopicLandingDataQuery, TopicLandingDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TopicLandingDataQuery, TopicLandingDataQueryVariables>(TopicLandingDataDocument, options);
        }
export function useTopicLandingDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TopicLandingDataQuery, TopicLandingDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TopicLandingDataQuery, TopicLandingDataQueryVariables>(TopicLandingDataDocument, options);
        }
export type TopicLandingDataQueryHookResult = ReturnType<typeof useTopicLandingDataQuery>;
export type TopicLandingDataLazyQueryHookResult = ReturnType<typeof useTopicLandingDataLazyQuery>;
export type TopicLandingDataSuspenseQueryHookResult = ReturnType<typeof useTopicLandingDataSuspenseQuery>;
export type TopicLandingDataQueryResult = Apollo.QueryResult<TopicLandingDataQuery, TopicLandingDataQueryVariables>;
export const TopicListDocument = gql`
    query topicList {
  topicList {
    nodes {
      name
      slug
    }
  }
}
    `;

/**
 * __useTopicListQuery__
 *
 * To run a query within a React component, call `useTopicListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopicListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopicListQuery({
 *   variables: {
 *   },
 * });
 */
export function useTopicListQuery(baseOptions?: Apollo.QueryHookOptions<TopicListQuery, TopicListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TopicListQuery, TopicListQueryVariables>(TopicListDocument, options);
      }
export function useTopicListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TopicListQuery, TopicListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TopicListQuery, TopicListQueryVariables>(TopicListDocument, options);
        }
export function useTopicListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TopicListQuery, TopicListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TopicListQuery, TopicListQueryVariables>(TopicListDocument, options);
        }
export type TopicListQueryHookResult = ReturnType<typeof useTopicListQuery>;
export type TopicListLazyQueryHookResult = ReturnType<typeof useTopicListLazyQuery>;
export type TopicListSuspenseQueryHookResult = ReturnType<typeof useTopicListSuspenseQuery>;
export type TopicListQueryResult = Apollo.QueryResult<TopicListQuery, TopicListQueryVariables>;
export const TranscriptDocument = gql`
    query Transcript($id: ID!, $language: String!) {
  translation(videoId: $id, language: $language) {
    ...TranslationInfo
    paragraphs {
      cues {
        text
        time
      }
    }
  }
  video(id: $id, language: $language) {
    id
    talkExtras {
      footnotes {
        author
        annotation
        date
        linkUrl
        source
        text
        timecode
        title
        category
      }
    }
  }
}
    ${TranslationInfoFragmentDoc}`;

/**
 * __useTranscriptQuery__
 *
 * To run a query within a React component, call `useTranscriptQuery` and pass it any options that fit your needs.
 * When your component renders, `useTranscriptQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTranscriptQuery({
 *   variables: {
 *      id: // value for 'id'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useTranscriptQuery(baseOptions: Apollo.QueryHookOptions<TranscriptQuery, TranscriptQueryVariables> & ({ variables: TranscriptQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TranscriptQuery, TranscriptQueryVariables>(TranscriptDocument, options);
      }
export function useTranscriptLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TranscriptQuery, TranscriptQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TranscriptQuery, TranscriptQueryVariables>(TranscriptDocument, options);
        }
export function useTranscriptSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TranscriptQuery, TranscriptQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TranscriptQuery, TranscriptQueryVariables>(TranscriptDocument, options);
        }
export type TranscriptQueryHookResult = ReturnType<typeof useTranscriptQuery>;
export type TranscriptLazyQueryHookResult = ReturnType<typeof useTranscriptLazyQuery>;
export type TranscriptSuspenseQueryHookResult = ReturnType<typeof useTranscriptSuspenseQuery>;
export type TranscriptQueryResult = Apollo.QueryResult<TranscriptQuery, TranscriptQueryVariables>;
export const UserAccountInterestsDocument = gql`
    query UserAccountInterests {
  viewer {
    id
    preferredLanguage {
      id
      name
    }
    bornOn
    industry {
      id
      name
    }
    primaryEmailAddress
    sailthruVars {
      vars {
        tedRecommendsNewsletterSubscriber
        tedTalksDailyNewsletterSubscriber
        tedEdDailyNewsletterSubscriber
        tedEdWeeklyNewsletterSubscriber
        countdownNewsletterSubscriber
        tedTalksTechNewsletterSubscriber
        supertopicArtAndDesign
        supertopicBusiness
        supertopicClimateChange
        supertopicEducation
        supertopicHealth
        supertopicMusicAndPerformance
        supertopicNature
        supertopicPersonalGrowth
        supertopicPsychology
        supertopicScience
        supertopicSocietyAndCulture
        supertopicSurpriseMe
        supertopicTechnology
        tedUpdatesSubscriber
        tedUpdatesConferences
        tedUpdatesOnlineEvents
        tedUpdatesImpact
        tedUpdatesSupport
      }
    }
  }
}
    `;

/**
 * __useUserAccountInterestsQuery__
 *
 * To run a query within a React component, call `useUserAccountInterestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserAccountInterestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserAccountInterestsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserAccountInterestsQuery(baseOptions?: Apollo.QueryHookOptions<UserAccountInterestsQuery, UserAccountInterestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserAccountInterestsQuery, UserAccountInterestsQueryVariables>(UserAccountInterestsDocument, options);
      }
export function useUserAccountInterestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserAccountInterestsQuery, UserAccountInterestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserAccountInterestsQuery, UserAccountInterestsQueryVariables>(UserAccountInterestsDocument, options);
        }
export function useUserAccountInterestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserAccountInterestsQuery, UserAccountInterestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserAccountInterestsQuery, UserAccountInterestsQueryVariables>(UserAccountInterestsDocument, options);
        }
export type UserAccountInterestsQueryHookResult = ReturnType<typeof useUserAccountInterestsQuery>;
export type UserAccountInterestsLazyQueryHookResult = ReturnType<typeof useUserAccountInterestsLazyQuery>;
export type UserAccountInterestsSuspenseQueryHookResult = ReturnType<typeof useUserAccountInterestsSuspenseQuery>;
export type UserAccountInterestsQueryResult = Apollo.QueryResult<UserAccountInterestsQuery, UserAccountInterestsQueryVariables>;
export const VideoDataDocument = gql`
    query videoData($id: [Int!], $slug: [String!], $language: String, $isPublished: [Boolean!] = [true]) {
  videos(
    id: $id
    slug: $slug
    language: $language
    isPublished: $isPublished
    first: 1
    channel: ALL
  ) {
    nodes {
      ...FullVideoInfo
      playerData
      takeaways {
        nodes {
          id
          text
          talkstarTalkId
          offsetSeconds
        }
      }
      talkExtras {
        learnModules {
          author
          blurb
          eyebrow
          headline
          imageUrl
          linkUrl
          published
          publisher
          status
          type
          visibleUrl
          year
        }
        takeAction {
          blurb
          endAt
          eyebrow
          linkUrl
          published
          startAt
          status
          verb
          visibleUrl
        }
        recommendations {
          blurb
          recLists {
            title
            description
            recItems {
              blurb
              eyebrow
              headline
              isPdf
              label
              linkUrl
              note
            }
          }
        }
      }
      relatedVideos {
        slug
        id
      }
      speakers {
        nodes {
          ...SpeakerInfo
        }
      }
      type {
        id
        name
      }
    }
  }
}
    ${FullVideoInfoFragmentDoc}
${SpeakerInfoFragmentDoc}`;

/**
 * __useVideoDataQuery__
 *
 * To run a query within a React component, call `useVideoDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useVideoDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVideoDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *      slug: // value for 'slug'
 *      language: // value for 'language'
 *      isPublished: // value for 'isPublished'
 *   },
 * });
 */
export function useVideoDataQuery(baseOptions?: Apollo.QueryHookOptions<VideoDataQuery, VideoDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VideoDataQuery, VideoDataQueryVariables>(VideoDataDocument, options);
      }
export function useVideoDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VideoDataQuery, VideoDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VideoDataQuery, VideoDataQueryVariables>(VideoDataDocument, options);
        }
export function useVideoDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VideoDataQuery, VideoDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VideoDataQuery, VideoDataQueryVariables>(VideoDataDocument, options);
        }
export type VideoDataQueryHookResult = ReturnType<typeof useVideoDataQuery>;
export type VideoDataLazyQueryHookResult = ReturnType<typeof useVideoDataLazyQuery>;
export type VideoDataSuspenseQueryHookResult = ReturnType<typeof useVideoDataSuspenseQuery>;
export type VideoDataQueryResult = Apollo.QueryResult<VideoDataQuery, VideoDataQueryVariables>;
export const VideosByIdDocument = gql`
    query videosById($id: [Int!]) {
  videos(id: $id, isPublished: true) {
    edges {
      node {
        ...VideoInfo
        description
      }
    }
  }
}
    ${VideoInfoFragmentDoc}`;

/**
 * __useVideosByIdQuery__
 *
 * To run a query within a React component, call `useVideosByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useVideosByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVideosByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVideosByIdQuery(baseOptions?: Apollo.QueryHookOptions<VideosByIdQuery, VideosByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VideosByIdQuery, VideosByIdQueryVariables>(VideosByIdDocument, options);
      }
export function useVideosByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VideosByIdQuery, VideosByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VideosByIdQuery, VideosByIdQueryVariables>(VideosByIdDocument, options);
        }
export function useVideosByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VideosByIdQuery, VideosByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VideosByIdQuery, VideosByIdQueryVariables>(VideosByIdDocument, options);
        }
export type VideosByIdQueryHookResult = ReturnType<typeof useVideosByIdQuery>;
export type VideosByIdLazyQueryHookResult = ReturnType<typeof useVideosByIdLazyQuery>;
export type VideosByIdSuspenseQueryHookResult = ReturnType<typeof useVideosByIdSuspenseQuery>;
export type VideosByIdQueryResult = Apollo.QueryResult<VideosByIdQuery, VideosByIdQueryVariables>;
export const VideosDocument = gql`
    query videos($id: [Int!], $first: Int, $after: String) {
  videos(id: $id, first: $first, after: $after, channel: ALL, isPublished: true) {
    edges {
      cursor
      node {
        ...VideoInfo
        type {
          name
        }
        speakers {
          nodes {
            firstname
            middlename
            lastname
          }
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
    totalCount
  }
}
    ${VideoInfoFragmentDoc}`;

/**
 * __useVideosQuery__
 *
 * To run a query within a React component, call `useVideosQuery` and pass it any options that fit your needs.
 * When your component renders, `useVideosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVideosQuery({
 *   variables: {
 *      id: // value for 'id'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useVideosQuery(baseOptions?: Apollo.QueryHookOptions<VideosQuery, VideosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VideosQuery, VideosQueryVariables>(VideosDocument, options);
      }
export function useVideosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VideosQuery, VideosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VideosQuery, VideosQueryVariables>(VideosDocument, options);
        }
export function useVideosSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VideosQuery, VideosQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VideosQuery, VideosQueryVariables>(VideosDocument, options);
        }
export type VideosQueryHookResult = ReturnType<typeof useVideosQuery>;
export type VideosLazyQueryHookResult = ReturnType<typeof useVideosLazyQuery>;
export type VideosSuspenseQueryHookResult = ReturnType<typeof useVideosSuspenseQuery>;
export type VideosQueryResult = Apollo.QueryResult<VideosQuery, VideosQueryVariables>;
export const VideosBySlugDocument = gql`
    query videosBySlug($id: [Int!], $slug: [String!], $language: String, $isPublished: [Boolean!] = [true]) {
  videos(
    id: $id
    slug: $slug
    language: $language
    isPublished: $isPublished
    channel: ALL
  ) {
    nodes {
      ...FullVideoInfo
      speakers {
        nodes {
          ...SpeakerInfo
        }
      }
      type {
        id
        name
      }
    }
  }
}
    ${FullVideoInfoFragmentDoc}
${SpeakerInfoFragmentDoc}`;

/**
 * __useVideosBySlugQuery__
 *
 * To run a query within a React component, call `useVideosBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useVideosBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVideosBySlugQuery({
 *   variables: {
 *      id: // value for 'id'
 *      slug: // value for 'slug'
 *      language: // value for 'language'
 *      isPublished: // value for 'isPublished'
 *   },
 * });
 */
export function useVideosBySlugQuery(baseOptions?: Apollo.QueryHookOptions<VideosBySlugQuery, VideosBySlugQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VideosBySlugQuery, VideosBySlugQueryVariables>(VideosBySlugDocument, options);
      }
export function useVideosBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VideosBySlugQuery, VideosBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VideosBySlugQuery, VideosBySlugQueryVariables>(VideosBySlugDocument, options);
        }
export function useVideosBySlugSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VideosBySlugQuery, VideosBySlugQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VideosBySlugQuery, VideosBySlugQueryVariables>(VideosBySlugDocument, options);
        }
export type VideosBySlugQueryHookResult = ReturnType<typeof useVideosBySlugQuery>;
export type VideosBySlugLazyQueryHookResult = ReturnType<typeof useVideosBySlugLazyQuery>;
export type VideosBySlugSuspenseQueryHookResult = ReturnType<typeof useVideosBySlugSuspenseQuery>;
export type VideosBySlugQueryResult = Apollo.QueryResult<VideosBySlugQuery, VideosBySlugQueryVariables>;
export const TakeawaysViewerDataDocument = gql`
    query takeawaysViewerData($filter: FavoritesFilter, $order: String, $limit: Int, $after: String = "") {
  viewer {
    id
    favorites(filter: $filter, order: $order, first: $limit, after: $after) {
      edges {
        cursor
        node {
          ...FavoriteNode
        }
      }
      pageInfo {
        hasPreviousPage
        hasNextPage
        endCursor
      }
    }
  }
}
    ${FavoriteNodeFragmentDoc}`;

/**
 * __useTakeawaysViewerDataQuery__
 *
 * To run a query within a React component, call `useTakeawaysViewerDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useTakeawaysViewerDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTakeawaysViewerDataQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      order: // value for 'order'
 *      limit: // value for 'limit'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useTakeawaysViewerDataQuery(baseOptions?: Apollo.QueryHookOptions<TakeawaysViewerDataQuery, TakeawaysViewerDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TakeawaysViewerDataQuery, TakeawaysViewerDataQueryVariables>(TakeawaysViewerDataDocument, options);
      }
export function useTakeawaysViewerDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TakeawaysViewerDataQuery, TakeawaysViewerDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TakeawaysViewerDataQuery, TakeawaysViewerDataQueryVariables>(TakeawaysViewerDataDocument, options);
        }
export function useTakeawaysViewerDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TakeawaysViewerDataQuery, TakeawaysViewerDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TakeawaysViewerDataQuery, TakeawaysViewerDataQueryVariables>(TakeawaysViewerDataDocument, options);
        }
export type TakeawaysViewerDataQueryHookResult = ReturnType<typeof useTakeawaysViewerDataQuery>;
export type TakeawaysViewerDataLazyQueryHookResult = ReturnType<typeof useTakeawaysViewerDataLazyQuery>;
export type TakeawaysViewerDataSuspenseQueryHookResult = ReturnType<typeof useTakeawaysViewerDataSuspenseQuery>;
export type TakeawaysViewerDataQueryResult = Apollo.QueryResult<TakeawaysViewerDataQuery, TakeawaysViewerDataQueryVariables>;
export const TakeawaysViewerDocument = gql`
    query takeawaysViewer($order: String = "desc") {
  viewer {
    id
    favorites(order: $order) {
      nodes {
        id
        favoriteable {
          id
          type
        }
      }
    }
  }
}
    `;

/**
 * __useTakeawaysViewerQuery__
 *
 * To run a query within a React component, call `useTakeawaysViewerQuery` and pass it any options that fit your needs.
 * When your component renders, `useTakeawaysViewerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTakeawaysViewerQuery({
 *   variables: {
 *      order: // value for 'order'
 *   },
 * });
 */
export function useTakeawaysViewerQuery(baseOptions?: Apollo.QueryHookOptions<TakeawaysViewerQuery, TakeawaysViewerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TakeawaysViewerQuery, TakeawaysViewerQueryVariables>(TakeawaysViewerDocument, options);
      }
export function useTakeawaysViewerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TakeawaysViewerQuery, TakeawaysViewerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TakeawaysViewerQuery, TakeawaysViewerQueryVariables>(TakeawaysViewerDocument, options);
        }
export function useTakeawaysViewerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TakeawaysViewerQuery, TakeawaysViewerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TakeawaysViewerQuery, TakeawaysViewerQueryVariables>(TakeawaysViewerDocument, options);
        }
export type TakeawaysViewerQueryHookResult = ReturnType<typeof useTakeawaysViewerQuery>;
export type TakeawaysViewerLazyQueryHookResult = ReturnType<typeof useTakeawaysViewerLazyQuery>;
export type TakeawaysViewerSuspenseQueryHookResult = ReturnType<typeof useTakeawaysViewerSuspenseQuery>;
export type TakeawaysViewerQueryResult = Apollo.QueryResult<TakeawaysViewerQuery, TakeawaysViewerQueryVariables>;
export const GetWatchedVideosCountDocument = gql`
    query GetWatchedVideosCount {
  viewer {
    id
    primaryEmailAddress
    watchedVideos {
      totalCount
    }
  }
}
    `;

/**
 * __useGetWatchedVideosCountQuery__
 *
 * To run a query within a React component, call `useGetWatchedVideosCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWatchedVideosCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWatchedVideosCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWatchedVideosCountQuery(baseOptions?: Apollo.QueryHookOptions<GetWatchedVideosCountQuery, GetWatchedVideosCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWatchedVideosCountQuery, GetWatchedVideosCountQueryVariables>(GetWatchedVideosCountDocument, options);
      }
export function useGetWatchedVideosCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWatchedVideosCountQuery, GetWatchedVideosCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWatchedVideosCountQuery, GetWatchedVideosCountQueryVariables>(GetWatchedVideosCountDocument, options);
        }
export function useGetWatchedVideosCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWatchedVideosCountQuery, GetWatchedVideosCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWatchedVideosCountQuery, GetWatchedVideosCountQueryVariables>(GetWatchedVideosCountDocument, options);
        }
export type GetWatchedVideosCountQueryHookResult = ReturnType<typeof useGetWatchedVideosCountQuery>;
export type GetWatchedVideosCountLazyQueryHookResult = ReturnType<typeof useGetWatchedVideosCountLazyQuery>;
export type GetWatchedVideosCountSuspenseQueryHookResult = ReturnType<typeof useGetWatchedVideosCountSuspenseQuery>;
export type GetWatchedVideosCountQueryResult = Apollo.QueryResult<GetWatchedVideosCountQuery, GetWatchedVideosCountQueryVariables>;